module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Prelims-head"
  }, [_vm._v("About the Authors")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Gerald Stribling travelled far and wide in his professional working life, appreciating good food prepared in various ways. After retiring, he decided to look a little more closely at cabbages and the cruciferous vegetables. As he dug into the subject, he realised the field was very large and would keep him out of trouble for some time. ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Usanna Stribling has always had a love affair with food. She feels she was lucky enough to raise her family on a smallholding, growing their own vegetables. Life has afforded her opportunities to travel and enrich her mind and palate along the way, a love which she continues to nourish by living in France. From offering her humble help as a five-year-old on her grandfather’s vegetable plot and now helping her father compiling this book, they’ve continued on their culinary adventures together.")]), _vm._v(" "), _c('p', {
    staticClass: "Subtitle-tp ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A layman’s handbook on Nutritive Leguminous vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-1"
  }, [_vm._v("Lady Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-2 ParaOverride-2"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "Title-tp-3"
  }, [_vm._v("Family")]), _vm._v(" "), _c('p', {
    staticClass: "Author-tp"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Gerald and Usanna Stribling")])]), _vm._v(" "), _c('p', {
    staticClass: "Author-tp"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Lady-bean.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Austin-Macauley-Publishers-logo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-name"
  }, [_vm._v("Copyright © Gerald and Usanna Stribling 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("The right of Gerald and Usanna Stribling to be identified as authors of this work has been asserted by the author in accordance with Sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("ISBN 9781398463431 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("ISBN 9781398463448 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("ISBN 9781398463455 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-space"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("Austin Macauley Publishers Ltd®")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright-text _idGenParaOverride-1"
  }, [_vm._v("E14 5AA")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-head"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main _idGenParaOverride-1"
  }, [_vm._v("All the images used are either taken by ourselves, have been added by the publishers from their stock library or were bought from 123RF ("), _c('span', {
    staticClass: "Hyperlink _idGenCharOverride-1"
  }, [_vm._v("https://fr.123rf.com")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 1\tIntroduction\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Why Beans and Peas?\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 2\tClassification and Description of Peas and Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.1 General Description of Leguminous\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.2 Leguminous Family\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.3 Classification of Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("General Description\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Leguminous Trees and Shrubs\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.4 Full Description of the Plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.1 Leaves\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.2 Roots and Nitrogen Fixation\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.3 Flowers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.4 Fruit\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.4.5 Grains\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Bean Seed Size\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("2.5 List of Species by Group\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.2 Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.4 Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.8 Peanuts and Groundnuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.9 Carob Tree Ceratonia siliqua\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.10 Tamarind Tamarindus indica\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.11. Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.12 Fenugreek Trigonella foenum-graecum\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.13 Liquorice Glycyrrhiza glabra\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.14 Rooibos Aspalathus linearis\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.15 False Acacia Robinia pseudoacacia\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.16 Mimosa Abacia dealbata\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("2.5.17 Animal Food and Fodder Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 3\tIntroduction to the History of Peas and Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.1\tPre-history of humans and plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.1 The Big Migration\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.2 Settlement and Domestication\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.3 Geographical Origin of the Leguminous Plants\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.4 The Result and Present Place of the Bean Family\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.1.5 Effects of Domestications\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.2 History of the Early Civilisations\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.1 Mesopotamia: the Fertile Crescent (About 9000 BC – 100 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.2 Egypt: The Nile Valley (6000 BC-300 AD)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.3 India (9000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Ganges Valley\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.4 East Asia China (8000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.5 Early Mexican Civilisation (8000 BC – 1521 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.6 Early Andean Civilisation (8000 BC – 1574 AD)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.7 The African Continent other than Egypt (4000 BC – 1000 AD)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.8 Australasia (40000 BC): Papua New Guinea, Australia, Vanuatu, New Caledonia, New Zealand\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.9 Europe (6000 BC – Present)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.2.10 The Greek Empire 700 BC – 300 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.3 Evolution of Agriculture and Plants Since A.D.0 1\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.1 Roman Civilisation\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.2 The Arab World 700-1200 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.3 Medieval Europe\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.4 Christopher Columbus and the Discovery of the Americas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.5 Colonisation and the Slave Trade\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.6 Asia 0-2000 AD\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.3.7 European and American and Modern ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Times\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.4 Historical Dates of the Leguminous Plants in Early Civilisations\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Knowledge of Food Plants at the End of Early Civilisations\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("3.5 List of Plants and their Geographical Origin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.1 Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.5 Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.6 Lentils\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.8 Peanuts and Groundnuts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.9 Carob Tree (St John bread, Locust bean Ceratonia siliqua)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.10 Tamarind (Tamarindus indica)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.11 Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.12 Fenugreek (Trigonella foenum-graecum)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.13 Liquorice (Glycyrrhiza glabra)\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.14 Rooibos (Aspalathus linearis)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.15 False Acacia\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("3.5.16 Mimosa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 4\tLeguminous Plants and Folklore...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.1 Expressions\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.2 Fairy Tales and Legends\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.1 Jack and the Bean Stalk\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.2 The Beans of Soissons\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.3 Lyrics\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.2.4 Lyrics: Beans and Cornbread\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.3 Music\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.1 Beans, an American Rapper\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.2 Louis Armstrong’s Creole Beans and Rice\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.3 Red Beans & Rice Jazz Band\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.4 Beans on Toast\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.5 Les Haricot Rouges (The Red Beans)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.6 Black Beans and Jazz\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.3.7 Bread and Beans Line Dancing\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.4 Comic Strips and Films\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.1 Beano\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.2 Peanuts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.3 Mr Bean\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.4.4 Tintin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("4.5. Other Uses\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.1 Carat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.2 Michael Lotito (Monsieur Mangetout)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.3 Peashooter\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("4.5.4 Blowgun or Blowpipe\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 5\tCooking and Recipe Codes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.1 Codes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.2 Notes on the Use of Leguminous Plants and their Cooking\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.3 Use of Leguminous Derived Products\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.4 Sprouting Grains of Leguminous Plants\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.5 New Nutritional Values, Diet and Health\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("5.1.6 Evolution of the Use of Leguminous Grains and Gluten-Free Food\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Chapter 6\tIndex for Recipes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.1 Soup and Consommé Recipes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.1 Pea and Mangetout Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.1 Green Pea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.2 Green Pea and Shrimp Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.3 Split Pea Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.4 Mangetout Soup with Garlic Bread\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.1.5 Pease Pudding\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Making Pease Pudding\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.2 Broad Bean Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.1 Broad Bean Soup with Harissa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.2 Dry Broad Beans with Lamb Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.3 Cream of Broad Bean Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.4 Broad Bean and Potato Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.5 Broad Bean and Courgette Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.6 Broad Beans with Red Peppers and Rice Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.7 Cream of Broad Bean Pod Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.2.8 Syrian Foul Soup with Dried Fava Beans (Broad Beans)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.3 Chickpea Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.1 North African Chickpea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.2 Chickpea Soap Served with Spare Ribs\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.3 Chickpea and Onion Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.4 Mexican Chickpea Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.3.5 Chickpea Soup for Good Thursday\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.4 Fresh Bean Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.1 Green Beans Fresh Dill Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.2 Fresh Shelled Beans Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.3 Fresh Flageolet Bean Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.4.4 Pesto Soup with Pesto Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.5 Dry Bean Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.1 White Bean and Red Pepper Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.2 Black Beans and Mushroom Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.3 Cream of White Bean and Boletus Soup\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.4 Mexican Chilli Bean Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.5. Japanese Napa Cabbage and Tofu Soup\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.5.6 Bok Choy and Shrimp Soy Milk Soup\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.6 Lentil Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.1 Red Lentil Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.2 Lentil Coconut Milk and Lemongrass Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.3 Egyptian Red Lentil Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.6.4. Lentils and Swiss Chard Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.7 Lupin Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.7.1 Sweet Lupin Pumpkin and Sweet Potato Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.8 Peanut Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.1 Equatorial Peanut Soup\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.2 Ghanaian Peanut Butter Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.3 West African Peanut Soup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.8.4 Indian Peanut Chaat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.10 Tamarind Soups\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.10.1 Fish Soup with Tamarind\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.1.12 Fenugreek Soups\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.1.12.1 Pumpkin Soup with Fenugreek and Alfalfa Sprouts\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.2 Salads, Starters, Snacks, Breads and Sauces Recipes\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.1 Green Pea Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.2 Mangetout Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.3 Green Pea and Bacon Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.4 Green Peas and Vegetable Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.5 Mangetout, Beetroot and Orange Salad\t.....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.6 Erbswurst German Green Pea Flour and Sausage Meat\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.7 Fresh Pasta with Green Pea Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.8 Arancini: Rice Balls Stuffed with Bolognese and Green Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.9 Grass Peas and Tomatoes on Drum Bread Toast\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.1.10 Green Pea and Chickpea Fritters\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.1 Young Broad Beans and Olive oil\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.2 Broad Bean Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.3 Broad Bean Dip\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.4 Grilled Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.5 Fried Dried Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.2.6 Stir-Fried Fresh Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.3 Chickpea\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.1 Socca, Farinata, Chickpea Pancake\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.2 Genoese Pesto Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.3 Chickpea Fries (Panisse)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.4 Chickpeas Polenta Fries\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.5 Chickpea and Chestnut Crackers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.6 Bread Rolls with Chickpea Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.7 Fresh Pasta with Chickpea Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.8 Chickpea Crackers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.3.9 Hummus (Chickpea Dip)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.4 Fresh Bean Salads and Starters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.1 Fresh Slender Green Beans and Basil Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.2 Fresh Yellow Bean, Red Peppers and Anchovy Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.3 Flat Green Bean and Feta Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.4 Salad of Fresh Cranberry Beans, Cockles and Mussels\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.5 Green Bean and Bacon Bundles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.4.6 Edamame Soybean Aperitif\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.5 Dry Bean Salads\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.1 White Bean and Green Pepper Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.2 Black Bean and Sweet Corn Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.3 Red Bean, Rice and Shrimp Salad\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.4 Sushi with Mung Bean Sprouts Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.5 Korean Style Mung Bean Sprouts Salad\t....")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.6 Salad of Coco Beans with Cockles and Mussels\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.7 Peppers Stuffed with Black Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.8 Tofu\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.9 Grilled Tofu and Vegetables\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.10 Soy Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.5.11 Coco Beans with Cod Paste (Brandade De Morue)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.6 Lentil Salads\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.1 Puy Lentil Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.2 Coral Lentils and Pepper Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.3 Beluga Lentil Basil Salad Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.4 Sprouted Lentil Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.5 Roast Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.6.6 Sprouted Green Lentil Burger\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.7 Lupin Salads and Starters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.1 Sweetening of Traditional Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.2 Lupin Beans as Aperitif\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.3 Lupin Houmous\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.4 Low Carb Pancake with Lupin and Plain Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.7.5 Low Carb Pizza with Sweet Lupin Flour\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.8 Peanut Salads and Aperitifs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.1 Roasted Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.2 Peanut Butter\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.3 Sugar-Coated Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.4 Potato and Beetroot Salad with Peanut Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.8.5 Indian Peanut Chaat Salad\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.2.16 Mimosa Aperitifs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.2.16.1 Mimosa Eggs\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3 Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1 Peas/Mangetout Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.1 Rice with Green Peas and Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.2 Gratin of Peas and Spinach with Brandade\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.3 Mangetout with Rice and Shrimps\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.4 Lamb Stew with Green Peas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.5 Greek-Style Peas and Potatoes with Chicory\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.6 Goat’s Meat Stew with Peas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.7 Chickpeas and Chorizo\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.1.8 Pork Fillet with Coco Beans and Mangetout\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.2 Broad Beans Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.1 Broad Bean Risotto\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.2 Gratin of Broad Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.3 Whole Broad Beans with Pork\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.2.4 Stir-Fried Broad Beans and Vegetables\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.3 Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.1 Lamb with Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.2 Andalusian Chickpeas with Spinach\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.3 La Cocido Spanish Chickpea Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.4 White Shark with Chickpeas\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.3.5 Chickpeas with Beef\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.4 Fresh Bean Main Dishes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.1 Coco Beans and Black Cabbage\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.2 Fresh Green Bean Gratin\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.4.3 Indian Cluster Beans and Potato Curry\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.5 Dried Bean\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.1 Brazilian Feijoada\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.2 Cassoulet\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.3 Garbure\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.4 Chilli Con Carne\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("Cooking in Louisiana\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.5 Dry White Beans and Sweet Corn\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.6 Creole Beans and Rice with Sausages\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.7 Oven Dish with Borlotti Beans and Chorizo\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.8 Savoy Beans with Diots\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.9 Baked Beans On Toast\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.10 Loubia White Beans with Beef and Calf’s Feet\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.11 Stir-Fried Tofu and Vegetables\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.12 Stir-Fried Chicken with Cellophane Noodles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.13 Stir-Fried Shrimps and Bean Sprouts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.14 Akra with Dry Black-eyed Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.15 Akra with Black-eyed Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.5.16 Cornbread and Beans\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.1 Lentils with Herb Sausages\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.2 Beef Sausages with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.3 Wild Duck with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.4 Lentils with Fresh Pasta\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.5 Rice with Lentils ‘Mujadara’\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.6.6 Confit of Duck with Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.3.8 Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.1 Beef with Peanuts and Noodles\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.2 West African Pork with Beans in Peanut Sauce\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.3 Fish with Dried Peppers Sichuan Pepper and Peanuts\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.4 Spicy Lamb and Peanut Sauté\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.5 Chard, Sweet Potato and Peanut Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.6 West African Chicken Peanut Stew\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.3.8.7 Mafe Senegalai with Two Meats\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4 Side Dishes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.4.1 Peas and Mangetout\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.1 Fresh Peas with Lean Gammon\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.2 Mushy Peas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.3 Pea Fritters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.4 Green Peas with Capers and Braised Chicory\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.5 Mangetout with Sesame\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.6 Mangetout Sautéd with Shallots\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.1.7 Mangetout with Carrots\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.4.2 Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.2.1 Plain Boiled Fresh Broad Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.2 Broad Beans and Tomatoes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.1 Chickpeas with Tomato and Harissa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.2 Chickpeas with Peppers\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.3 Chickpeas and Spinach\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.3.4 Galettes of Lentils and Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.4 Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.1 Boiled Fresh Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.2 Boiled Beans with Onions and Garlic\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.3 Beans and Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.4 Green Beans with Tomatoes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.4.5 Green Bean Relish\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.1 White Lima Beans Sauté with Coriander\t...")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.2 Kidney Beans with Peppers\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.3 Beans and Sauerkraut\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.4 Dry Black Beans with Potatoes and Bok Choy\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.5.5 Refried Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.6 Lentils\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.1 French Lentils with Pork Belly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.2 Black Beluga Lentils with Rice\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.6.3 Brown Lentils with Swiss Chard and Za’atar (Spices)\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.4.7 Lupins\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.1 Low Carb Spätzle\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.2 Low Carb Gnocchi with Herbs\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.4.7.3 Gluten-Free Gnocchi with Pesto\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5 Sweets, Desserts and Drinks\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_vm._v("6.5.3 Chickpeas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.1 Chickpea and Pistachio Biscuits\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.2 Fried Churros\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.3 Gluten-Free Canistrelli with Chestnut and Chickpea Flour Buns\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.3.4 Canistrelli with Chickpea Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.5 Dry Beans\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.1 Adzuki Bean Sweets\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.2 Korean Sweet Bean Paste Bread\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.3 Japanese Red Bean Paste Pancakes\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.4 Making Soy Milk\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.5. Chocolate Cake with Soy Milk\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.6 Soy Yoghurt\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.5.7 Kudzu Japanese Starch Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("6.5.6 Lentils\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.6.1 Lentil and Chocolate Brownies\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.6.2 Lentil Granola Bars\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.7 Lupins\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.1 Low Carb Pancake with Lupin and Plain Flour\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.2 Lupin Spice Biscuits\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.3 Gluten-Free Lupin Pancakes\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.7.4 Lupin Carrot Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.9 Carob\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.9.1 Carob Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.9.2 Carob Sauce\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.10 Tamarind\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.10.1 Tamarind Sweet Balls\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.10.2 Tamarind Date Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_vm._v("6.5.11 Mesquite\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.1 Mesquite Bean Jelly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.2 Mesquite Syrup\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.11.3 Mesquite Tortillas\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.13 Liquorice\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.1 Liquorice Root Extract\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.2 Black Liquorice Caramels\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.13.3 Liquorice Cake\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.14  Rooibos\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.14.1 Rooibos beverage\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.15 False Acacia\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.15.1 Acacia Flower Fritters\t")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_vm._v("6.5.16 Mimosa\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.16.1 Mimosa and Lemon Jelly\t ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("6.5.16.2 Crystallised Mimosa Flowers\t")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Chapter 1\tIntroduction")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a sequel to our book "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Cabbage and Family")]), _vm._v(", a review of the crucifer family of edible and useful plants including cabbage, cauliflower, kale, mustards and many other edible plants. (The crucifer plants are plants in which the flower is in the form of a Maltese cross.) That book was a general description of the edible crucifer and their origin history and how they are used, ending with a series of recipes to illustrate the great diversity of their use. We enjoyed the research and discovery. The book was published by Austin Macauley Publishers in 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-02.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This book inspired us into writing another book. Again, great discoveries with a lot of historical interest.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The object of the present book, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lady Bean and Family")]), _vm._v(", is to examine the edible and useful leguminous plants. The leguminous plants are a vast family with many species, from small plants to vines, rooted plants shrubs and trees. The family comprises thousands of species. The edible leguminous plants are eaten all over the world in one form or another. Peas, broad beans and beans are one of four principal foods and also have many uses. Peanuts are found everywhere as an aperitif accompaniment or in food. Lentils are widespread. Certain beans are used for making cakes in Asia. Rooibos, a South African shrub, is used as a drink and used worldwide. The fermented products are used all over the world; there are few houses worldwide where there is not a bottle of soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous plants are of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family (peas and beans family). Most of the edible leguminous plants belong to the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae")]), _vm._v(" sub-family comes from the French word for ‘butterfly’, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("papillon")]), _vm._v(", as the leaved flower that resembles a butterfly in flight. Most of the leguminous plants generally have a capacity to fix atmospheric nitrogen and therefore fertilises the soil. Peas and beans are also gluten-free, which these days has become very important.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-04.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The book begins with a description of the edible and useful leguminous plants, their positions in the plant family, a general description of them as they grow from small herbaceous plants to vines, roots shrubs and trees. It shows the family tree of the plants concerned and a more detailed description of each. Equally, there is a description of the derived products. The family tree of the plants is followed by an illustration of the leaves, the flowers, pods and fruit. This is a complete detailed description of each member with a number of illustrations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next section is about the history and the origin of these leguminous plants. This has been somewhat difficult to research due to the fact that early evidence is rare and often disputed in rival academic schools. There are things that are easy to understand like the fact that the North American beans were not known before the voyages of Christopher Columbus. However, what is strange is that Asian and Chinese beans were not known through the silk road and all the exchanges with the east. Perhaps this was in the same way that beans never came to Europe from West Africa, although coastal trading between West Africa and Europe was active well before Columbus.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next section we are concerned by discusses the legends and stories about the leguminous plants, like Jack and the Bean Stalk and other stories, songs, musicians and groups, comic strips and films, and others. (We had fun writing this!)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The final section is dedicated to the use of leguminous plants in cooking and in the preparation of derived products. We start by an explication of the set-out and coding of the different recipes. This is followed by a general idea about the culinary use of leguminous plants and derived products. This is completed with a section on the sprouting of the same plants. Next comes a description and nutritive values of these plants and their dietary use. The principal part of this section is the different recipes for the use of leguminous plants; this is divided into five groups. This is followed by some mouth-watering recipes, showing the diversity with which you can cook with them from recipes worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Why Beans and Peas?")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Gerald:) The following words give the reasons for my interest in beans that seem to have been with me all my life. I spent my youth in England, and beans were very important during and after the war. Baked beans with sausages and beans on toast: a still important, cheap and nutritious food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After working in Africa, my work took me to the South of France where beans are very important all along the Mediterranean coast. Pistou soup is a soup that is found from Genoa Italy to Marseille in France. This soup is based on the herb ‘pistou’ (basil in English) and is made basically from cocoa beans and basil. from Genoa to Nice it tends to be a light soup with onion, garlic and carrot with some pasta; around Marseille, it appears as a heavier soup with meat and pasta. Another bean stew, cassoulet, is a famous dish from Toulouse.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Latterly my work took me to the Americas, where beans originated from. Today, from the southern states of the United States to Peru and Brazil, beans and rice are the basic food staples.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At about the same time, part of my work was in Asia. Here I found very different varieties of beans. From India to Japan and from Southern Asia to Indonesia, there was a completely different world of beans: sprouted, cooked, caramelized, and fermented.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-break"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In this book, we have tried to illustrate these different varieties of beans and their vast differences, from soybeans to peanuts. Beans and peas are very popular today, as they are gluten-free.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic--L",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-08.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Usanna:) As far back as I can remember, I have had a love affair with food. I was lucky enough to raise my family on a smallholding where we grew vegetables, fruits and kept beehives. Our livestock included sheep, goats, geese, chickens, ducks, a turkey and a pig a real menagerie. We grew a variety of vegetables, from the mainstream to the exotic. We would often have gluts of something or other which helped to force my hand in creating new recipes that would help stretch our yields to feed a family and avoid ‘marrow fatigue’, the inevitable feeling of eating the same thing night after night. Life has afforded me opportunities to travel and enrich my mind and palate along the way, introducing me to spices, techniques and ingredients the world over. Travel has certainly helped keep my love of food, good ingredients and experimenting with new tastes alive. A love that I continue to nourish by living in France. Eating delicious food in other people’s homes and my own has been a lifelong pursuit. From Finnish venison or Spanish tapas to North African tagine to stir the senses, and still a whole world’s worth to discover!")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-1-09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("From offering my humble help as a five-year-old on my grandfather’s vegetable plot and now helping my father compile this book, we’ve continued on our culinary adventures together. After writing "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Cabbage")]), _vm._v(", which we really enjoyed, we then started to look for beans and peas. This offers an even wider variety and is so diverse and interesting. I hope you enjoy the book as much as we have written it.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Chapter 2\tClassification and Description of Peas and Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("2.1 General Description of Leguminous")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" or "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionoideae")]), _vm._v(", normally called ‘leguminous’ plants, are a family of flowering plants that grow as trees, shrubs, vines, perennial or annual herbaceous plants. They are very widely spread and grow all over the world in many climates, from cold to tropical rain forests and the arid forests of America and Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The name "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionoideae")]), _vm._v(" comes from the flowers, whose five drooping, irregular petals resemble a butterfly in flight.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most leguminous plants have the capacity to fix free nitrogen as a usable form for plant nutrition, thus fertilising the soil with nitrogen. Leguminous plants are very important in the world economy, particularly in the following fields: vegetables for human consumption, e.g. peas, broad beans, chickpeas, beans, lentils, lupins and peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These are other uses for leguminous plants.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("As spices: fenugreek, liquorice and tamarind.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For wood (and food): mesquite, carob, and acacia.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For animal fodder,:clover, lucerne, vetch and soybeans.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For green manure: peas.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For their flowers: orchids, mimosa and glycine.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("For derived products: soy and adzuki beans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants were amongst the first used by early man and provided food in the earliest times: peas, broad beans, chickpeas and lentils in Europe and beans and others in the Americas and Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous family is large and consists of some 19,000 known and identified species.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("2.2 Leguminous Family")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flower")])])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peas and Mangetout")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Broad Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chickpeas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fresh Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Dry Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lentils")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lupins")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Carob")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Tamarind")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Liquorice")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Rooibos")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("False Acacia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("2.3 Classification of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("General Description")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous,"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Leguminosae")]), _vm._v(" (also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" or "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae,")]), _vm._v(" sometimes called the pea, bean family) are a large family of plants, herbaceous, vines, shrubs and trees growing all over the world in virtually all climates and at all altitudes. They are characterized by generally having five-drooping-petal flowers that produce pods containing grains, which have the capacity for atmospheric nitrogen fixation. They can be annual or perennial and are very important economically as they are used as animal and human food, for floral decoration, industrially for natural gums, for dyeing and for the pharmaceutical industry for certain active chemical and other raw materials. The position of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family in the botanic system is shown below.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following chart shows the position of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae ")]), _vm._v("or leguminous"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }), _vm._v("plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-03.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Leguminous Trees and Shrubs")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-05.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tTamarind\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-07.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFalse Acacia\tMimosa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-09.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("2.4 Full Description of the Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("2.4.1 Leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leaves are alternated and compound, with multiple leaves: often three but sometimes more. The leaves are often heliotrope and follow the sun to improve the plant’s metabolism.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following illustrations show some of the different forms:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-16",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-10.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-17",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPea\tPea alpha type")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-18",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-12.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-19",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tBroad bean\tChickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-20",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-14.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-21",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tBean\tLentil")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-22",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-16.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-23",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLupin\tPeanut")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_vm._v("\t`"), _c('img', {
    staticClass: "_idGenObjectAttribute-24",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-18.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-25",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLiquorice\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-26",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-20.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-27",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tMesquite\tTamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-28",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-22.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-29",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFenugreek\tRooibos")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("2.4.2 Roots and Nitrogen Fixation")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Root with nodules")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The majority of the leguminous plants live with symbiotic bacteria called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Rhizobia")]), _vm._v(". These bacteria live in the root nodules of the plant and are capable of fixing atmospheric nitrogen, transforming it into molecular ammonia. This free ammonia radical is transferred in an ammonium salt, which is absorbable by the roots of other plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This ability to fix nitrogen allows the plant to be independent for nitrogen nutrition to supply and to feed surrounding plants and equally plant for the next culture. The majority of edible leguminous plants have a simple taproot and nodules. There are exceptions, e.g. peanuts, where the fruit grows underground; liquorice, where it’s the root that is harvested to give the extract; yam beans and kudzu, whose roots grow underground.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The root is a taproot with nodules as illustrated:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-30",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-25.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-31",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanuts\tLiquorice")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_vm._v("\t`"), _c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-27.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-33",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tYam bean root\tKudzu root")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("2.4.3 Flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The flowers are five leaved and drooping. Typically:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-34",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-29.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-35",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-30.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-31.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Broad bean flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-37",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-32.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-38",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-33.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Bean flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-34.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-39",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-35.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tChickpea flowers\tLentil flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-40",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-36.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-41",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLupin flowers\tRooibos flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-42",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-38.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-43",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-39.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLucerne flowers\tSoy flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-44",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-40.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-45",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanut flowers\tTamarind flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-46",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-42.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-47",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFalse acacia flowers\tMimosa flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("2.4.4 Fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit of the leguminous plant is a pod, which is composed of two halves. These are generally green and are joined by a filament that can be separated when the plant reaches a certain maturity. The pod contains grains, which will develop as the pod grows. The pod will develop progressively and change colour. We harvest some plants before maturity and the rest when they are at full maturity and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are a number of ways that fruits can be eaten.")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Before maturity of the grains, as for mangetout and broad beans. This can be eaten cooked or raw.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("At maturity of the grains, as for green peas, broad beans and chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("At full maturity when the pod has dried, as for most leguminous plants.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two exceptions: coco beans that are harvested at the beginning of pod drying; and flageolet beans that are harvested when the leaves start to turn yellow. Here, the plants are pulled from the ground and the beans are separated while they still contain about 45% of water.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other cases are liquorice, tamarind, yam beans and rooibos.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-48",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-44.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tIndian peas\tMangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-49",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-46.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-50",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPigeon peas\tBroad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-51",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-48.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-52",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tChickpea pod\tChickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-53",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-50.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-54",
    attrs: {
      "alt": "C:\\Users\\Mr et Mme HOFER\\Documents\\Peas & Beans Book 20.3.2018\\Pictures Beans & Peas\\Dads photos 4th December 2017\\PIC_0022.JPG",
      "src": "image/Stribling-2-51.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Dwarf beans              Runner beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-55",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-52.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Flat bean")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-56",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-53.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-57",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tCoco beans\tOne-eyed beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-58",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-55.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-59",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-56.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tLentils\tLupin pod")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-60",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-57.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-61",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-58.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeanuts\tCarob")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-62",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-59.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-63",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tMesquite\tTamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-64",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-61.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("2.4.5 Grains")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The grains vary in form, from kidney shape to round or oval and in the form of lens for lentils.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Typically:")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-65",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-62.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-66",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-63.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPeas: green or yellow\tBroad beans: light green")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-67",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-64.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Chickpeas: beige or black")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-68",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-65.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lentils: many colours")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-69",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-66.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" Lupins: yellow")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Bean Seed Size")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("It is very difficult to give a general sense of the size of the different beans; the following are the approximate sizes of some typical beans.")]), _vm._v(" "), _c('table', {
    staticClass: "No-Table-Style _idGenTablePara-1",
    attrs: {
      "id": "table001"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soisson Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16-18 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dark Red Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17-20 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("White Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16-18 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cranberry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15-17 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pink Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14-16 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8-12 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soy Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6-7 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Adzuki Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5-6 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mung Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4-5 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Wild Mexican Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4 mm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Wild Andean Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3 mm")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("2.5 List of Species by Group")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("2.5.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-70",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-68.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea is an annual or evergreen herbaceous plant of the leguminous family, mainly cultivated in the Middle East, Europe, India and East Asia from Neolithic times and also in East Africa, probably more recently.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The original domestication of the pea is difficult to determine and depends on the type. Each type will be examined in turn.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant produces a pod that contains generally green spherical grains, which will dry. In early times, the plants were grown or harvested for the dry seeds, which were cooked. The harvesting of green peas is a fairly recent event, probably dating from the end of the Middle Ages.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We have the following types of peas:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table002"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Garden or Cultivated Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dried Peas and Animal Food")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Marrowfat Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Snow Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. saccharatum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Snap Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. macrocarpon")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Indian Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lathyrus sativus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kudzu Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pueraria montana")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pigeon Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cajanus cajan")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.1 Garden or Cultivated Green Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-71",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-72.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The green pea is an annual plant growing in cool climates and is the most cultivated pea. Originating in the Fertile Crescent, it is now cultivated worldwide and is grown anywhere from simple gardens to large-scale industrial farming to supply pea-processing factories.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The mature pea plant is about 1-2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m in height. They are grown generally on support and produce pods about 10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing about 8-9 peas. These are generally green but sometimes yellow, each weighing from 0.1 to 3.6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("g.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today these peas are consumed fresh, canned or frozen and also dried for household use. Freeze-dried peas are also available for domestic consumption or lyophilize for industrial use as a food additive. However, this is relatively recent, as before the end of the Middle Ages peas were always consumed cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.2 Dried Peas and Animal Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pea plants have been developed by selection to produce peas that have high protein content and are used mainly for animal food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas are generally of the alpha type. The normal form of pea leaves have three or four pairs of opposed leaves and two or three vine-type filaments. In the alpha type there are only one or two pairs of opposed leaves. It is resistant to falling in rain or wind and is easier to harvest with a combined harvester.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.3 Mangetout Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mangetout peas are the same species as the normal pea but are a variety. The characteristic of this pea, as its French name suggests, is that the whole pod is edible. This pea was developed by selective cultivation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other members of the mangetout family are snap peas and snow peas, both of which are edible.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Snap peas are also called sugar peas which are cultivated in the same way as garden peas. Their scientific name is "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. macrocarpon")]), _vm._v(". They are of Mediterranean origin and were largely cultivated in Europe, particularly in England in the nineteenth century. They can be grown in open fields in winter and spring and are eaten like mangetout.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Snow peas, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pisum sativum var. saccharatum")]), _vm._v(", are thought to be a cross between snap peas and a Chinese snow pea or mutant. In cooler climates, snow peas are grown in the field in winter and spring. The snow pea can be eaten like mangetout. In China, it is grown to maturity to produce seeds, which are sprouted as food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.4 Indian Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This pea is also known as grass pea. It has blue flowers. It is widely grown in Asia and East Africa and is very suited to poor soil and drought conditions. It is used both for human and animal consumption. In many countries, it is considered as a safeguard against famine and drought. It grows at temperatures of 5°C to 25°C and will support floods and drought. The origin of this pea is obscure but is probably India or the Eastern Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is somewhat different to the normal pea in that the pea when shelled is green and round but on drying it has a yellow colour and a slightly square form. It is generally used dry. It was widely cultivated in Southern Europe for hundreds of years, but today has generally disappeared, but still present in parts of Italy and Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Italy these peas are used in the Florence area. In the South of Italy, there is a typical popular soup made from grass peas and served on bread made from durum wheat in Bari.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Spain, in the region of La Mancha, the popular dish, ‘Gachas Manchego’, is made from pork and grass pea flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dried peas should be soaked and boiled before use. The Indian pea contains small quantities of neurotoxins which do not cause problems in normal usage; however, it has been noted that there can be problems if eaten too often. This is the staple diet in much of India.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.5 Kudzu Peas (Japanese Arrowroot)")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-73.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Root with nodules")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very strange pea. It is a quick-growing ‘everlasting vine’ native to East Asia and Japan. The fruit is a hairy pod containing peas, and the plant has a large taproot. The whole of the plant is edible but is not often used for human consumption. The root is very rich in starch and copper and when dried produces Japanese arrowroot, which is the main ingredient for starch cakes, an important ingredient in desserts in Eastern Asia. The whole plant can be used as food for livestock, particularly for goats on poor land.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both grains and roots of the plant have an important place in traditional Chinese medicine as they contain many isoflavones. The extracts from Kudzu are used for the treatment of tobacco and alcohol dependence. They are present today in homoeopathic treatments worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is very vigorous and if allowed will climb shrubs and trees and smother them, causing them to die.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The long-dried stems of the kudzu pea are used in wickerwork for making mats and baskets.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Kudzu pea was introduced into the United States in the 1800s as a decorative plant, as it is very pretty. Later, it was used as a soil improvement crop and as an anti-soil erosion plant and operated well in these functions. However, if not controlled it is very invasive. The control of the plant is difficult as it reproduces by both seeds and runner roots. Since the seeds can stay inert for many years, it is necessary to destroy the root crown. Apart from using unacceptable herbicides, it is a long and difficult process to decontaminate the soil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.1.6 Pigeon Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-74.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pigeon peas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This pea was first domesticated in the South of India, first grown in about 1500 BC. The plant is a tropical shrub, either annual or perennial, and grows in deciduous woodlands. It can be from 1 to 4 metres  and has yellow flowers. Its pods generally contain four to five green to yellow or brown peas, which are speckled and slightly oval. The plant moved to Southern Asia and to East Africa and from there to West Africa. It was found by early European explorers and called the Gungo bean. Later on, it moved to the Americas with the slave trade.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea can in some cases last from three up to five years; however, the yield drops after the second year. For pea production, annual culture is better.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pea grain is very rich in proteins and eaten with a cereal makes for a very rich diet. Today it is grown worldwide and is particularly popular in the Caribbean Islands and in Central America, where it is used in lots of traditional dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The pigeon pea can be sprouted before cooking. This has the advantage of making the cooked bean more digestible.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("2.5.2 Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-75.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Broad beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Broad beans are an annual plant of the leguminous family that can grow from 0.5 to 2.0 metres. The plant is erect and self-standing and will produce white flowers with black spots that after pollination by insects will give a pod with grains. These European broad beans are of the genus"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v(" Vicia")]), _vm._v(" of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae")]), _vm._v(" family.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two main types of European Broad Bean:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table003"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common or Garden Broad Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vicia faba")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Horse or Field Broad Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vicia faba")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.2.1 Common Broad Beans or Garden Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the classic broad bean used in Europe for general consumption. The plant is generally about 60 cm high and has a heavy central stem with a square section. It will give as fruit a pod, which will develop until the grains are between 20 and 25 mm. At maturity, the pod, previously green, thick and slightly hairy, will dry and become almost black.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For consumption, the harvest will usually be a week before green maturity. The beans are harvested when the pod is still green and the grains have not started to harden. The beans are harvested manually and the grain is separated from the po. The grains are generally boiled to eat, either with the skin or without.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In countries around the Mediterranean, the pods are harvested well before maturity and after removal from the pod are eaten raw or with salt or olive oil. In some parts of Southern Spain, the pods are harvested even earlier and cooked with the pods.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.2.2 Horse or Field Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-76.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer090"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Horse beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This broad bean is very similar to the common broad bean and is cultivated for both human and animal consumption. The grain is smaller and darker and has a stronger flavour than the common broad bean. It is, however, referred to in some countries as the ‘normal’ broad bean. For example, in Egypt, this bean is preferred to make bean dips like hummus and falafel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are two other beans that are similar to the European broad bean. They are the Jack beans (called the Brazilian broad bean) and the sword beans. These two beans belong to the genus "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Canavalia")]), _vm._v(" of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Fabaceae ")]), _vm._v("family. They are from a group of some 50 plants of climbing vines, whose origin is in the Hawaiian Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("2.5.3 Chickpeas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-77.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Beige and black chickpeas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpea is an annual leguminous plant that grows around the Mediterranean as well as in Asian countries. The plant grows to 50-70 cm. It has many branches and grows like a bush. The branches are covered with feathery leaves, which end in small pods, each containing two or three peas. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are four types of chickpeas.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table004"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Desi Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Bombay Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kabuli")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cicer arietinum")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.1 Desi Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea has a dark coat and a rough surface. It grows mainly in India and surrounding countries. These peas have much higher fibre content than other chickpeas, and they are lower in sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.2 Bombay Chickpeas, Desi Dahl")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea is very similar to the Desi chickpea but is darker and smaller.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.3 Kabuli")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the conventional chickpea used in most parts of Europe. It is light in colour and about 10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("mm in diameter. It is called Kabuli as it is believed that it originates from Afghanistan.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.3.4 Black Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chickpea from South-Eastern Italy is totally black-skinned and slightly larger than the Kabuli type. It is called ‘"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("ceci nigra")]), _vm._v("’ in Italian and is popular all over southern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("2.5.4 Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans are from the common bean family ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")]), _vm._v(") and have pods that are harvested well before maturity, often before the beginning of seed formation. However, in some cases the seed is formed and more developed, as with kidney beans, when the grain is formed but not mature. In other cases, the grains are formed but the pods not quite dry, as with flageolet or coco beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All beans derived from the original wild bean were of the vine or climbing type; the bush bean is a fairly modern development, produced by selective breeding. The vine type of bean flowers from the bottom up and is harvested progressively. This progressive harvest is convenient in a small garden or market garden, while the object of the development of the bush bean was to have a plant that would be easier to grow, where all the pods matured at the same time, allowing modern methods of harvesting to be carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans as food are relatively recent; up to the end of the 1600s, beans were only used dried and after soaking and cooking. At this time, it was found in the south of Italy that the immature bean could be cooked and eaten. After this, the cooking of green beans progressed, and it was Catherine de’ Medici who introduced the green beans to the royal French court.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1872, a French farmer, G. Chevrier, found that when an immature green bean is fully formed but not dry, it could be harvested: you harvest the bean pods, then shell them, and the resulting beans can be cooked. Thus the flageolet was born.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh beans can be a bush or climbing type of plant and the colour can vary from yellow to green or violet. There are so many different sorts of beans; some of them you eat as a whole bean and others you have to pod them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The harvest is generally carried out by hand for both bush and climbing types; however, in the case of intensive production for conserves, the harvest is generally mechanical.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Generally, the growing time averages for fresh beans is about 50 to 60 days for the bush type and longer for the climbing varieties.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Types of fresh bush beans:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("A. Fresh bush beans are found in three principal colours:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Purple to black")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("They are also found in a number of different forms.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Round and short")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tall, long and short")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Broad")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In most cases, the beans will be from 16 to 24"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Climbing beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Climbing beans are of two types: short, growing to about 1"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metre high; and the general run of the mill, growing to about 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metres. In the two cases, you find the same type of variations in colour and size as in the bush type. The length of the pods will vary from about 20"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm to about 25"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many cultivars of beans depending on the climate and tastes in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most of the fresh beans belong to the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")]), _vm._v(" family. One exception is the asparagus bean, "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata")]), _vm._v(", also known as the yard-long. This is a herbaceous plant of the leguminous family, which seems to have its origins in semi-tropical Africa and is now grown in semi-tropical areas all over the world. This climbing plant, which can grow to 3-4 metres high, produces pods of up to 1"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("metre in length. The pods are edible and have a taste between beans and asparagus. The seeds are green and round and are edible when fresh.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Certain cultivars of the plant can be cultivated in a temperate climate with a warm southern exposure.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today the following fresh beans are widely available:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table005"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green, yellow or black.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need ends trimming before cooking.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Diameter: 6 - 10 mm"), _c('br'), _vm._v("Length: 100 - 115 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Flat Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Generally green.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Needs trimming and string removed.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Thickness: 3 - 4 mm"), _c('br'), _vm._v("Width: 10 - 15 mm"), _c('br'), _vm._v("Length: 20 -30 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Kidney Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need to be prepared the same as flat beans.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Thickness: 5 - 8 mm"), _c('br'), _vm._v("Width: 10 - 15 mm"), _c('br'), _vm._v("Length: 20 - 25 cm")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Flageolet Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Need to be podded.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Coco Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Generally white or striped with red.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("When pods dry out they go brownish and crinkled.")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yard Long Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these beans are available fresh most of the year-round nowadays or either deep-frozen or canned.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("2.5.5 Dry"), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Note: Peanuts and groundnuts are treated later.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The bean is a very old vegetable but only known in Europe after the return of Columbus from his first voyage to the Americas. The bean is typically an annual herbaceous plant of the leguminous family. It is generally a vine and climbs on any support available. It produces longish pods which contain grains that we call beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("However, there were other bean-cultivating areas: the Indus Valley, East Asia, Papua New Guinea and the Pacific isles, and West Africa. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will deal with each case.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The American Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("There are two basic origins of beans in the Americas, Meso America and the Andin highlands part of South America, the beans from this area have the genus name of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When Columbus arrived in the Caribbean. Island, he found five varieties of beans being cultivated by the Pre-Columbian population.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Pre-Columbian Culture of Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("When Columbus and other explorers came to the New World, they found a new way of cultivating crops.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The culture was often carried by a number of tribes working together.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the case of beans, a field would be sown with patches of maize of about six plants and when the maize grew to a certain height, they would sow the beans around the maize. The bean as they grew would climb the maize and develop.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Around the bean plantation, they would sow squash, the beans by their nitrogen fixation would feed the maize and squash, the beans being heliotrope would follow the sun and provide shade for the squash. This type of culture was successful and even protected the crops from wild animals. The method is still used in certain regions is called the culture of The Three Sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The following are the varieties found in the Americas:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table006"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tepary Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus acutifolius")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Runner Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus coccineus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lima Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus lunatus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Trailing Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Strophostyles umbellata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yam Long Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Jicama")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus erosus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Goitenyo")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus tuberosus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Ahipa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pachyrhizus ahipa")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.1 Tepary Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is an annual plant of the leguminous family, it is a drought-resistant species of the "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus")]), _vm._v(" genus. It is native to the desert regions of South Western United States and Northern Mexico. It was cultivated by Amerindians in pre-Columbian times in river beds and valleys after the spring floods. It was harvested 60-129 days after sowing. The plant can grow to 3-4"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, has three slightly pointed leaflets, has a white flower and gives a pod with 2-7 grains. The plant has been cultivated in northern Mexico since 5000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.2 Runner Beans (scarlet runner beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is native to the mountains of Central America and Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is an annual plant of the leguminous family, a vine reaching 3 meters in height, the three-leaved leaf is pointed, giving generally red flower that produces a knife-shaped pod containing coloured beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The bean is grown both as food and for decoration, as food the green pods are edible young and the dry beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is cultivated worldwide and is used in many kitchens.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.3 Lima Beans (butter beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Lima bean is native to the Andes and Mesoamerica, it would appear that two different developments took place, the first in the Andes in about 2000 BC giving a large white bean of the Lima type, and a second in Mesoamerica in about 800 AC giving a smaller bean kidney shape.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.4 Common Beans (string beans, field beans, flageolet beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is an annual plant of the leguminous family and has a lot of diversity in its forms. It is native to the Americas and was domesticated separately in Mesoamerica and the Andes, the two distinct types exist today. The common bean is with maize and squash, the third member of the ‘Three Sisters’ famous base of North American agriculture.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The common bean started as a vine growing to about 2-3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, cultivars of the bush type have been developed growing to about 60"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. All varieties have green or purple leaves which are divided into three oval leaflets. The flowers are white, pink, yellow or purple and give pods containing 4-6 beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The common bean is cultivated all over the world and is the most important bean producer.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.5 Trailing Beans (pink fuzzy beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a bean of the vine type belonging to the leguminous family it is native to North America, Eastern Canada and Mexico. It has a fuzzy stem that will grow up to 3 meters long, has a leaf with three leaflets, the pea light purple flowers grow on the leaf stalks and give fuzzy pods containing black hairy beans. The plant grows as a weed in abandoned or worked land and seashores. It is not cultivated but was used by certain Native American Indians as medicine and food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.6 Yam Long Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a rather surprising member of the legume family, as it has swollen taproot that is often edible. The genus is small with five or six species.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.7 Jicama")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-79.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Jicama")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as Mexican yam bean or Mexican turnip, this is cultivated for its large taproot. The plant is a vine that can grow to a height of 4-5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m given support, the root can attain some 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m and weigh up to 2"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("kg. The vine gives white or blue flowers that give pods similar to the Lima bean. The root is edible either raw or cooked, the rest of the plant is poisonous, and the seeds at maturity contain a chemical that can be used as a pesticide or insecticide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its origin is Mexico and Central America, it was taken to the Philippines by the Spanish and has spread through Asia where it is popular. It is also very popular in West Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.8 Goitenyo")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Goitenyo, the Amazonian yam bean, is an annual vine of the leguminous family. It has a thick and hairy stem with a ligneous base, giving white to lilac flowers which give pods 10-20"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing beans that are edible and very rich in proteins. All part of the plant is edible, and the leaves can be fed to livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The vine is indigenous to the Amazonian tropical rain forests and is cultivated by native Indians who practice shifting horticulture.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.9 Ahipa")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-80.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Ahipa")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is known as the Andean yam bean, it’s not too similar to other beans, it’s a tall bean but is not a vine, and has longer tubercles than jicama. The plant originates in the Andes and can grow up to 2000 meters in altitude, it is commonly found in the Bolivian highlands and in the Argentinian provinces of Salta and Juyjuy. In the 1800’s it was introduced into the Caribbean Islands where it grows regularly as food eaten raw and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3 ParaOverride-1"
  }, [_vm._v("The Indus Valley Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table007"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Moth Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna aconitifolia")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Gram")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna mungo")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mung Bean")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna radiata")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.10 Moth Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is native to the Indus Valley and is an annual creeping herbaceous plant of the leguminous family. The plant when adult will cover the ground and attain 4"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm height and cover 1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m of ground, it gives yellow flowers that produce brown pods from about 5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long which give 4-9 beans. These beans exist in a variety of colour’s from yellow-green to black. The bean is very rich in proteins, but like most beans needs soaking and cooking to destroy the toxins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is drought-resistant and has been traditionally cultivated in the arid areas of India and Pakistan, today it is cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.11 Black Gram")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is also known as mungo bean when whole but once, dehusked and split it is white and is known as Ural Dal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This annual herbaceous plant of the leguminous family is an erect or semi-erect trailing hairy plant that will grow to 30-100"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm in height with a taproot with smooth nodules, the pods are cylindrical and up to 6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of black gram in India and it is today one of the most cultivated pulses in India and Pakistan and is now cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.12 Mung Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as the green gram, this bean is an annual herbaceous plant of the leguminous family, it is an erect, slightly trailing plant from 15 to 100"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high the stem is branched sometimes twining at the top. The leaves are alternate, trifoliate with elliptical or oval leaflets, 5-18"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 3-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm broad. The flowers are "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Papilionaceae")]), _vm._v(" yellow or green in colour giving pods that are cylindrical and pending, they contain 7-20 small elliptical grains variable in colour from green to brown or black.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Mung bean may have been domesticated in Persia, but has been present in India for very long-time archaeological evidence goes back more than 4000 years.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a ParaOverride-1"
  }, [_vm._v("The East Asian Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table008"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Adzuki Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna angularis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soy Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Glycine max")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.13 Adzuki Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is an annual or perennial herbaceous member of the leguminous family. It is a bushy erect or twining from 30 to 90"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high. There exist climbing varieties; the stem is green and slightly hairy. The root is of the taproot type and can penetrate to 40-50"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. The leaves are trifoliate, pinnate and arranged alternately along the stem on a long petiole. The leaflets are oval 5-10"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 5-8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm wide. The flowers are bright and give pods of 5-13"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long containing up to 14 beans, generally red but may vary.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of the adzuki bean in Japan, Korea and China, first domestication in its present size dates from about 2000 BC, today it is cultivated all over Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The main use of the bean is to produce the sweet bean paste, which is the base of desserts in cakes and sweet bread all over Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.14 Soy Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-81.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an annual herbaceous plant of the leguminous family that grows erect to a height of 1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m high with a thick stem covered with thick brown hairs. The leaves are alternate, trifoliate with oval leaves and short peduncle the basal ones simple. The flowers with white or white-violet 5-6"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long in clusters. The pods are up to 7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with one to four to form beans, the colour depending on the variety, yellow, black or green.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant grows wild in China and its origin is South-East Asia, there is evidence of its existence very early, it was domesticated in about 2800 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The soya bean genus is divided into two sub-genus.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2.5.5.14.1 Glycine")]), _vm._v(" soy that contains the wild varieties of soy including the ancestors of present-day cultivated soybeans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2.5.5.14.2 Glycine Edamame")]), _vm._v(" max that contains the present-day cultivated soybeans:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The yellow and black soybeans are now cultivated worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v(" The Edamame soybean, this bean is harvested immature and green and looks somewhat like a broad bean and has four grains per pod. This bean was first reported in Japan in the 1299’s and is popular in Japan as an aperitif, in a similar way as the European lupin in Spain and Portugal, but is easier to prepare as it only needs cooking and for this reason, it has spread all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The edamame soybean came to Europe in the 1700s and to America in the 1800s.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its development all over Asia was important basically as food and secondly for all the derived products that have been produced for centuries, bean sprouts, soy milk and all the fermented products, tofu, soy sauce, miso.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the United States, the use was to an extent the same as in Asia but it was found that the soybeans could be used as animal feed.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-72",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-82.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Harvesting beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The South East Asian and Pacific Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table009"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Rice Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna umbellata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Winged Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Psophocarpus tetragonolobus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.15 Rice Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The rice bean is a warm climate short-lived perennial plant of the leguminous family. It is normally cultivated as an annual and is generally 30-100")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm high, but has a variable habit and can attain 200")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm. In fact, in some areas, it is called the mountain climbing bean. The bean produces bright yellow flowers that give cylindrical pods 7.5-12.5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cms long that contains 6-10 beans 6-8")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mms long with a kidney shape, the beans are variable in colour going from yellow to brown and red.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The rice bean is used as food for humans and animals, the green parts are also edible and can be dried to make hay for livestock. The beans are somewhat difficult to cook because of the tough skin and should be dehusked before boiling or cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant originated in Indo China where it is wild, it was first domesticated in Thailand from where it spread all over Asia and the Indian Ocean. It is grown and is popular in Northern India and the Himalayas, also grown in Central America and Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.16 Winged Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is a perennial vine of the leguminous family, mainly grown as an annual. The Winged bean grows as a climbing vine up to 3-4")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("m high and gives pale blue flowers that in their turn pods typically 15-22")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm long with four wings with feathery edges. At maturity, the pods turn brown and split releasing the beans that are similar in colour and content to soybeans. The plant is of a variable type the leaves may have different forms and colours; the beans can vary in colour and shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The whole of the plant except the beans is edible raw or cooked, even the tuberous roots. The beans need to be boiled for 3 hours to remove toxins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is native to New Guinea but is now cultivated in tropical areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The African Beans")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table010"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cowpeas (Beans)")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Guar Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Cyamopsis tetragonoloba")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lablab Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lablab purpureus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Velvet Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mucuna pruriens")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yardlong Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata subsp. Sesquipedalis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cornille Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna unguiculata subsp. Unguiculata")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.17 Cowpeas (beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also known as the black-eyed bean or yardlong bean, is an annual herbaceous plant of the leguminous family originating in West Africa and probably Ghana. It is a warm-weather plant growing in many different conditions, it can be erect, droopy or even trailing depending on the method of culture and the climate. From its original home, it travelled to East Africa to Asia and was grown all over the old world and then to the Americas with the slave trade. Today it is one of the most cultivated beans in semi-tropical areas worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In certain countries, it is eaten at all stages of growth, typically in Tamil Nadu where it’s very popular it is eaten green with the leaves in soups often with tamarin and is also eaten dried and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.18 Guar Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This plant is also called the")]), _c('em', {
    staticClass: "italic CharOverride-5",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cluster bean, is an annual herbaceous member of the leguminous family. It grows to a height of 1-2")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("m gives rose flowers that give in their turn clusters of pods containing the guar bean seeds. The origin of the plant is not known, it is believed to have originated in Africa as they have similar species, the first domestication of the plant was in Indus and Pakistan the plant resist drought as is very useful in dryer areas.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The guar bean contains gum that is very important as a thickening agent for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today the gum is also used as a thickening agent for water in the fracturing oil shale and has become an important market for bean producers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cluster beans are considered as a very interesting rotation crop in drylands as nitrogen fixation, this technique is widely used in Rajasthan.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.19 Lablab Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a climbing herbaceous plant generally annual sometimes a short-lived perennial of the leguminous family. It is widely grown in the tropical areas of Africa, Asia and the Americas. It is used both for human and animal food. Its origins are obscure and thought to be Africa or Pakistan.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant produces violet flowers and is cultivated in certain areas as a decorative plant.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.20 Velvet Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is a tropical shrub vine of the leguminous family growing in Africa and Asia. It is a hairy plant whose vines can develop up to 15 meters and when young are very hairy and well known for itchiness by contact with the young vegetation. When the plant is older it loses its hairiness.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is mainly cultivated for animal food and forage, it can be dried, or used to make silage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In some parts of the world, the beans are eaten; typically, it is popular in the Indonesian islands of Java.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the important uses of the velvet bean is in agriculture as green, manure or a rotation plant as being leguminous, it will fix nitrogen that is available for the next crop.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The seeds are also used in medicine as they contain quantities of active ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In certain states in the USA like Florida, the plant is considered an invasive weed as it tends to escape from its cultivated areas and invade deserted land and shore fronts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.21 Yardlong Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer099"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-83.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Yardlong beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This annual climbing vine grows in the tropics and sub-tropics and gives pods that can reach 50-80")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm long and is excellent green for human consumption.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.22 Cornille Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean is thought to have originated in West Africa in the savannas of Burkina Faso, Ghana and as far as the Belgium Congo. It is a bean of average size and today grows all over the warmer parts of America and Asia, particularly in the Southern states of the USA and Brazil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The beans need to be cooked for about 10 minutes fresh and 40 minutes dry. They give a slightly sweet taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The Sub-Species and Cultivars")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table011"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Cranberry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. cranberry")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tarbes Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. tarbes")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soisson Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Phaseolus vulgaris var. soissons")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.23 Cranberry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean developed in Columbia from the common bean has a hazelnut colouring with black or purple splashes. This was brought to Italy; in the early 1889s, it was further developed to give slightly different beans called the Borlotti bean, both names are used today as many commercial cultivars exist. These beans are popular all over the Americas, in Italy, Portugal, Greece and Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.24 Tarbes Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean was developed in the South West of France a little time after the bean crossed the Pyrenees from Spain with seeds from the beans that Columbus brought to Spain. This bean followed a long development and was used to prepare the two, major dishes of the region Garbure and Cassoulet. These beans have obtained a geographical agreement that limits the area where they can be cultivated, with a specification for the beans. That it’s to have a certain size, be white with a thin skin and have a creamy texture and not a taste of flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.5.25 Soisson Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer101"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-84.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer102"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soisson beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This bean was found in the town of Soisson in the North East of France, it is a very large white bean that has developed locally and has obtained a geographical certificate.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("2.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The lentil was one of the first plants domesticated by early man. Its origin is unknown but it was in the Middle East probably in Syria or Turkey. Archaeological remains have been found dating to about 7000 BC. These remains were lentils seeds from wild plants that had been collected. Lentils were widely used in Egypt and later by the Greeks and Romans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The lentil plant is an annual herbaceous bushy plant of the leguminous family occurring all over the world in many different types. The plant grows to a height of about 75")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("cm high. The stem is angular and hairy, the leaves are compound alternate and have up to 7 pairs of oval leaflets, the flowers are grouped on stems and vary a lot in colour from white to yellow, pink and purple. The flowers give pods that are about 1.5 cm long containing two seeds of about 5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mm in diameter. The colour of the skin and the cotyledons is variable depending on the variety.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lentils are commercialised in different forms according to their use.")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Whole, generally used for cooking. The cooking must be done very carefully with a minimum of water, to be added as the cooking progresses to maintain the shape and skin.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Peeled or peeled and split. The lentil has a tendency to melt and is often used in soups or to thicken a dish or stew. It is possible to keep the form but this requires careful attention.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Flour. This flour is used in many ways, to thicken dishes or as an additive for cakes, pastry, pasta and bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many different varieties of lentils in the species "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")]), _vm._v(". In India which is the largest consumer of lentils, there are about 50 different varieties cultivated. We will consider the main types. It should be noted that lentils must be cooked before eating as like many beans they contain toxins that are destroyed by cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The following are the main types:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table012"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Black Beluga Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brown Spanish Pedrina Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Puy Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens esculenta puyensis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Verdina Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Urad Dal Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Queen Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Armura Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Crimson Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Indian Head Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lens culinaris")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.1 Black Beluga Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is a small shiny black lentil about 5")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("mm in diameter and is called Beluga because of its resemblance to caviar and since it is the most expensive. It originates from Syria or Turkey and is cultivated worldwide, Canada being a large producer. It has thin skin and normally keeps its form after cooking which requires about 20 minutes on low heat, it is the lentil with the highest content of protein and is used in particular for salads and soups.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.2 Brown Spanish Pedrina Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer103"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-85.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer104"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Brown lentils")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sometimes, it is called brown lentil that is a small brown and melts when cooking, was cultivated in the Pyrenees, but today is largely produced in the United States. It is earthy brown to reddish-brown, yellow inside, often used with pasta or salad and generally Mediterranean food, needs slow cooking on low heat for about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.3 Green Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the green lentil grown in France, Germany and Russia, the European green lentil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.4 Puy Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is derived from the standard European lentil but has been cultivated in a particular area in Southern Central France, Puy-en-Valley, Rhone Department. The particular area has a good exposure to the sun and a micro-climate that suits this type of lentil its cultivation dates back to 1647.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.5 Verdina Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a small and green lentil, and is mainly used in South America and is often served in stews and baked dishes with chilli. It requires about 30 minutes of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.3.6.6 Urad Dal Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lentil is from India where is cultivated largely, it has an ivory white colour and is very rich in proteins, and for this reason, it is a good replacement for meat. The flour is used for making bread and in particular poppadums.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.7 Queen Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is one of the largest lentils it is yellow and flattened.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.8 Armura Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lentil comes from the Spanish area of Salamanca, it is a blonde yellow colour. This lentil is very large and is considered one of the best tasting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.9 Crimson Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A lentil from Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.6.10 Indian Head Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Known also as the Egyptian lentil.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("2.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The genus lupines contain many species about 600 which are very diverse, the plant is a herbaceous annual or everlasting and belongs to the leguminous family. It is a flowering plant. The lupin plant produces beans, and has been eaten by humans and animals from very early times. They are very rich in proteins.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There were two sites of early domestication one in the old-world Mediterranean basin and another in the new world Andes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupins are also used as decoration; they have very beautiful flowers and lots of different colour’s.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("Mediterranean and European Lupins")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table013"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("White Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus albus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Yellow Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus luteus")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Gallery Blue Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus cosentini")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.1 White Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("This is thought to be the first domesticated lupin, grains were found in tombs of the Phaethon’s, used by Egyptians as food. Cultivated and used by the Greeks It is an annual plant growing to 50-120")]), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v(" cm")]), _c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v(" high, it has white flowers that give pods containing grains rich in proteins and containing bitter alkaloids, that have to be removed by soaking and cooking. This lupin is widely grown all around the Mediterranean and even in Germany. It is a popular aperitif dish all around the Mediterranean and particularly in Spain, Portugal and Southern France. The preparation, for removing the bitterness is long.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.2 Yellow Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The European lupin or yellow lupin have been cultivated around the Mediterranean and in the Nile valley, seeds were found in the tomb of Ramses 111, about 1500 BC. This lupin does contain bitter alkaloids and requires preparation of soaking and cooking being used generally it is served in brine as a snack or street food all-round the Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.3 Gallery Blue Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lupin is mainly grown for livestock feed and green manure, it is a deep-rooted annual plant growing to about 120 cms. It contains large quantities of bitter alkaloids and care must be taken with animal feed.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2a"
  }, [_vm._v("The Old World Lupins")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table014"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andean Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus mutabilis")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Australian White Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus angustifolius")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.4 Andean Lupins")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer105"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-86.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer106"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lupin flower")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Lupinus mutabilis")]), _vm._v(" was cultivated in the Andes by pre-Inca civilisations in about 600 BC. These lupin beans were used as food by the Incas and were also eaten by previous civilisations, they spread all over South America the New World lupin beans contain generally lower bitter alkaloids than the European types.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.7.5 Australian White Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This lupin known as the narrow-leafed lupin grows in Australia and has a lower level of bitter alkaloids than the other lupins.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Sweet Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A lot of genetic work has been carried out on lupines to produce nontoxic food for humans and animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first low alkaloids lupins were produced in Germany in the late 1920s, but this work was not continued.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Australia farmers in Western Australia in the early 1900s in the land that was generally considered to be sterile after ploughing back the lupines it was much richer for the next crop, this technique of green manure was developed and contributed to the success of farming in Western Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sweet lupines are interesting as they allow the use of lupin beans without soaking and cooking, they also permit the production of lupin flour and lupin flakes. Both flour and flaked can be useful as a replacement of cereals in breads due to their low starch contents paste and other dishes to reduce the carb contains, as the lupin has very low carb content.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("2.5.8 Peanuts and Groundnuts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer107"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-87.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer108"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peanut Flowers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a general name used in discriminately to describe the leguminous plants that produce beans in underground pods sometimes also called monkey nuts. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are three main members of this group.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table015"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("American Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Apios americana")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Groundnuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Vigna subterranea")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Arachis hypogaea")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.1 American Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Apios tuberosa")]), _vm._v(", sometimes called American groundnuts.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer109"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-88.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Groundnuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is native to the southern parts of North America and is also called potato bean or Indian potato. It is a perennial vine that bears edible tubers. This vine grows up to about 5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m in length, with peanut leaves 8-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with 5-7 leaflets. The flowers are usually pink to purple or reddish-brown and produce dense racemes 7-13"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long. The fruit is a tuber pod on the rhizome type root stem, being 5-13 cm long. Its natural growing area is from the south of Canada down to Florida and to Colorado in the West.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is toxic raw but can be eaten cooked as boiling destroys the toxicity like in many beans. The Apios Americana peanut cooked has the taste of potato with a nutty note, it is richer in starch and proteins than potatoes. It was largely consumed by Amerindians for centuries. It was used by settlers and pilgrims and helped them to survive the first winters.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.2 Groundnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This plant is also called bambara bean or earth pea. It is an annual herbaceous climbing plant, having long glabrous trifoliate leaves. It has a deep taproot that carries lateral roots that carry nitrogen-fixing nodules. Flowers are present with papilla’s feller that once fertilized are drawn underground and produce fruit which gives a pod continuing 2-3 grains.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant originated in West Africa where it grows mainly in the tropical areas of the sub-Sahara.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.8.3 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The peanut also called groundnut ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Arachis hypogaea")]), _vm._v("), is a herbaceous annual plant of the leguminous family. It grows to a height of 30-50"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm. Like most plants of this family, peanuts plant has a nitrogen fixation capacity present in the root nodules. The plant has a bush form with leaves that are opposite and pinnate with four leaflets, two opposite pairs, each leaflet is 1-7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 1-3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm large, and like many leguminous, the leaves close at night. The flowers are yellow-orange and 1-1.5"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long. The flower structure is different from other plants in the family in that the ovary is mounted on a sort of stem, that after polarisation will push the ovary underground where it will produce a pod 3-7"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cms long and form the peanuts. The peanuts have a similar taste to tree nuts; they can be used in place of nuts but are generally used as food or to produce oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The peanut is a hybrid of two different plants, it would seem that this mutation occurred somewhere in the highland between Bolivia and the Argentine. In early times the culture spread to other South American Countries and many varieties were developed. Today the peanut is grown worldwide in tropical and sub-tropical climates. Its culture is very important for the production of oil in which it’s very rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("2.5.9 Carob Tree "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ceratonia siliqua")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer111"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-89.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer112"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Carob tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Carob Tree ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Ceratonia siliqua")]), _vm._v(") is a permanent tree belonging to the leguminous family. It is native to the Mediterranean and grows all around and just to the Canary Islands and Iraq.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The tree can grow to some 15 meters, has a hemispherical form with a strong trunk with dark brown bark. It can live for about 500 years and takes 70 years to produce fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leaves are composed, alternate with 3 to 5 oval leaflets, the leaves are hard and of a dark green colour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The male tree does not give fruit, the flowers are small reddish and are in a catkin-like support and the flowering takes place in autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit is a pod from 10 to 30"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and 2 to 3"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm large, it is green and turns to dark brown at maturity in July the next year.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carob pod is widely used as animal food, it is particularly appreciated by horses perhaps because of its slightly sweet taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The wood is a dark red and is used by carpenters for furniture, in particular, for the powder of the carob pod is used as a substitute for cocoa powder and gives a different type of chocolate. It is often found in health food shops as it contains fewer toxins than normal chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The powder is also widely used in the food industry as an additive.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A gum is extracted from the bean. This is used as a thickener for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carob powder is also used for baby’s bottles as a replacement for milk, it has a sweeter taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("2.5.10 Tamarind "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Tamarindus indica")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer113"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-90.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer114"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamarind tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This leguminous tree is indigenous to the tropical African forests where it grows wild. It is a long-lived bushy tree that can attain some 20 -25 meters high. The tree has very flexible branches which make it resistant to wind, these branches carry feathery type leaves with oblong leaves about 7.5 to 15 cms long. The tree produces yellow fruits which in their turn give drop-shaped fruits in heavy skin. The fruits dry into a pod containing a red to brown paste and the seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The fruit is edible as are the leaves, the pulp from the pods and the seeds are very important to produce many condiments, sauces and additives for the food industry.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The tree has become very important and is grown worldwide in tropical and sub-tropical areas, from India to Asia to Southern Florida and most of Northern South America, and Northern Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is widely used in cooking either as a paste or dried particularly in India and Southern Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("2.5.11. Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A mesquite is a group of perennial shrubs and trees with contains some forty members of the leguminous family that are indigenous to the Americas. They are present from the Southern States of the USA, Arizona to Texas in the North all through Mexico and the whole of Central America down to the north of Chile and Argentine. Each species has its own territory and conditions, all produce edible beans, these trees have been used by local indigenous humans and as animal food. The trees are relatively quick growing, and the wood is used for cooking and smoking, and in some cases medically, the bark is reported to contain alkaloids. The trees and shrubs are very thorny and have dangerous thorns, to the extent that the Gaucho cattle herdsmen have their horses equipped with a front apron in thick leather to protect the horse’s fronts and the rider’s legs when they are herding.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mesquite has always served as food for local inhabitants both for them and their livestock, the dry mesquite bean once ground gives a flour similar to wheat flour that can be used to make bread or tortillas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-73",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-91.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite tree")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following are the two most known Mesquites.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table016"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Velvet Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Prosopis velutina")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Honey Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Prosopis glandulosa")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.11.1 Velvet Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This rather strange leguminous tree grows in the deserts of California, Nevada and New Mexico, it is an important part of the desert ecology and favours the local vegetation and animal life. The deciduous tree grows to a height of 9-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m and has a very strong taproot that descends to about 15 meters and the tree is fairly resistant to drought.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The young branches may be greenish to start with and develop yellow thorns of some 2.5 cms long, the leaves which are feathered are about 10 cms long with the alternate section placed in opposition. The leaves have the particularity they close up at night.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the spring new leaves grow followed by the flowers which are yellow and about 10 cms long, the flower give rise to long pods that start with bright green like peas, but dry and bend containing several hard-brown seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2.5.11.2 Honey Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This mesquite is indigenous to the Southern Eastern states of the USA, Mexico and parts of Central America. It grows as a tree or bush and in the tree, form is smaller than the Velvet Mesquite and reaches 6-8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m. The pods, seeds and vegetation are edible, it serves as a shelter for animals both domestic and wild. The mesquite wood is used for construction and is also popular in Mexico for making furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("2.5.12 Fenugreek "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Trigonella foenum-graecum")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an annual plant of the leguminous family, with leaves having three oval leaflets similar to clover and can grow to about 60"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm high. The flowers are white-yellow which give pods about 8"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long and contain from 10 to 20 brown coloured angular grains.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek when you use the leaves fresh or dry is classed as a herb, but when you use the seeds, it’s classed as a spice, having a characteristic sweet flavour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is of Mediterranean origin and was cultivated in Egypt. Today it is cultivated all over the world in the warmer climates, typically in Southern Europe, but mainly in the Indian sub-continent.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("2.5.13 Liquorice "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Glycyrrhiza glabra")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer116"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-92.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer117"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Liquorice")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a herbaceous perennial plant of the leguminous family; it grows to about 1 meter in height and has pinnate leaves 7-15"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("cm long with 9-17 leaflets. The flowers have a purple to white colour and produce a loose inflorescence. The root is heavy and is the part that is used for flavouring.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The plant is native to Southern Europe and also Asia, particularly India.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The extract from the root is used as a flavouring agent for tobacco and for making sweets.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("2.5.14 Rooibos "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Aspalathus linearis")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The genus"), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v(" Aspalathus")]), _vm._v(" has many species, particularly in South Africa red bush or rooibos in Africans ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Aspalathus linearis")]), _vm._v(") is one of the species and is a leguminous shrub that grows exclusively in the mountains North of Cape Town in South Africa. Attempts to grow it in a similar climate worldwide have been without success.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The reddish needle-like leaves of the red bush have been used for a long time to produce tea-like infusions all over Southern Africa, today the product is known worldwide. The plant grows to about 1.5 meters and is upstanding depending on the variety. The plant is harvested in the summer and either fermented or and then dried for use.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is an infusion that has the advantage that it does not contain stimulants, unlike tea or cafe. Often called redbush.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("2.5.15 False Acacia "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Robinia pseudoacacia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A perennial deciduous tree of the leguminous family growing to 20-23"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }), _vm._v("m, and originated in America, and now growing worldwide. They use the flower to make beignets that are very popular in the season.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("2.5.16 Mimosa "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Abacia dealbata")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-2-93.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer119"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mimosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A perennial tree of the leguminous family that can grow to about 20 meters. This tree has a bright yellow flower that is the national flower of Australia from where it was imported to Europe in 1867 by Captain Cook. It grows in Portugal, Spain, Southern France. Italy and Southern Mediterranean. The tree has a very beautiful yellow flower and is used as a decorative tree and also as a cut flower. Other uses are for its essence for perfumery and to make syrups, jelly, beignets and the flowers are crystalized for decoration by bakers for cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("2.5.17 Animal Food and Fodder Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Note: These plants are detailed as they are important economically and for environmental farming equilibrium, but are outside the scope of this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This group of plants is very important historically and economically, as the different plants are present all over the world and represent the basis of animal food in different forms. There are four families of leguminous fodder plants: the clovers, the lucernes, the vetches and the vicia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these plants can be used in different ways for animal food, for grazing, for making hats or as silage.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a herbaceous annual plant of the leguminous family, and the four contains some 140 species of flowering plants commonly known as vetches.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some of these plants are very old since certain species are related to the ancestors of the broad bean and traces have been found dating from 9000 BC in the Middle East and from 5000 BC in the Balkans, and at about the same time in Thailand.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Plant of the species are present all over the world and are cultivated at the present time as animal feed or to support beekeeping as the flowers produce large quantities of pollen and nectar.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer181"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("Chapter 3\tIntroduction to the History of Peas and Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("3.1\tPre-history of humans and plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chapter is in no way a history lesson but simply offers a straightforward explanation to give a background to the history of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants are very important in human history. After cereals, they are one of the most consumed foods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The history of leguminous plants is complicated, as is the history of many plants and the humans who domesticated them. In order to explain in very general terms, the first part of the chapter covers the history of humans and their domestication of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Our ancestors came from Africa. The first "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" appeared some 150,000 years ago and were a hunter-gathers who were able to hunt and eat large quantities of wild animals and birds.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("About 100,000 years ago, man left Africa for unknown reasons and gradually populated the rest of the world. We will describe this movement in time and then examine the movements of the migration and also the origin of leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v("3.1.1 The Big Migration")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following image, Map 1, shows the general lines of human migration. The dates should be considered an indication only: the real dates are very complicated and difficult to interpret.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 1: The big migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-74",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Our first ancestors with a certain resemblance to us lived in Africa; they were hunters and gatherers and roamed in search of food. They were called hominoids. After some 2.5 million years, they had evolved and we have the first appearance of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(", which had a closer resemblance to us. At this stage, man started to use fire; it was the beginning of the Stone Age. The use of fire brought many advantages: to be able to cook, to keep warm and to protect against wild animals. These "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" were still wanderers looking for food and hunting. There were at least two types of this species and, perhaps, more.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At about this time, migration from Africa began, perhaps for climatic reasons or perhaps for others. The migration for those from the south was by the rift valley: what is now Egypt to the Middle East, either by the Red sea or by the Sinai; the west, towards Europe; the east, towards Central Asia and then to East Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the migration from Africa, the humans who left were not at all like the present-day Africans. They were smaller and lighter, more like the modern ‘Bushman’. The type of African that we know today evolved much later, it is thought in the Ethiopian, Nubian and Chad areas, before the beginnings of the Ancient Egyptian civilisation.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When these Africans started to move around the world they evolved and started to search shelter cliffs, and particularly caves. From about 30,000 – 20000 BC there were cave dwellings all over the world, and in some of these cave’s that have resisted time we find artistic painting and rock etchings. Most of the paintings show scenes of hunting. These remains are of great value, both historically and archaeologically.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-75",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-02.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cave drawing with hunting scene")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.2 Settlement and Domestication")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Following these migratory movements, humans slowly changed from a hunter-gathers to a partly and later totally sedentary race. This development was long and led to the creation of the early civilisations.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For historians, civilisation is defined as a developed structure with an organised society with a hierarchy and early farming and artisanal activities to build houses and monuments. We are interested in the period before civilisation, during the early domestication of plants and animals, thus in the period during which the leguminous plants were developed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In order to try and see this development, we will examine two periods, before Christ and in our time.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("The early period:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mesopotamia, the ‘Fertile Crescent’")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Egypt and the Nile valley")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("India")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Early Mexican civilisation \t")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("East Asia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Andes civilisations")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The African continent (other than Egypt)")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Australasia and the Pacific")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Greek Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Africa and Papua New Guinea are often neglected as they left no great monuments like the Pyramids. However, they are important, as domestication and developments were also taking place there.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After this civilisation, the whole world developed slowly and major historical events changed the culture of the leguminous plant:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("More recent history\t")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("The Roman Empire")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The Arab Empire")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Medieval Europe")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Christopher Columbus and the discovery of the Americas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Colonisation and the slave trade")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("British Agricultural Revolution and modern times")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Table 1 below shows the general evolution in different parts of the early period")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Green represents – Early civilisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Orange represents – Big towns and movements")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 1: Domestication and civilisation")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table017"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("10,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("9,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("8,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("7,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("6,000")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesopotamia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Jericho")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Egypt ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("East Asia ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Andes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Papua New Guinea, Australasia, Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("South-East Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("40000 BC")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("New Guinea ")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Estonia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Italy ")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Greece")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-3"
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table018"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("5,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("4,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("3,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("2,000")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("1,000")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesopotamia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Erdu")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-7",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Egypt ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-7",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Memphis")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Luxor")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-10 _idGenCellOverride-1",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Harappa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("East Asia ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-10 _idGenCellOverride-1",
    attrs: {
      "colspan": "2"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Andes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-11"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Papua New Guinea, Australasia, Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-11"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-12"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-5"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-6"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("South-East Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3 _idGenCellOverride-2",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Philippines ")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Spain")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Cadix")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-2"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Greece")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-3",
    attrs: {
      "colspan": "3"
    }
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-4",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Crete")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-8"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-9"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.3 Geographical Origin of the Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following table 2 and map 2 show the location of the first reported domestication of the leguminous edible plants developed by human selection. These plants were domesticated by selection progressive from wild plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 2")]), _vm._v(" "), _c('table', {
    staticClass: "No-Table-Style",
    attrs: {
      "id": "table019"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("America")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pacific")])])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Broad beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lupini")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tamarind")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fenugreek")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Liquorice")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Rooibos")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("False acacia")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "No-Table-Style"
  }, [_c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-13"
  }, [_c('p', {
    staticClass: "Text-table"
  })]), _vm._v(" "), _c('td', {
    staticClass: "No-Table-Style CellOverride-14"
  }, [_c('p', {
    staticClass: "Text-table"
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 2: Origin of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-76",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This type of early selection took place all over the world on all the continents. In the Americas, maize was domesticated and later beans in Meso-America and the Andes. Forms of early wheat in the Fertile Crescent (present-day Iraq) spread to Egypt, Europe and North Africa, and rice in China and India. As far as beans are concerned, apart from mung beans in India and one-eyed beans in Africa, all other beans are from the Pacific rim.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.4 The Result and Present Place of the Bean Family")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the earlier part of the chapter, we described the migration of people from Africa. We will now consider what happened to these people and what they did, and how and when they domesticated plants and animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is generally thought that the Fertile Crescent was the origin of our civilisation. However, if we look at the world map of Neolithic settlements, we will see that in fact there were simultaneous settlements in the different continents at about the same time, and each of these started agriculture and animal domestication in very different ways, mainly as a result of the particular wild plants and animals present. Map 3 shows the Neolithic and Bronze Age settlements worldwide. Map 4 shows a more detailed view of Europe, North Africa and the Middle East. It should be noted that the dates shown are to be considered as an indicative guide, to give a general picture of the historical evolution.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 3: Neolithic Settlement (BC)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-77",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 4: Neolithic Settlements (dates in BC)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-78",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.1.5 Effects of Domestications")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today everyone can eat more or less anything, even out of season. However, the original possibilities of local food remain very present.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Europe, the Middle East and North Africa, our food ways are influenced by wheat and barley in different forms. Wheat-based bread is present everywhere, often in different forms, followed by pasta and couscous. It is somewhat surprising that rice and beans took so long to come to Europe: rice came to Western Europe at the time of the Arabic invasions of Spain and Sicily in the eleventh century. Their consumption in these countries has been in many different ways, as in paella and risotto. On the other hand, beans came to Europe after the return of Columbus, although varieties were already known in West Africa and India.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In East Asia and India, rice was one of the first domesticated plants to be used and remains the base of most Asian foods. It took some time for rice to arrive in Europe. It was known to the Ancient Greeks, as Alexander the Great talks with admiration about a pilaf that he had eaten in Azerbaijan on his voyage to South Asia. However, it was not used in Greece for cooking but was considered a medical plant. To show the importance of culinary heritage, we can examine the case of South Korea. Japonica, or round rice, was first domesticated in the valley of the Yangtze River. The type of rice was used all over the north of China and then in Korea and Japan. Today, despite the fact that Indica or long rice could be cultivated in Korea, it is round rice that is used exclusively.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the Americas, in pre-Columbian times, the basic foods that were available were maize, beans, tomatoes, peppers and yams, among others. Marinated raw maize gave a grain that was used to make tortillas in central America and tamale in the south. Beans were largely cooked with meat, tomatoes and pepper. This type of food spread all over the Caribbean. After Columbus and the slave trade, African rice, black-eyed beans and collard greens arrived in America. The slaves knew how to cultivate these plants and they became part of the national food, often called ‘soul food’. In more modern times, the African rice was replaced by Asian rice, which is more productive; however, African rice is more resistant to adverse conditions and continues to be cultivated in more difficult conditions. Today, the basic food in the Americas consists of beans and rice, mainly with maize in Central and Southern America and with wheat in North America. However, maize is still widely used in the southern states of the US.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In sub-Saharan Africa, the following foods were previously available: African rice, millet, white fonio, spelt and yams, collard greens and black-eyed beans, with other vegetables and fruits. Today, the main foods used are rice, couscous made with millet and other cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Despite westernisation, many local breads are still made with local products like the typical tapalata bread in Senegal that is made from a mixture of cereals, wheat, maize and millet, containing 50% of local black-eyed bean flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.2 History of the Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The early civilisations were mainly river beds developments and the first were the following with their beginning dates:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table020"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1. Mesopotamia, The Fertile Crescent")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9000 BC – 100 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2. Egypt, The Nile Valley")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6000 BC – 300 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3. India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4. East Asia, Chinese River")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5. Early Mexican Civilisation")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – 1521 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6. New Early Andean Civilisation")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8000 BC – 1574 AD")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7. The African Continent (other than Egypt)")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4,000 – 1000 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8. Australasia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("40000 BC")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("9. Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6000 BC – Present")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10. The Greek Empire")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("750 BC – 366 AD")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following map shows the implantation of these civilisations.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 5")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-79",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dates given are the dates of the established civilisation, but thousands of years of domestication and work were necessary to get to this point. This early period is obscure to an extent because there were no writings to record what happened. However, a lot of archaeological information is available.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As an example, the town of Jericho was built in about 8500 BC, but before being built it was necessary to be sure that enough food would be available. For a town of that size, there is no way that hunting and gathering could achieve this; therefore, some type of organised farming must have existed. This would mean the preparation and storage of foods that could be dried: cereals and leguminous plants such as peas, broad beans, lentils and chickpeas. This system would need areas for drying and threshing and drying and other areas protected and dry for storage. The grinding of grains to make to flour could be done later. The farmers would need to be organised to produce the plants that could be stored as well as those that could be eaten fresh: cabbage, peas, broad beans and others. This same system would have taken a lot of years to prepare so the dates are difficult to imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.1 Mesopotamia: the Fertile Crescent (About 9000 BC – 100 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is what most historians consider as the cradle of civilisation: in the valley of the rivers Tigris and Euphrates, going west to the Jordan valley and the banks in the Mediterranean and touching the northern part of what is now Egypt (the Nile Delta).")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-80",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-08.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-81",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFertile Crescent\tTower of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some 12,000 years ago, this area had a number of tribes: some who wandered, others who started to have temporary or permanent villages, where many activities were starting to evolve, sowing plants and domesticating animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the earlier towns, a little apart from the centre, was Jericho, constructed on the West bank of the River Jordan (in modern-day Palestine). Jericho is believed to be the first town to be built in the Fertile Crescent. It was built in 8500 BC and fortified in 6800 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The valley of the Euphrates and Tigris has very rich soil, fertilised by the large deposits of rich silt that allow agriculture, while the rivers can be used for irrigation. These valleys, flowing through a very arid area, are flooded regularly: once with the melting of the snow in the mountains in the spring, and irregularly due to the rains in the same mountains. For this reason, it was more difficult to organise the irrigation to provide food for the population. The first Sumerian town was Eridu, constructed in 5300 BC. This was a more developed structure than Jericho.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of the Fertile Crescent between and around the Euphrates and Tigris was made possible by extensive work to drain and irrigate. The delta between the rivers was a wet and rich area, but to be cultivated it needed to be drained. The drainage was carried out by digging ditches from sea level to the delta, starting at the lowest level and progressing, digging out the soil till you found the water flowing to the sea. Once drained and worked and the seeds were sown, it was necessary to bring fresh water for the plants to grow. This was achieved by creating dams higher up the river, bringing water from these reservoirs to the delta by constructing canals with dams to regulate the flow. This system is fairly complex and shows a high level of technology. Later, these techniques moved up the two riverbanks to give fertile plains. The structure was fragile and had to be remade after the big floods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 9000 BC, wild grains were being cultivated. The regular foods available in Mesopotamia were plant products, e.g. emmer wheat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("4500 BC: barley oats, peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("6000 BC: lentils, chickpeas, cabbage, broad beans, onions, olives, almonds, dates, pistachios, pomegranates, radishes, carrots. For animal products: beef, wool-bearing sheep. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("5000 BC: goats, pigs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Hunting provided fish and wild game.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The supply of food was a major problem, as indicated in some of the early Sumerian writings where the problems of food rationing were discussed.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Plants available:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas, broad beans, turnips, onions, radishes, cabbages, barley grain, emmer wheat, aubergine.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Apples, grapes, dates, pomegranates, melons.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, sheep, goats, chicken, ducks.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and wild game.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The principal food of Mesopotamia was barley, mainly to make soup or porridge or stew with the vegetables and meat available. Ground to a flour, it was made into bread or fermented to make beer. With many fruits available some of which could be dried for conservation.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.2 Egypt: The Nile Valley (6000 BC-300 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of the Fertile Crescent probably started in the Jordan valley and then moved or was developed simultaneously in the Euphrates and Tigris valleys and delta. Later, it moved south to the Nile valley, north towards Turkey and then east towards the Caspian Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic-2-cols"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-82",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-10.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-83",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tPyramids\tEgyptian plough")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Nile valley is an ideal place for a river bed development, since the sources of the Nile are in the highlands of upper East Africa and have regular rainfall that produces regular flooding of the valley with rich silt which fertilises the surrounding arid land, while the regular flow of the river allows irrigation. This led to agriculture and development all along the river.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this time, Egypt was divided into Upper Egypt and Lower Egypt. The two kingdoms were unified by Narmer and led to the first dynasty; the capital was moved to Memphis in 2600 BC. Early development in Southern Egypt helped bring minerals and stones from the Western desert to produce ceramics and copper. Obsidian was coming from Ethiopia to make cutting tools such as primitive sickles to harvest grass or cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Egypt was the first large-scale agricultural site due to the length of the Nile and the fact of its effective administration that controlled the population as everybody worked on the land of the state-owned farms, and Egypt prospered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("By 2500 BC, the land was being worked with primitive ploughs drawn by oxen and irrigating was improved.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following products were available:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Emmer and other wheats, barley, onions, peas, broad beans, chickpeas, cabbages, leeks, radish, cucumber, carrots, turnips, aubergine, asparagus, olives, lupin, lentils, carob, garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Melons, dates, grapes, apples.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, sheep, goats, pigs, pigeons, quail, geese, bees (wild and domesticated).")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and game from hunting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The basis of Egyptian food was bread and beer. The bread and beer were accompanied by vegetables, either raw or cooked, and meat, generally cooked. The following types of cooking were used: boiling, stewing, grilling or roasting. The bread was made generally from emmer wheat flour, made into dough and raised with yeast made from the same flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The yeast made for bread was also used to ferment the beer. There were many types of baking methods used for the bread which changed during Egyptian history, the last being an oven similar to the Indian tandoori oven.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.3 India (9000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Early Neolithic civilisation started in the different parts of India from about 9000 BC as small villages that started cultivating and breeding animals in and around the river beds. There are two main rivers in the north of India, the Indus to the west and the Ganges to the east. Development in the Indus valley was by indigenous inhabitants and influenced by the earlier development in the Middle East; on the other hand, the Ganges Valley was a little later. But it was influenced by South-East Asia and perhaps New Guinea for certain plants or seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-84",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-12.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Geometric Structure in the Indus Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Indus Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Indus valley starts in the Himalayas and Afghanistan. It has many tributaries and flows to the Arabian Sea, covering a large spectrum of climatic conditions. The Indus river separates what is today Pakistan and India. The Indus valley civilisation was very important and was the largest of the early civilisations, and had many towns and cities all along the course of the river. The towns and cities were very structured and built in a geometrical structure with right angles. They were built with a higher part fortified where the nobles, rulers and rich lived, while the lower parts were for the common people. The towns had a fairly sophisticated drainage system. Because of the large drainage basin, the river flooded regularly and probably often. Each flood would bring a layer of fertile silt, the flooding would be finished by November and the lands would start to dry. The seeds were sowed and harvested by about April, before the next floods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Plants grown were the following: Indica rice (long rice), varieties of wheat and barley, oats, mung beans, broad beans, lentils, sesame, mustard, chickpeas, lupins, cabbage and cotton.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The animals domesticated were ox, buffalo, sheep and goats.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Camels and donkeys were used for transport; horses were little used. Elephants and rhinos were known.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 6: Indian Rivers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-85",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Trade was carried out with the rest of India as well as Mesopotamia, both by land and by sea.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-86",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-14.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Indian ceramic statues")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("Ganges Valley")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-10"
  }, [_vm._v("The Ganges, the longest river in India, starts in the west and drains into the southern part of the Himalayas and the northern part of India, finishing in what is now Bangladesh and flowing into the Bay of Bengal. Some hundreds of years apart, the population moved from the Indus valley to the Ganges plains in north-west India and became the centre of civilisation there. The cultures and animals were more or less the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the time, nomadic tribal life in India was fairly easy because of the richness of the lands near the fertile rivers. As humans started a semi-nomadic life at the beginning of civilisation, many plants were available for domestication.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products available:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Wheat rice, millet, sorghum, lentils, chickpeas, peas, onions, garlic, cotton, olives.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Lemons, oranges, mangos, dates, jujube, sugar cane, tamarind.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle sheep, pigs, goats, chickens, bees.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish and game.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The base of early Indian food was cereals and rice. A number of breads were made, the most important being chapatti. The dough was made from wheat flour made into a thin disc and cooked on a plate or dry pan with no oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Naan is a yeast-leavened bread from flour dough and yeast, made into discs and cooked in a tandoori oven.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Papad is a thin disc made from chickpea flour and water and cooked in the pan at the last minute.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These different breads were eaten with cooked vegetables and meat. However, in about 3000 BC, the Hindus decided that cattle were sacred and that meat was not to be consumed; most people became vegetarians. Indian food was highly flavoured, using many herbs and spices.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Drinks made from milk and honey, often mixed with water or fruit juices, were the most popular. Wine was also made, but this was reserved for the rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.4 East Asia China (8000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Early development in East Asia was around the three large river beds. The Yellow River runs through the northern parts of China and the south of Mongolia and ends in the Yellow Sea. The Yangtze River rises in the west, goes through the central part of China and ends in the China Sea. The Pearl River starts north of the Himalayas and finishes in the South China Sea. There is a lot of scholarly discussion about the order of development between the different rivers. While this discussion is interesting, for our use we are just concerned by a general picture of the development and not the details.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 7: Main Chinese Rivers")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-87",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products Available")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Asian rice (short-grained, Japonica) – Yangtze valley, 8000 BC – South Korea")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chinese millet, North China yellow river, Central Asia, 5000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Soybeans, South China Yangtze valley, 6500 BC.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Adzuki bean, North China, Korea, Japan.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Wheat (from central Asia), 2000 BC.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Sorghum.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Hemp for fibre and cannabis.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also: perilla, mulberry, cabbage, onions, garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peaches, Jujube, Sweet Oranges, Chestnuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cattle, Sheep, Goats, Pigs, Chicken and Bees.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In central and southern China, the major food ingredient was rice, which was boiled in water or milk. In Northern China, millet and wheat were the main major foods, generally boiled to make porridge.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tea was popular from 3000 BC. By 2000 BC, beer was being brewed from rice.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-88",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-16.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Great Wall of China")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.5 Early Mexican Civilisation (8000 BC – 1521 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The early civilisation of Mexico, with the Teotihuacan, Maya and Aztec, was made possible by the early tribal domestication of plants using the grand biodiversity available. The land was fertile, and the climate was good; however, the geography, with large shallow rivers and lakes and very steep hills on each side, resulted in very small river banks for the culture. This problem was solved by the construction of the ‘floating islands ‘in the rivers and lakes and terraces on the hilly parts. The Chinampas are island fields created in the shallow lakes and river beds of the Mexico valley. They are generally small and rectangular and are made by fencing part of the shallow lakes and then filling the fenced part with stones, sand and rotting vegetable waste and soil until the island is above the water level. These fields were cultivated as normal land and often serviced using flat reed boats. Sometimes, the Chinampas used willow sticks, which grew and gave shelter to the plans being grown. The terraces were built by digging a flat on the slope, taking the rocks to the lake and filling the hole with soil, generally keeping the best soil for the surface. The construction of these walls was very difficult, and it required a lot of dexterity and practice to make the Chinampas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-89",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-17.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sketch of Chinampas river cultivation")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-90",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-18.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Irrigation terrace")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Organised dwellings were present on the Mexican eastern coast in 600 BC, near present-day Vera Cruz.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-19.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Products Available:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer139"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Maize")])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Vegetable Plants:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize (many species) \t\t7000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Beans (many species) \t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Squash \t\t\t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tomatoes \t\t\t4000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peppers (hot and sweet) \t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Potatoes \t\t\t8000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also available: Peanuts, manioc, tobacco, cacao, sunflower seeds, rubber, cotton, sweet potatoes, cashews, cinnamon, vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Fruits:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Bananas, mangos, guavas, peanuts, avocados, limes and many other tropical fruits.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("Animals for food:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Turkey, Muscovy duck, dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fish, rabbits and deer from fishing and hunting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Food and drink:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The main food culture consisted of the ‘Three Sisters’: maize, beans and squash. In this culture, the maize was sown first. Once it had started to grow, the runner beans were sown or planted around the maize and later the squash as an outer ring. The maize was the support, the beans climbed the maize and fertilised the ground and the squash, with its large leaves, protected the soil and reduced evaporation. This system is still used by some gardeners. Maize could be used in many ways – fresh, boiled or grilled – but the major use was dried and ground to flour or very small grains, mixed with water to make a dough, rolled into thin discs and grilled to make tortilla or tamales. The tamales are generally small, thick pieces of maize dough wrapped in the shell of the maize grains, either fresh or dry. In early times tamales were cooked by burying them in the ashes of a fire.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-91",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-20.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamale")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Potatoes were the other main starch source. The tortilla or potatoes were generally served with meat and vegetables in a hot sauce using hot peppers. In the Aztec times, meals were often served with three tortillas to accompany the rest of the food.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-92",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-21.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tortilla")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A drink was made by mixing maize flour with chocolate, cinnamon and vanilla in water. Another drink was made by fermenting the syrup of agave (cactus) to make an alcoholic drink generally reserved for the priests and rich.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-93",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-22.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sun Pyramid")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.6 Early Andean Civilisation (8000 BC – 1574 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There is evidence of human occupation in caves in high altitudes in 1200 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Andean civilisation goes from part of Colombia to the north of Chile and the Pacific Ocean. It includes parts of Ecuador, Bolivia and Peru. It is believed that the earliest civilisation took place about 5000 BC in the desert land near the Pacific coast. This is very arid but is surrounded by a land river that comes from the Andes mountains and flows most of the time. With irrigation using the water from these rivers, early tribes started cultivating, but because of the limited resources new populations had to move towards the mountain, where they found water easily. It was very difficult to live because of the geography of the land and the climate. However, these early Incas were able to survive by making terraces and shelters to adapt to the climate, and this was the beginning of the Inca civilisation. The Inca civilisation at the beginning was a patchwork of different tribes over a large area and climate spectra. The Andean area contained an amazing collection of botanic variety.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following fairly recent photos shows the terraces on the Yska del sil in the Bolivian water of Lake Titicaca. These terraces were constructed some 3,000 years ago to feed the people of La Paz. They are still used today by the local population.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-94",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-23.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Old Inca terraces on Lake Titicaca")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following different plants and animals were present:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Vegetables and grains:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The principal plants:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Maize (many varieties)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Potatoes (many varieties)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Quinoa")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Peppers (sweet and hot)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tomatoes")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Sweet potatoes (many varieties)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Also cotton, cocoa tobacco, maca, parsnips.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Fruit:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pineapple, peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Animals:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Llama, alpaca, guinea pigs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many other fruits and vegetables used by the Incas remain unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Foods")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The main basic food support was maize and potatoes. The maize could be eaten fresh, grilled, boiled or in soup. The dried maize could be conserved and used cooked alone or in stews, or could be ground to a flour consistency to make tortilla that could be grilled or cooked otherwise. The potatoes were eaten cooked, boiled, grilled, or in soups; however, the Incas had discovered the technique of freeze-drying and were able to keep potato powder during the winter seasons.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as the meat was concerned, llama and alpaca were eaten on religious celebrations or by the rich. The basic meat for the population was guinea pig, which was bred everywhere. In fact, it is still bred in people’s backyards or in their houses. Otherwise, hunting and fishing were carried out in certain areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For drink, ‘Chicha’, a beer, was brewed using maize flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.7 The African Continent other than Egypt (4000 BC – 1000 AD)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Africa was the original home of humans and after the grand migration some 150,000–100,000 years ago. The Africans who migrated were not the Africans of today; they were smaller, thinner, much lighter than the present-day Africans. This migration took place over a long period and was by the northern route by the Sinai or by the Red Sea to the Arabic peninsular. Many tribes or parts of tribes remained and evolved, each one continuing their own development. These developments took place progressively all over Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In about 7000 BC, the modern type of African, the Nubian, evolved in the higher parts of the Nile Valley, in the Sudan and Ethiopia and migrated partly to Egypt where they were called Bantu, a name that has followed them till today.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-95",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-24.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Egyptian hieroglyphs for ‘BANTU’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Nubians were a civilisation of hunter-gatherers between 7000 BC and 400 AD, and their way of life was very dependent on water in rivers and lakes. They covered a large part of the Nile valley and other areas of north-eastern Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In about 6000 BC, there was a much drier period and the level of the river and lakes was lowered, and the Nubians were looking for more favourable lands.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this period, the Nubians were cultivating millet, sorghum and teff (a grain cereal) and by 3000 BC had domesticated donkeys and cattle probably coming from Ethiopia. By 2500 BC, they were trading gold with Egypt in exchange for cotton and linen.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 8 First Bantu migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-96",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this time, they started to move East, South and between the two, taking three different directions. The Eastern route took them through Chad, Niger and Mali and followed the rivers to North-west Africa. Those who went further South from Chad moved to the Congo basin. Those who went south took either the coastal route to Ethiopia and Kenya or the Rift Valley to Lake Victoria.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 9 Second Bantu migration")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-96",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("On their way the Nubians met the local populations who remained hunter-gatherers. The local people had the choice of moving on or integrating with the Nubians. The majority decided to integrate, seeing the incomers’ agricultural knowledge and their iron tools and arms. Once arrived at the coastal area, the Nubians found a population of indigenous Africans and Pygmies in the rainforests. The locals integrated but the Pygmies moved deeper into the rainforest areas. These people lived on yam as vegetables with fish and game; guinea fowl were plentiful. The new arrivals discovered wild African rice which was domesticated, as was millet, sorghum and other cereals. These were plentiful and the population expanded rapidly. After some time, space became short and it was time to move. By now, the Nubian origin had disappeared and West Africa and West Central Africa had become the Bantu Homeland, and was followed by the occupation of the totality of Africa south of the Sahara.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-97",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-27.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("African beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.8 Australasia (40000 BC): Papua New Guinea, Australia, Vanuatu, New Caledonia, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first human presence in this area is the arrival in 70000 to 50000 BC of humans coming from the earlier migration from Africa. These people probably arrived by the land bridges all over South-East Asia due to the low sea levels. In Papua New Guinea in 50000 to 40000 BC, there are human settlements with dwellings and agriculture in the coastal areas. This civilisation seems to have disappeared, perhaps by earthquake, tsunami or disease. The population moved to the highlands and continued a life of hunter-gatherers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the same time, others of the same group moved to Australia, either via North or Western Australia or across the Straits of Torres to Northern Queensland. They moved around the Australian coast and Tasmania, which at the time still had a land bridge. They adapted to the very arable climates, going from the cold mountains of Tasmania to the tropics of the North. They were hunter-gatherers and lived on meat, fish, birds, snakes, grubs and insects; they also collected vegetables and fruits. These were different from what was available in other parts of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It has been established that there is a genetic link between these aboriginal peoples and those of Tamil Nadu in the southernmost part of India. It is believed that during their trip from Africa they passed centuries in Tamil Nadu, where it is believed that evolved humans were present 100,000 years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The second settlement in the area was the population of the nearest Pacific islands, Vanuatu, New Caledonia and New Zealand in 2,000 to 1000 BC. This movement was very different as the settlers were Asian, thought to come from Malaysia or the Philippines. These settlers were more organised as they travelled by boat over long distances in deep water and carried with them provisions and plants, grains and animals to help settlement in much the same way as the pilgrims who left Europe for the New World.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 10")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-98",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-28.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Australian and Papa New Guinea settlement and the first humans in Australia – "), _c('br'), _vm._v("Route of the Aborigines")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 11")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-99",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-29-new.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The settlement in the closer Pacific Islands")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Vanuatu may have been populated by the same people as Australia by groups of the first arrivals, but then became inhabited in about 100 BC by the newcomers from Asia. This explains the difference between the Australian Aboriginal and New Caledonian Kanak and the New Zealand M"), _c('span', {
    staticClass: "accented-letter"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "accent"
  }, [_vm._v("-")]), _vm._v("ori.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.2.9 Europe (6000 BC – Present)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Homo sapiens")]), _vm._v(" arrived in Europe in about 4500 BC and lived with the more primitive types of man for many thousands of years. Development was later in northern Europe due to the terminal effects of the last Ice Age.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The presence of cave dwellers in Southern Europe is illustrated by the southern French cave dwellings with interesting wall paintings in the Grote Lascaux, one of the departments of the Dordogne, and the Grote Chauvet in the department of the Ardèche. The habitation of these caves is dated about 30,000 – 20000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-100",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-30.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-101",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-31.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cave paintings")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Development was earlier in the regions near the Middle East, since development and agriculture were already developed. There was migration from these areas to Europe either by sea or boat to the Danube valley. Europe was populated from Spain to Russia with a hunter-gatherer population, who under the influence of tribes from the Middle East were beginning to farmland and breed animals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period was one of massive tribal movements throughout Europe, which led to domination and exchange with new people like the European Indians who came through Anatolia and Turkey and who mixed with the local populations. It was the time of primitive agriculture and husbandry to feed the growing population and use the rich marshlands recently liberated from the ice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Bronze Age started about 3000 BC and was present in the Aegean area. The effect of metalworking produced early sedentary communities necessary for metal smelting and produced a certain organisation and the beginnings of social structure.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Iron was known in the Aegean in about 1000 BC but its origin is difficult to find. Its use spread slowly over Europe and mainly in Northern Europe in 5000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1200 BC, the Aegean people and the Greeks merged and created a force that developed quickly, becoming an important maritime power; however, this power only lasted for about 100 years and sobered into the dark Greek ages until 750 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("With the disappearance of the Greek maritime power, the Phoenicians proceeded to occupy and create trading posts in Marseilles in France and Cadix (Cadiz) in Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some dates:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("3600 BC \tMinoan settlement Crete, bronze tools")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("6111 BC \tStonehenge in England")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1100 BC \tThe Phoenicians built Cadix")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1000 BC \tMadrid founded")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("600 BC \t\tForum constructed in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v("3.2.10 The Greek Empire 700 BC – 300 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-102",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-32.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Greek monument")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 12 ")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-103",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-33.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The full extent of the Greek (Macedonian) Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Greek Empire started in 700 BC at the end of the Greek Dark Ages. What little is known suggests that these ‘Dark Ages’ was a period of internal conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Greek Empire was very rich due to its abundant agriculture, with products that the Greek sailors could trade all around the Mediterranean in exchange for necessary supplies. The main products that Greece produced were wheat, both emmer and drum, barley wine from grapes and olive oil. With trading and colonisation, the Greeks spread development of agriculture around the Mediterranean and in Asia Minor.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The rise of the Greek maritime forces allowed them to capture Marseille from the Phoenicians and also to install themselves and create a trading post in Spain, near Gerome.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Greece, land was not controlled by the state but was free, which led to the widespread development of smallholders. These smallholdings were often tiny, but competition was high and things worked well.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most of the work in these smallholdings was manual, generally carried out by slaves using mainly wooden tools. Ploughing was by ox-drawn wooden ploughs, sometimes with iron tips.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following crops were being grown for local use or for export.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cereals:")]), _vm._v(" Wheat, both emmer and drum, with barley and millet in the wetter areas.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("V"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("egetables:")]), _vm._v(" Cabbage (three types), peas, broad beans, chickpeas, lentils, cucumber, onions, garlic, salads.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fruits:")]), _vm._v(" Apples, pears, pomegranates, quince, figs.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Tree culture")]), _vm._v(": Olives, almonds, walnuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as husbandry is concerned, the herds were small, generally family affairs. The following animals were being bred: sheep, goats, pigs, chickens and cattle. Horses, donkeys and mules were being used for transport.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In support of all this agricultural activity, many artisanal activities were being developed. A typical case is ceramic art. Ordinary pots were being produced for daily use, and large amphora and jars were produced for transporting oil, wine and cereals. For the rich tables, very fine and highly decorated table wear was made.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Between trade and colonisation, the more modern agriculture system spread around the Mediterranean and to Eastern Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-104",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-34.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Greek pottery")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.3 Evolution of Agriculture and Plants Since A.D.0 1")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.1 Roman Civilisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman history is divided into three periods:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Kingdoms \t\t753 – 500 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Republic \t\t500 BC – 27 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Roman Empire \t\t27 – 470 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-105",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-35.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Roman Bath")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These periods correspond to different forms of government, but despite the internal problems the expansion of Rome was continued and very rapid but not continuous, as it was related to the ease of occupation of new territories, sometimes by consent and other times by war, and through constant combat with the barbarian invaders. Under Roman rule, agriculture and husbandry continued to develop to keep up with the rapidly increasing population necessary to feed the ever-increasing need for workers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The city of Rome was founded in about 700 BC, and the kingdoms lasted until 500 BC when it was replaced by a Republic. At this time the Roman influence covered the whole of present-day Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 500 BC the Republic of Rome was created and they replaced the king with elected senators headed by a president. This period was a period of expansion and ended with the Punic Wars, then civil wars between leaders. At this time Julius Caesar arrived in Marseille and helped the local people to evict the Phoenicians, after which the local population helped Caesar to conquer some of his opponents in the Punic War. After this success, Caesar moved to the town of Arles and created the Roman colony with Arles as its capital in 49 BC and started his conquest of France.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After his victory against Mark Antony, Julius Caesar’s adopted son Octavian, later known as Augustus, was made Emperor with total power. The expansion of Rome continued; its final extent is shown in the following map. At this time, it is thought that the population was about 90 million, a third of the world population.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 13")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-106",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-36.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The Roman Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Roman cities were important with imposing structures including generally, arena, amphitheatre, baths, forum and all the infrastructure necessary for the organised life of a city. Many artisanal activities were necessary to allow the city to function – buildings, stonemasons, foundries, metal workers, etc. Outside the town and in the rural area, large farms were important to feed all the people of the town. Water was brought to the towns from far away, with sophisticated aqueducts in stone, and was distributed in the town in lead pipes. The towns were also equipped with good water and waste evacuation systems.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the Roman towns, the homes for the poor and the workers did not have kitchen or toilet facilities, as these activities were collective.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-107",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-37.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pont du Gard Aqueduct for the town of Nîmes, France")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Food took an important place in Roman life. In Greece, the main activity was drinking; in Roman life, it was eating. Basic food for all was wheat, meat, vegetables and fruit. Naturally, for the rich, it would be white bread, good cuts of meat, vegetables and fruit. The poorer and working classes had enough to eat and their diets were more or less based on whole-grain bread or a porridge made from wheat and other cereals.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The foods available was meat from cattle, goats, sheep, chicken and fish. The cereals were bread wheat, durum wheat, spelt barley, oats and rye. Milk was made from cows’ milk for the poor, whereas the rich preferred milk from sheep and goats. Many types of vegetables were available: peas, broad beans, cabbages, lentils, chickpeas and root vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.2 The Arab World 700-1200 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period is very important in agricultural development, with the mechanisation of irrigation and early methods of large-scale agriculture to provide for the rapidly increasing population. It was possible partly to Arab traders, who had access to a large land area, from the Iberian Peninsula to parts of Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are a lot of academic discussions between historians as to what extent this was not a development of Roman technology. The information below is just for interest.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the time of the Arabian empire, the following plants were being cultivated, principally: durum wheat, sorghum, rice, sugar cane, cotton, olives and other vegetables, peas, broad beans, chickpeas, lentils, different cabbages, spinach and other root vegetables, with dates and some citrus fruits. The size of the empire and the traders allowed many exchanges.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 14 ")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-108",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-38.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("The Ottoman Empire")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The agricultural methods were improved with primitive rotation, fertilisation and a lot of development in irrigation. The norias were improved and installed all over; the sakia or animal-powered water wheels were developed in Islamic Spain and then all over the Old World.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-109",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-39.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Noria")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rice was introduced to Europe by the Arabs, first into Spain in Valencia in the eleventh century and later to Sicily. In Valencia, the rice paddies were established around the lagoon and the Arabs taught the Spanish how to grow and cook rice. In Sicily, rice was cultivated by levelling the ground to produce rice paddies, using sophisticated irrigating that was installed. Again, the Sicilians were taught how to grow and cook rice. This rice was the basis for the paella dish, which came from Valencia. In Italy, the rice-growing moved to the Po Valley, and this is where risotto came from.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-110",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-40.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sakia")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.3 Medieval Europe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Middle Ages in Europe were the time of the creation of monasteries in many places. These monasteries were the home of knowledge and agricultural technology and helped to spread knowledge and make exchanges with Arab and Asian scholars. They also helped local landowners to control the labour force. They helped in the exchange of crops and techniques and introduced summer irrigation to improve the output of the land and development.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The development of iron smelting allowed the realisation of iron tools: blades for spades, hoes and for ploughshares. With the adoption of the chisel-type ploughs, the heavy and wet ground of Northern Europe could be tilled.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These monasteries took a very active part in the development of agriculture. They carried out plant improvement by selection and crossing of favourable plants. Equally, they developed methods of cultivating with rotation and also with methods of harvesting, drying and storing. Each monastery worked with the local climate, depending on local needs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Equally they employed crop rotation with a fallow year between, and made use of leguminous plants, peas, broad beans and lentils to fertilise the land.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Waterwheels invented by the Romans were improved and used for milling flour or processing flax and wool. The principal crops were wheat, barley, oats, peas, broad beans, cabbage and vetch, used later as animal food and as a leguminous plant for its nitrogen-fixing ability.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-111",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-41.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Modern village showing medieval structures")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.4 Christopher Columbus and the Discovery of the Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Columbus was probably not the first European to cross the Atlantic, as it is reported that Vikings and Brittany sailors had knowledge of the land, but he was the first to realise the importance of what he had discovered. His voyages were to trigger new development of trade, exchanges, war, colonisation and slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Columbus discovered the products and techniques of Aztec and Inca agriculture. Among other things, he discovered beans, which he brought back to Europe. Some went to the Spanish king and others to the Pope. The Pope gave the bean seeds to the Medici family and Catherine de Medici brought them to the French court when she married into it. These developments led to the early introduction of beans to Europe, followed by selective culture to produce new varieties: for instance, the tarbais beans were very popular in south-western French cooking, notably for cassoule; in northern France in the town of Soissons, they preferred a very large white bean and the famous flageolet, and later the borlotti bean became popular in northern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-112",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-42.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Christopher Columbus Caravels")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Other products that came from the New World included potatoes, tomatoes, squash, maize, peppers, chillies, sweet potatoes and vanilla. The impact of these plants was very important in Europe, where these plants had been unknown; they were to represent a major part of European food.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 15 Route of Christopher Columbus’ maiden trip")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-113",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-43.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.5 Colonisation and the Slave Trade")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("After the discovery of the New World by Columbus in the 1500s, the next century was an explosion of discovery and colonisation. The first to do this were the Spanish with the conquest of ‘El Dorado’ and the acquisition of the Inca and Aztec gold and other goods. The Spanish were quickly followed by the Portuguese, the British, the French and the Dutch.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The colonies were very rich in products not available in Europe: minerals, spices, wood and other things. There was a very important maritime exchange between the colonies and their owners and settlers were departing to the colonies to make new lives. In India and the Far East, there was no problem in obtaining labour; however, in the Americas and the Caribbean the local inhabitants either died due to disease brought in by the Europeans to which they were not tolerant or they disappeared inland to live their own life. Soon in the Americas there was a need for labour, for which the solution was slavery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The organisation of the slave trade was somewhat complex as it had to fit into normal trade routes. The solution found was to take goods from Europe to the African coasts that could be exchanged or sold to buy slaves. These slaves were taken to the coasts of the New World to be sold. The boat then took on goods that could be sold in Europe. There was no special boat for slave transport, and all types of commercial trading boats were used, from a capacity of 20 slaves to 100; however, the general boat would carry 60 slaves for a crew of 40, the crew being more important than usual for the trip across the Atlantic with slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The trips were difficult to organise as once the boat arrived in Africa, they had to buy the slaves, the boat had to be equipped for the crossing, irons and chains were installed to hold the slaves and they had to make provisions for the food and drink necessary for the crew and the slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Water was transported in barrels so these had to be made or repaired. The food was mainly barley and rice as a base, with dried vegetables and preserved meat. There was the inevitable conflict between the need to deliver the slaves in good condition and the cost of food and water.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-114",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-44.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Despite all the difficulties, the system functioned, despite leading to atrocious conditions for the transport of many slaves. The whole round trip took from 13 to 16 months, depending on the pickup and delivery points.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The arrival of these slaves was to have a long-term influence on the dietary habits of the Americas. The rice taken to feed the slaves was African, and the leftover rice was left with the slaves or new owners. This was the first rice cultivated in the Americas, which was possible due to knowledge brought over from Africa. The slaves also adopted the products of the New World that they were quick to use. Following their knowledge of making rice bread, they adapted their technique to make bread from hominy (maize flour) to make the cornbread now famous all over the Americas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The three maps that follow (maps 16-18) shows the general routes taken by what was called the triangular trade. The European traders left mainly from their home ports in Spain, France, Portugal, the United Kingdom, Holland and Belgium to a first destination in Africa – generally West Africa and in certain cases East Africa. In this first stage (see map 16: Slave Trade Triangle, Stage 1), the cargo was manufactured goods, arms, ammunition, trinkets, all destined to be sold or traded to African chiefs or bandits in exchange for slaves.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next stage (see map 17: Slave Trade Triangle, Stage 2) would deliver the slaves to the new areas of colonisation, mainly Brazil, and then to the Caribbean areas and the southern states of the present United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The third stage (map 18: Slave Trade Triangle, Stage 3) was the return to Europe with wood, minerals and other raw materials.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Later the Americans joined the slave traders, but their trips were solely transatlantic.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All these maps show typical routes, but this is only an indication.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 16: Slave Trade Triangle, Stage 1")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-115",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 17: Slave Trade Triangle, Stage 2")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-116",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Map 18: Slave Trade Triangle, Stage 3")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-116",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.6 Asia 0-2000 AD")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period in Asia represents a large-scale development of agriculture to meet the increase in population. This meant gigantic expansion, employing farm workers to produce the terraced rice paddy fields and large irrigation projects.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It was a period of development of derived leguminous products, generally beans in China, Japan and Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following sub-products were made: soy milk, soy wine, tofu, fermented bean paste, soy sauce, miso, sweet adzuki bean paste and cellophane noodles.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-117",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-48.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Example of bottles used for soy products")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy milk is made from ground soybeans and water and is a substitute for animal milk. The first date of its utilisation is largely disputed but is probably between the first and fourth centuries AD.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Wine")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy wine was first reported in about 350 AD. This is a fermentation of soybeans that gave an alcoholic drink. Later, beans and rice were fermented together and gave higher alcohol content. Later still, rice was used alone, with an even better result.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soybean Sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("These were first eaten by the Koreans in the tenth century, at the time of the Three Kingdoms.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tofu is made by curdling soy milk to give curds and whey. These are then used in much the same way as animal milk is used to make cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Fermented Bean Paste")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fermented bean paste is generally made from yellow soybeans, which are cooked until soft, ground to a paste, mixed with salt and sugar and then fermented by a complicated procedure for about one year. There are dozens of types of fermented beans, going from very light to almost black, depending on the type of bean and the other products added. They are used all over Asia to make sauces to flavour dishes. The first reported bean fermentation was Chinese black bean fermentation in about 165 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-118",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Soy Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Soy sauce is a liquid with a taste of meat and aromas coming from the degradation of vegetable proteins by fermentation. There are hundreds of types of soy sauce, going from light brown to almost black, and many types of different tastes. In China, where they were produced initially from about 700-900 AD, they were made from soybeans and roasted wheat. The method of production is fairly complex. The sauce spread all over East Asia and in each country it was modified or adapted.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Miso")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Miso is a Japanese culinary preparation with the texture of peanut butter, coloured from light brown to chocolate,. It is used to perfume soups and dishes and to make sauces, and also as a condiment to serve with starter dishes. It is made by fermenting soybeans with twice the weight of rice. The procedure is somewhat complex and can take from weeks to years, according to the specific requirements.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Sweet Adzuki Bean Paste")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This paste is made by soaking adzuki beans and then cooking them with sugar to give a jam-type paste that then forms the base to make bread or pastry. This is used all over East Asia.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Cellophane Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cellophane noodles or Chinese vermicelli are transparent noodles made from starch and in China from ground mung beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.3.7 European and American and Modern Times")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This period is important as the time of the great agricultural revolution. During the period there was a greater need for food for the increasing population at the beginning of the industrial revolution. Up to this time, agriculture was based on a system that deprived the land of its natural richness and typically land was left fallow every few years to recover some of this richness. One of the most important factors to improve productivity was the introduction of the Dutch rotation method. In this rotation, there are four crops that are grown in rotation – wheat, barley, clover and turnips – where the use of a leguminous plant, clover, allows the land to keep its nitrogen content, while the turnips make use of lower levels in the soil and improve the structure. ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The other major change was the development of the enclosed land method of farming. Up to this time, fields were left open and used by others than the owner due to the popular grazing rights of village shepherds. Later came changes in the social structure of farmers and the development of markets and transport, mainly by the canal system. At this stage, there was a large movement of the population from rural areas to the towns to work in the emerging manufacturing factories in the towns. The agricultural changes allowed an improvement in productivity and with improved transport enough food to be produced to meet the increasing need.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Mechanisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Animal-drawn ploughs have been known for all of recorded history. The Mesopotamians and Egyptians used them; these were wooden and were improved over the ages. In the mid-1600s, the Dutch improved the Chinese plough, and other animal-drawn tools were improved. In 1700 an Englishman developed a new plough with a cast iron frame and improved mouldboards and shares, which gave a better result. This plough was named the ‘Scots plough’ and was used for many years. Most work could be carried out with horse-drawn tools. This even includes threshing machines using equipment invented by the American McCormick in the 1800s but only used much later.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At this period, work had started on selective breeding based on the work of Mendel. Animals with desired characteristics were selected for breeding: these techniques produced animals with more useful specialisations, for instance, finer wool, increased weight or better resistance to diseases.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-119",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-50.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-120",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-51.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption ParaOverride-12",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Single mouldboard and share plough          Light harrow")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Motorisation")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The first replacement of animals as a power source started in the 1820s with the first steam-powered tractor. These machines were inspired by railway locomotives; they were heavy and hard to use, either in direct pulling or in cable hauling, which was introduced in about 1850. They allowed the use of larger tools and improved production.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-121",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-53.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Steam power tractor")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The first tractor with an internal combustion motor appeared in 1892. The first successful model was introduced in 1902, and this was the beginning of powered tractors all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1918 the first power take-off (PTO) was introduced. This means that it allowed the power of the tractors to be transferred to the attached tool via a driveshaft mechanism.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In 1935, the company Ferguson introduced the three-point hitch. This allowed the tractor to be coupled to the tool and the tool to be lifted vertically for road transport onto the field and put to the correct working height. This technology was adopted by Ford in 1939 and is used by most tractors manufacturers today. The three-point hitch was hydraulically powered by the oil pressure from the tractor’s hydraulic pump. It was possible to use this oil pressure to operate hydraulic pistons on the tools, and typically to turn double share ploughs or open cover crops.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The end of World War I saw the rapid increase in the need for food for the growing population. The industrial companies that had been making tanks and other military materiel turned to agricultural machinery tractors and tools, while others that had been making explosives and propulsive powder turned to synthetic fertilisers, herbicides and pesticides.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today, ploughs with up to 20 mouldboards and shares are available for very extensive farms.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("The Dust Bowl")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This was a major agricultural catastrophe, between 1900 and 1930 in the south-western US states of Oklahoma, Kansas and Texas. This was due to intensive cereal farming involving deforestation. The destruction of the woodlands led to drought conditions, and the land was overexploited without consideration. This led to soil erosion and massive dust storms, and the area was abandoned. It took many years to try to return to a normal state. This was made possible by the planting of millions of trees by the US government. This catastrophe made the US government create a service of land protection and control. This made other countries aware of this problem and some followed suit.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Modern Agriculture")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Modern agriculture has become highly mechanised and very chemical-dependent, using genetically modified plants that allow the plants to resist the herbicides that are used to avoid invasive weeds, and industry has partly taken control of farming methods.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-122",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-52.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Modern tractor with a six-furrow reversible plough")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.4 Historical Dates of the Leguminous Plants in Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Towards the end of the Stone Age and the beginning of the Bronze Age, the activities of man started to get organised. Already in the Stone Age, part of the population became less nomadic and with the knowledge they already had, they could go back to the known areas to pick plants that were ripe or catch fish that would be there at that time. This represented an evolution in the way of thinking and organising. This was the first settlement the tribes would stay in one place and start to cultivate in a primitive way whilst others would hunt in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("Knowledge of Food Plants at the End of Early Civilisations")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a global view, with the world divided into three groups, Asia (1), the Americas (2) and Europe, the Middle East and Africa (3).")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("1. PLANTS KNOWN")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.1 Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Japonica rice in China, Indica rice and mung beans in India, soy and adzuki beans in China; cabbage, onions, millet, wheat, mustard, radish, turnips, wasabi, perilla.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.2 The Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize, tomatoes, squash, potatoes, quinoa, beans, peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("1.3 Europe, Middle East and Africa")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas, cabbage, broad beans, chickpeas, wheat, oats, barley, onions, collard greens.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("2. PLANTS NOT KNOWN")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.1 Asia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("European crucifers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.2 The Americas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cabbage, peas, broad beans, wheat.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("2.3 Europe, Middle East and Africa")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Maize, rice, tomatoes, beans, potatoes, squash, Chinese crucifers, peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Major geographical transfers:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rice was being cultivated by the Arabs who took it to Spain and Italy in their invasion of Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans, maize, tomatoes, potatoes and squash were brought to Europe by Columbus and other Spanish boats in the eighteenth century and the Europeans took, cabbage, peas, broad beans, rice and chickpeas to the Americas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("3.5 List of Plants and their Geographical Origin")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In this section, we give the details and estimated dates of the presence of the different leguminous plants and historical dates of other detail, methods of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.1 Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.1 Green Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peas were first domesticated in Syria, Turkey and parts of Egypt. The following traces have been documented:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Turkey\t\t\t6500 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Nile Delta \t\t4800-4000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Upper Egypt \t\t3000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Indus Valley \t\t2000-1700 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Ganges Valley \t\t2000 BC")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-123",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-54.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Pea flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas were cultivated by the Romans, but wild peas were still collected by Roman soldiers to improve their rations. Peas, broad beans and lentils were the staple food in the Middle East, north Africa and Europe during the Middle Ages. In the seventeenth century, mangetout was developed, and at about this time it became the habit to cook fresh green peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.2 Indian Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This pea is indigenous to southern Europe, northern India and the Horn of Africa and has been cultivated from Neolithic times. It is the oldest known vegetable.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.3 Kudzu Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Kudzu peas are indigenous to Japan, Korea, China, Nepal and Bhutan. They seem to have been domesticated in about 3000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.1.4 Pigeon Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pigeon peas are a perennial plant that is indigenous to India and was domesticated in 1500 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Remains of broad beans have been found in the Egyptian pyramids, and the plant had travelled as far as North Italy by the Bronze Age. They were known all over the Eastern Mediterranean from 6000 BC and very early on were used as a cover top to protect the land from soil erosion, as they give a green cover during the winter and fertilise the soil. They can be used fresh or dry after soaking. They are very popular in the Middle East, where they are used in many ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origin of chickpea is in Turkey, the Middle East and India, in about 7500 BC. However, remains have been reported in South-East France in 6700 BC, so wild chickpeas must have been present all around the Mediterranean and east towards India. Today, chickpea grows all around the Mediterranean, South Asia and India. Generally, it is the dry seeds that are harvested. In India during the cultivation season, fresh green chickpeas are available. These are very good but unfortunately they are not available in most countries because of the high cost of harvesting. However, you can grow them in your garden.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("3.5.5 Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This group of plants is somewhat more complicated as they were absent from the traditional home of the Mediterranean and the Fertile Crescent of the Euphrates. There were separate origins for different bean types.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.5.1 American Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The origin of the American beans would seem to be the following:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table021"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tepory Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Runner Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lima Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Common Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Andes and Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Trailing Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica and Canada")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Tam Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Jicama")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mesoamerica")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Goityo")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brazil, Amazon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Ahipa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Anes")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans were domesticated in America in two distinct areas, first in the South American Andean area going from north Chile to the southernmost part of Central America, the second being from Central America to the south of what is the United States today.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following table shows the continental distribution of the leguminous plants.")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Table 3: Continental (World) distribution of the leguminous plants")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table022"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("India")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Asia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("America")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Africa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Pacific")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Broad Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Tamarind")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Fenugreek")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Liquorice")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mesquite")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Rooibos")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("False Acacia")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table"
  }), _c('td', {
    staticClass: "Basic-Table CellOverride-15"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.2 Indian Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Here we are talking about the Mung bean, which was first domesticated in the Indus valley in 2500 BC and in the south of Kerala in India in 2000 BC.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-124",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-55.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mung Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.3 East Asian Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Here, we are concerned with the soybean and remains have been found in:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("China \t7000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Japan \t6000 BC")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Korea \t1000 BC")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For information, Chinese legend states that from about 250 BC the following plants are sacred: beans, rice, wheat, barley and millet, which would allow us to imagine that these plants were already domesticated.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.4 South-East Asian and Pacific Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Hawaii Island was the home of some 50 species of beans. Some of these beans are now cultivated worldwide:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Rice beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Cowpea (beans)")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("The Winged bean from New Guinea is also cultivated in Africa and Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.5 African Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The following beans are from tropical Africa:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Guar beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("One-eyed beans")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Velvet beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There is some confusion between the origins of Africa and Pacific beans, probably due to trade movements. So, there may be some errors about origin.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_vm._v("3.5.5.6 Beans in Europe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Beans are not indigenous to Europe but came to Europe in the 1500s after the return of Columbus following his discovery of the Americas. In fact, on his first trip, Columbus did not get to the mainland of the Americas but ended in the Caribbean islands, in particular in Cuba, where he found beans and many other vegetables that had been cultivated thousands of years ago in Mesoamerica and the Andean part of South America. The vegetables included maize, potatoes, tomatoes and squash.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Before this time, beans were present around the Pacific rim and in the Hawaiian islands, in India and in tropical Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It is easy to understand that the beans did not come across the Atlantic to Europe. However, it is surprising that this did not involve the popular commercial connections between Asia and Europe transversal voyages, particularly the Silk Road, which brought many products from Asia to Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("On his return, Columbus gave the beans to the King of Spain and to the Pope who in turn gave the beans to the family Medici. Catherine de Medici bought the beans to the French court on her marriage to the King of France, after which beans spread very quickly all over Europe where they are cultivated in most places.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v("3.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lentils were known in Eastern Mediterranean, Syria and Turkey area from 13,000 to 9,999 years ago. In the Bronze Age, deposits were found in Switzerland (Lake Biel).")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v("3.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupins were known to the Egyptians and were found in the pyramids, dating from 2000 BC, and were cultivated in the Empire. Later it was cultivated by the Romans, who spread them through Europe and particularly in the south and Mediterranean areas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lupin was also known in the Andes, and evidence has shown it to have been present in about 700 BC in what is now Peru.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both the European and Indian lupins are bitter due to the presence of alkaloids. These bitter elements can be dissolved by soaking in water or salted water and cooking. Despite these difficulties, lupins have continued to be grown and used as street food all over Southern Europe, North Africa and the Eastern Mediterranean.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A low-alkaloid lupin was developed in Germany and Poland in the early 1830s. Trials were made, with average success. Due to wars, these trials were never finished.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the 1980s, there was a major breakthrough in Australia with the development of a sweet lupin that had a minimum of bitter alkaloids. This project has continued successfully, and today sweet lupin, flour, flakes and beans are available. The main obstacle for the development of this product is where the risk of cross-pollination with non-alkaloid free or wild lupin is high. This means the culture must be carried out in an area with a weed-free zone. This is possible in such countries as Australia, Canada or the United States, but is very difficult in Europe and other neighbouring countries.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-125",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-56.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Wild Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v("3.5.8 Peanuts and Groundnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are three origins in this group, coming from different areas:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.1 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Vigna Subterranea")]), _vm._v(" (Groundnut, Bambara bean)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is the West African groundnut; it is an annual leguminous plant that originated in the area of Mali and Nigeria.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.2 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Arachis Hypogaea")]), _vm._v(" (Peanut)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This annual leguminous plant is a hybrid of a rare type that originated somewhere between Bolivia and the north of Argentine. It was subsequently domesticated in a number of surrounding countries: Argentine, Peru, Ecuador, Brazil, Paraguay and Uruguay. In each of these countries a specific sub-species was developed each being different and botanically identified.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("3.5.8.3 "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Apios Americana")]), _vm._v(" (Indian potato, Potato bean)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This plant is indigenous to North America, from southern Canada to the southern states. It is an annual leguminous plant and grows wild was collected and domesticated by the native American Indians; it was a lifesaver like chestnut for early pilgrims and help them to pass the first winters. The genetic material of these plants has been used to produce the peanuts of today. The name Indian potato was given by The American Indians.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v("3.5.9 Carob Tree (St John bread, Locust bean "), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ceratonia siliqua")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an evergreen flowering shrub or tree of the leguminous family and is widely cultivated for its edible pods. It is indigenous to the Mediterranean area, its limits being the South of Europe to North Africa and from the Canary Island to Iran.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v("3.5.10 Tamarind ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Tamarindus indica")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a tree of the leguminous family indigenous to tropical Africa and India.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v("3.5.11 Mesquite")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer177"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-57.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer178"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mesquite")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mesquite is a family of leguminous deciduous trees and shrubs that grow in hard conditions from Central America to the north of South America. It has some forty family members of very different sizes that have been present from the Pleistocene and wood has been found from 1000 BC. The pods were used by indigenous populations as food for themselves and for livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v("3.5.12 Fenugreek ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Trigonella foenum-graecum")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek is an annual leguminous plant originating in the Middle East and India, which reached the Channel Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v("3.5.13 Liquorice ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Glycyrrhiza glabra")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Liquorice is a perennial leguminous root plant indigenous to Southern Europe and the Asian plains.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v("3.5.14 Rooibos ("), _c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Aspalathus linearis")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is a leguminous shrub growing on the hills around Table Mountain in South Africa. It was first used, it is believed, by the local population some three hundred years ago to make a tea-like infusion. Its international commercialisation started in the 1930s.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("3.5.15 False Acacia")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("False acacia is a leguminous tree origin in North America. It is now grown all over temperate climates. Its flowers are used for making beignets.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v("3.5.16 Mimosa")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer179"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-3-58.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer180"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mimosa flower")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Mimosa is a leguminous tree indigenous to Australia. It was brought to Europe by Captain Cook and now grows in many parts of Portugal, Spain, Italy and parts of France.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Its bright yellow flowers are used in many ways. To make syrups, jellies, crystallised fruits, and the whole flower can be used to make beignets. In Italy, they give a bouquet of Mimosa flowers to celebrate International Woman’s Day. This was chosen by the Italian Women Association on 8 March 1946.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer194"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_vm._v("Chapter 4\tLeguminous Plants and Folklore")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.1 Expressions")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer182"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer183"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Early beans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("OLD BEAN: a word of welcome for a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("HAVEN’T GOT A BEAN: broke, no money.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("GOTTA COUNT ME BEANS: better check my money.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.2 Fairy Tales and Legends")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.1 Jack and the Bean Stalk")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an old English fairy tale that first appeared under the title of "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Story of Jack Spriggins and the Enchanted Bean ")]), _vm._v("published in 1734. Since then, it has been re-written, changed and modified many times as a book, pantomime, and plays for children, films, video and games.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following is a summary of the tale.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack, a young lad, lived with his widowed mother in a small farm cottage with a cow, Bess, who was their only source of income. One day the cow had no more milk and the widow said to her son, “Go to the market and sell the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack took the cow to the market, but on the way, a wizened old man said to Jack, “Hello, Jack. Where are you going this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack, rather surprised that the old man knew his name, said, “I am going to the market to sell the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The old man walked around the cow to make sure that all was well and said to Jack, “Look in my hand: I have some magic beans, and I will exchange them for the cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack looked at the beans and was in a quandary to know what to do, so he asked the old man, “What is magic about these beans?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The old man explained to Jack that if he planted the beans that they would grow overnight to the size of a tree and lead him to the treasure. The old man, seeing that Jack was bewildered, said that if it did not work, the old man would return cow in exchange for the beans. Jack, thinking that this was a fair deal, took the beans in exchange for Bess. When Jack got home, he explained to his mother the deal he had done with the old man. She was furious and sent him to bed without any dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next morning, when Jack woke, he saw a shadow on the bedroom window and opened it and saw that the bean had grown overnight and the stalk seemed to disappear in the clouds. Without hesitating, Jack climbed the beanstalk that took him through the clouds, where he saw an enormous castle. Jack left the beanstalk and walked up the windy road to the castle as he walked into the kitchen. He found a woman cooking. She asked what he was doing and he told the story of the old man. The woman said that it was very dangerous as her husband the giant would be back soon and might kill him: “Come and hide into this copper pot. He will be here soon for his breakfast, you hide and since he has a nap after breakfast and once he snores you can get away.”")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-126",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A few minutes later the giant arrived with much noise:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“Fee-fi-fo-fum,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I smell the blood of an Englishman.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Be he alive, or be he dead,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I’ll grind his bones to make my bread.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("“Nonsense,” said his wife, “go and get washed; your breakfast is nearly ready.” ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The giant left and came back to eat noisily; once finished, he said to his wife, “Bring me the white hen and the singing harp.” He poked the white hen and said “lay” and the hen laid a golden egg that he put in a sack under the table. He took the golden harp and started to strum and a beautiful woman’s voice sang a lullaby. The giant fell asleep and started snoring.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Jack climbed out of the copper pot and tiptoed across the room and as he passed the harp, there was a whimper: “Take me with you. I can’t stand it here.” Jack hesitated, bit his lip, picked up the white hen and the golden harp; as he was leaving the castle, the hen cackled and woke the giant. Jack realised that he was in trouble and ran as fast as he could to reach the beanstalk.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("He heard a growl as the giant came out of the castle and started chasing after him. Jack started to climb down; when he was some way down, he felt the stalk shake as the giant started to climb down. He moved quickly and when he got nearer to the ground, he cried, “Mother, mother, bring the woodchopper quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When Jack was able to jump down, he gave the hen and the harp to his mother and started to chop the stalk. The axe was sharp and Jack was used to chopping wood and when the giant got near, there was a crunch and the beanstalk fell, killing the giant.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The white hen continued to lay golden eggs and Jack rebuilt the farm, re-purchased old Bess. Jack, his mother, the white hen, the singing harp and old Bess lived happily thereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.2 The Beans of Soissons")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Soissons is a town in the north-east of France well known for its large white beans that is well known for their very good taste. The bean has a number of legends of its origin: all of them are interesting. A few examples are as follows.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("FIRST LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("During hundreds of years of war between the French and the English during 1337-1453, the town of Soissons had an epidemic of plague and those who could abandon the town did so, often leaving part of the provisions of grains and animals along the road. When they returned, they found along the river and canal a very surprising harvest of wonderful white beans. Since this time, they have been called Soissons beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("SECOND LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the town of Soissons, there is a street called rue de la Paix, ‘Peace Street’, after a peace conference that was held in Soissons in 1728 to host a European conference which went on for several months on the future of Gibraltar. Spain was represented by the Marquis of Santa Cruz. The Spanish diplomat became friends with Jacquot, the gardener of the Saint Léger Abby, for whom he had great respect. The negotiations carried on for too long and The King of Spain recalled the Marquis. Before leaving Soissons, the Spanish diplomat made a present to Jacquot of a leather sack of Cordovan leather. When Jacquot opened the sack, he found beans much larger than the beans that they usually cultivated. He cooked some and found them excellent and planted them the year after. The crop was good, and from that time everybody who had a garden cultivated these beans that were called the ‘real Jacquot’.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("THIRD LEGEND")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the late 1800s, the Soissons watchman called Le Paon never left his watch. He watched over the town for fires, at the same time continuing his profession as a cobbler. This gave him a lot of pleasure but did not completely satisfy his curiosity. He occupied the rest of his time by sowing beans in boxes around the protective walls of the watchtower, and they grew to cover the tower with greenery, which everybody was pleased to see.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("“It’s the true Soissons,” he told his visitors, but added, “not as pleasant as described by the naïve poet,” and quoted: “God created the flower said, ‘Be Rose’, created the bean and said, ‘Be Sois Sons and go in peace’”. He wrapped his beans in cloth bags and gave them to the visitors. There was a confectioner who had a shop near the cathedral and he made a mould to make boiled sweets in the same form as the beans and coloured the same beige. He sold the sweets in cloth bags like the cobbler. It was a success, and he shared the profit with the cobbler.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These three legends are still maintained in the town of Soissons, and every year in September there is a festival of ‘The Soissons Bean’, with many celebrations throughout the town.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.3 Lyrics")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.2.3.1 Beans, the Musical Fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("There are many rhymes about the musical bean; see below a few examples.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Beans beans, the musical fruit,")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer185"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you eat, the more you fart.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you fart, the better you feel,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("So, we have beans at every meal!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Pinto beans are good for your heart,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you eat, the more you fart.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The more you fart, the better you feel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Stephen King in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Dark Tower")]), _vm._v(": “Beans beans, the musical fruit, the more you eat, the more you toot.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cartoon "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Camp Lazlo")]), _vm._v(" has a censored version:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“The more you eat,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the more you sit on the toilet seat”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In fact, the fart may have a musical context. I remember, when I was a young boy at boarding school in a rehearsal of a Gilbert and Sullivan operetta ("), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Pirates of Penzance")]), _vm._v("), that at the line ‘a cat’s footfall could be distinctly heard’, one of the boys let out a fart. Everybody was trying not to laugh. The choirmaster rapped his stick and said. “We will start again.” At the end, nothing was said, but baked beans were no longer served on music days.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.2.4 Lyrics: Beans and Cornbread")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer186"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-04.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These are the lyrics of a song written by Louis Jordan:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("Beans and Cornbread,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Beans and Cornbread had a fight,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Beans knocked Cornbread out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Cornbread said, “Now that’s alright, meet me on the corner tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("“I’ll be ready. I’ll be ready tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("That’s what Beans said to Cornbread. “I’ll be ready tomorrow night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.3 Music")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("People and groups that have adopted beans in their name or personal bean details.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.1 Beans, an American Rapper")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The American Robert Edward Stewart (the Second) was born in New York on 3 July 1971; his professional name as an underground rapper was Beans. He was a member of the Antipop group and he was the founder of Tyga Rawwest Records. He produces a number of what was called chunky psychedelic electro-hop. Beans performed on the same stage as performers like Radiohead and Kool Keith.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.2 Louis Armstrong’s Creole Beans and Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Louis Armstrong was well known for his love of beans and rice and as we have mentioned signed his letters ‘Beans and ricely’. After his death, his own personal recipe was found in his papers. This recipe is often served at jazz festivals.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-127",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.3 Red Beans & Rice Jazz Band")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer188"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-06.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Red Beans are a group based in Tel Aviv. They play swing music, also known for the tap-dancing that goes with the music. Their music style is from 1920s traditional New Orleans jazz right through to the 1940s; this was very popular in Harlem in New York. They played in famous clubs like the Savoy Ballroom and Cotton Club.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.4 Beans on Toast")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans on Toast is the stage name of British folk singer Jay McAllister, born 1 December 1980, from Essex, England. The group’s music includes folk, alternative rock, with antifolk topics like politics, drugs and love. Beans on Toast opened the Glastonbury Festival one year. They supported Kate Nash in 2008. One of their traditions was to release an album on McAllister’s birthday; from 2009 to 2018 they did this.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.5 Les Haricot Rouges (The Red Beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Les Haricot Rouges were a French jazz band, formed in 1963 by a group who all came from the Rodin School in Paris. They played New Orleans jazz and Dixie. They sold one million albums worldwide. In 2013 they celebrated their 50 years as a group with a new album, ‘French Melodies’. They were very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.6 Black Beans and Jazz")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Black Beans and Jazz were a group formed to play jazz music with themes by famous Guatemalan groups. It was published for Margarita Tejada House. Black Beans and Jazz support the work of the Margarita Tejada Foundation, which supports the work of Down syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.3.7 Bread and Beans Line Dancing")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very popular song for line dancing:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("“Bread and beans and yellow cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Having no idea of what’s going on.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("With our friends, with our dews was it right or wrong. I was gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The above is just to give you an idea of the lyrics. The original song was from Ernie Oldfield, from the CD "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("I Got What I Am")]), _vm._v(" sung by Peter Jordan.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This song is very popular worldwide. See one example, “The Rodeo Girls ‘from South Africa. If you want to listen to this, go to the following website: Rodeo Girls. Bread and Beans (Line Dance).")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-128",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.4 Comic Strips and Films")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.1 Beano")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Beano")]), _vm._v(" is an English comic magazine for children. It was first published by D. C. Thompson and Co. in 1938 and has continued to the present. It is published weekly on Wednesdays and dated the following Saturday. Today it is published by John Anderson. It remains very popular and contains the adventure of Dennis the Menace, Minnie the Minx, The Numbskulls and many others. It is also published in the form of an annual.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-129",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-08.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Street mural showing Dennis the Menace (and his dog Gnasher)")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.2 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Peanuts")]), _vm._v(", also called "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Snoopy and the Peanuts")]), _vm._v(" or just "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Snoopy")]), _vm._v(", is a comic strip created in 1950 by Charles M. Shultz, an American cartoonist. Mr Shultz started his career as a cartoonist in his home town of St Paul, Minnesota with the famous ‘Li’l Folks’ that appeared in his home town by Pioneer Press Publisher 1947-1950. In 1950, he moved to New York and started a saga with two principal characters: George Brown, a young man, clumsy, without a chance and depressed, and his dog Snoopy. "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Peanuts")]), _vm._v(" was a great success in the United States and worldwide. It was published in many countries and in many languages and continued until the death of Shultz in 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-130",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-09.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Charles M Shultz drawing his most famous character, Charlie Brown")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.3 Mr Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Bean")]), _vm._v(" is a British television series created by Rowan Atkinson and Richard Curtis and produced by Tiger Aspect Productions. It is a family-type comic with 14 episodes, produced from February 1990 to December 1995. Each episode is about Mr Bean and his toy bear Teddy and their surprising adventures. The role of Mr Bean is played by Rowan Atkinson himself; the films are almost without words and take "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mr Bean")]), _vm._v(" into a series of impossible situations, where he is able to create extraordinary situations, like getting people to fight to gain a few places in a queue. Rowan Atkinson has extremely visual abilities and offers a sort of exercise in non-verbal communication. The series has been a success and is shown worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.4.4 Tintin")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tintin is a fictional character in "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("The Adventures of Tintin")]), _vm._v(", created in 1929 by Belgium cartoonist Hergé. Tintin’s dog was called Snowy. The family dog was called Mangetout, and his grandfather was always trying to train the dog in vain.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-1"
  }, [_vm._v("4.5. Other Uses")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.1 Carat")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The carat, a unit of measure for gems, is derived from the carob seed, the seed being used by the Greeks, Romans and Arab as a measure. For jewellers, the seed of the carob has a diameter of 6.5 mm and this is the diameter of a 1 carat, ‘brilliant cut’ diamond. The value of the diamond carat is not the same as for other gemstones. This carat is not to be confused with the carat of goldsmiths, where it is a measure of purity.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.2 Michael Lotito (Monsieur Mangetout)")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Michael Lotito was a French entertainer, born in Grenoble in 1950. He was famous for eating indigestible objects like metal, glass and rubber. He broke the objects into small pieces then ate the pieces, washing them down with mineral oil. A Cessna 150, a small plane, was one of the most famous things he ate. This took several years. This is why he became known as Monsieur Mangetout, translated to Mr Eat-All.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.3 Peashooter")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peashooter comes under lots of categories. Here are a few examples.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.1 Boeing P.26 Peashooter Fighter Aircraft")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-131",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Boeing P.26 Peashooter was the first American aircraft built all in metal. Designed and built by Boeing in 1932, it was used by the American Air Force, the Republic of China, the Philippines and the Guatemala air forces.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.2 Peashooter: a version of the blowgun or blowpipe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The peashooter is a toy version of the blowgun or blowpipe. It’s a long tube that you blow down to shoot the dried peas out. There are lots of different sizes and versions. I can remember when I was a young girl that most of the boys had small ones and the girls were the targets. There is a World Peashooting Championship in England, in the village of Witcham. It’s carried out in the same way as archery.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("4.5.3.3 Peashooter: the nickname for a pistol")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The peashooter is a name for a small hand with low efficiency, i.e. 22 calibre. It is also the nickname of a lot of small handguns.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("4.5.4 Blowgun or Blowpipe")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The blowpipe or blowpipe goes way back in history. It’s the same principle as the toy peashooter.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many cultures used these weapons. The indigenous people of South-East Asia, the Amazon and the Guiana regions of South America, Central America and Guatemala were best known for using blowguns. These blowguns were used for hunting small animals. They were very effective. You can see evidence of painting of blowguns on pre-Columbian pottery, also in many Mesoamerican mythologies. Today the blowgun is used more for tranquillising dangerous wildlife. Sometimes to control the numbers and sometimes so that they can tag the animals to be able to monitor their whereabouts. The history of this is very interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-132",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-4-12.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Man with peashooter in Beaubourg, Paris")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We had a lot of fun putting this chapter together, and hope you will enjoy reading it!")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer229"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_vm._v("Chapter 5\tCooking and Recipe Codes")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.1 Codes")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer195"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer196"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("White bean soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This chapter is not a cookbook, but an overview of the vast possibilities in cooking the different leguminous. The number and diversity of the leguminous fruits and vegetables are quite astonishing and gives cooks, dieticians and food industries great scope. Another aspect of the leguminous is that they are gluten-free which today is very important for many people who cannot tolerate gluten or do not want gluten. Some of the leguminous contain slow-releasing sugars which may be useful for certain diets.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("To be able to find what one is looking for we have the following numbering system:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The recipes will have the first number 6, to refer to the chapter number.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Then we have the numbering of dishes, which will be the second suffix in the number code: ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("For instance, 3 = Main dishes, so the main dish headings will be numbered 6.3.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The five dish codes are as follows:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table023"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Soups and Consommés")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Salads, Starters, Snacks, Bread and Pancakes, and Sauces")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Main Dishes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Side Dishes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Sweet Dishes and Drinks")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Below we have the vegetable codes. This means, for example, that the main chickpea dishes have the heading number 6.3.3: in other words, 6. (Chapter number) + 3. (Main Dish) + 3 (Chickpeas).")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("The numbers of the ingredients (the third set of digits) are as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer197"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer198"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Sweet pea flowers")])])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list ParaOverride-13"
  }, [_vm._v("Broad Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Chickpeas")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fresh Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Dry Beans")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lentils and Pulses")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Lupins")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Carob Tree")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Tamarind")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mesquite")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Fenugreek")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Liquorice")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Rooibos")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("False Acacia")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the different recipes, we have adopted the following conventions for the weight.")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table024"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1 tsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("heaped teaspoon (about 5.0g)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("½ tsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("level teaspoon (about 2.5)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("tbsp")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("heaped tablespoon for dry ingredients, level for liquids.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All weights and volumes are in metric values:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table025"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("g")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("grams")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("kg")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("kilograms")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("millilitres")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("dl")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("decilitres")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("l")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("litres")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When quoting volume for measurement, this is what we mean: 1 volume of white rice to 2 volumes of water. The word ‘volume’ refers to the same amount.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In different recipes we talk about a certain number of spices. The following are some of the details.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Herbs de Provence")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer199"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer200"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Bunch of Herbs de Provence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a mixture of herbs used in Proven"), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("ç")]), _vm._v("al cooking and is a mixture of herbs. This is a mixture which varies depending on the taste you desire or on the cook. It can also be found in shops. The following is the mixture that we use. We make it ourselves from herbs that we collect in the countryside. The herbs are collected and dried, then the leaves are separated from the stalks and passed through a coffee grinder to give a usable, heavy-grained powder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main ParaOverride-7"
  }, [_vm._v("Our mixture is:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("2 tbsp thyme")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1 tbsp sage")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("1 tbsp rosemary")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("5 bay leaves")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("½ tbsp ")]), _vm._v("savoury")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("½ tbsp marjoram")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We also refer to two Indian spice mixtures. We make these ourselves.")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Garam Masala: Made with cumin, coriander, fenugreek, mustard, turmeric and gloves. Without chilli powder.")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Garam Masala with chilli: the same ingredients, but we add chilli.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Saffron is a crocus plant that produces red pistils and is used to colour and perfume dishes. False saffron comes from a flower called safflower, which gives a red flower, perfumes and coloured dishes. It is used as a substitute for saffron. It’s a lot cheaper, but does not have quite the same taste.\t")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("When we refer to sprouted beans, this means seeds that have been germinated.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.2 Notes on the Use of Leguminous Plants and their Cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.1 Peas and Mangetout")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer201"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-04.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer202"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Green pea")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Green peas and mangetout are generally eaten cooked, but they are very good raw. Very young mangetout is excellent in a salad. Otherwise, they are generally cooked in water or can be cooked in a soup or dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both peas and mangetout can be tinned or frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Dried peas can be found in green, yellow or split forms, the last being when the pea is skinned and opened. All the dried forms are normally soaked before cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour can be made from both green and yellow peas and is used in cooking. This is very good for people that are gluten intolerant, e.g. for pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.2 Broad Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Broad beans are generally eaten cooked, but when young they are very good raw and in this form are very popular all around the Mediterranean. They can be cooked in their pod when young but are generally shelled before cooking, which can be done if they are to be eaten on their own or in a stew or dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Once dried and after soaking, they can be cooked on their own or in a dish. In Egypt, they are cooked in their skins and once cold they are skinned and used to make hummus or falafel.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour can be made from dry broad beans and is used in making bread. There is about 3% broad bean flour in the dough used to make traditional baguettes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.3 Chickpeas")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Chickpeas are normally eaten cooked and are available dried or in pots and tinned. However, in the growing areas before harvest, they are picked like fresh peas. They can be found all around the Mediterranean and in central India, where green chickpeas are sold on markets and in the street. The green chickpea is very tasty and can be served alone or in salads or as a starter. Of course, this is not practical in Europe or the USA, as the harvesting of green chickpeas is very labour-intensive.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer203"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-05.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer204"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Chickpea pods")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Dry chickpeas need soaking before use but today most people use either pots or tinned chickpeas. They can be used on their own or in salads or dips. They are very important to the cuisines of the Middle East, North Africa and Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas are used to make flour which is widely used in cooking. It was particularly popular in Genoa in Italy to make a popular type of pancake known as farinata. This was carried all around the Mediterranean and even to South America, where it is still present on both sides of the Rio de la Plata.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas can be used for sprouting.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.4 Fresh Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fresh beans are eaten cooked. They are available fresh almost all year round, with products coming from all over the world. They are also available frozen and canned. These beans are generally cooked in salted water, the minimum to conserve vitamins and taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The cocoa bean is an exception as it is harvested when the bean is developed but is not dry; this bean is shelled and cooked in water or in a soup.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Another exception is the edamame bean, which belongs to the soy species and was known in Japan as far back as the sixth century. This bean resembles the broad bean and is harvested at an immature stage, cooked in its pods in salted boiling water. When young they can be eaten with the pods on; when they are old, they will need podding. In Japan, edamame is often served as an aperitif with beer, much like the traditional lupin in Spain and Portugal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Beans are used to produce bean sprouts, which are beans that have been allowed to sprout. The sprouting takes about seven days and gives a sprout that is more nutritious than the mother bean. Bean sprouts are used widely in cooking and salads.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.5 Dry Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The dry beans grow in a large variety of sizes, colours and forms; however, almost all dry beans are toxic raw, as they contain toxic alkaloids. These alkaloids are unstable, and the beans can be made nontoxic by boiling: 10 minutes in boiling water is sufficient. This does not mean the beans are cooked, however.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The dry beans are normally boiled in unsalted water, as the salt makes the boiling time longer. The beans can be boiled directly or can be soaked in advance. The soaking operation reduces the boiling time and generally gives a better product. As an example, the adzuki bean will take one and a half hours to boiling without soaking but if they are soaked for 24 hours, then the boiling time is about half an hour. Then you can cook them. The cooking time of the bean will depend on the type and on age; it is better to consult the label on the packet. The beans should be cooked slowly to avoid destroying the structure. A good simmer is ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Some beans can be sprouted. This way has become very popular.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("As far as flour is concerned, it is complicated to make flour due to the alkaloids present in raw beans; flour can be made but the bean or flour must be treated thermally before it can be used.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.6 Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Lentils come in many varieties and different colours; they are eaten cooked in many ways. The cooking times vary according to the variety and age. With lentils the most important thing is to cook them very slowly in a minimum of water by adding water as necessary, thus avoiding the possibility that the lentils break. The lentils can be served on their own or to make salads, soups or dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Typical cooking times are in minutes:")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table026"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Beluga Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15 - 20")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Brown Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("30 - 50")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("French Puy")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("30 - 40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("20 - 25")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Red Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("15 - 25")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Split Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table CellOverride-1"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("10 - 15")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Lentils can be sprouted and used alone or in a salad or in a dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.7 Traditional Lupin and Sweet Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Traditional Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Both European yellow lupin and South American lupin have been eaten for centuries. However, these lupin seeds contain very bitter alkaloids that have to be removed before eating.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The method of removing the bitter elements requires very long soaking and subsequent boiling to produce an edible lupin. These lupines are served as an aperitif all round the Mediterranean and particularly in Spain and in Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Flour is not made from the traditional lupins because of this bitterness.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Sweet Lupins")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Sweet lupins have been developed by genetic research. This produced lupin plants whose beans have very low bitter alkaloid content. This work started in Germany in the late 1920s and has continued worldwide. Australian agricultural workers were responsible for major development in the 1950s. Sweet lupin beans are available commercially. Sweet lupin flour and sweet lupin flakes are also now available.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Both flour and flakes can be used in cooking as a complement to other products. They’re both useful, but the flakes are about twice the price of the flour and are therefore less attractive.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The use of lupin products made from sweet lupin flour or flakes is very interesting from a dietary aspect as the lupin has is very low in calories and its use alone or mixed with other leguminous or with cereals will give a low-carb product. Typically, if you replace 30% of cereal or leguminous plants, you will reduce the carb content by about 20%, which is very interesting. In the recipes that follow we will illustrate the types of dishes that can be prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("It should also be noted that lupins, like peanuts, can be dangerous for people who have tree nut allergic syndrome.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.8 Peanuts and Groundnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peanuts and groundnuts can be eaten raw or cooked. In Europe and the United States, they are generally eaten raw as an aperitif or snack, raw or often roasted, or ground into a paste called peanut butter. In Africa and Asia, they are eaten raw and often cooked as part of a dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-133",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-06.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.9 Carob")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The carob tree is an evergreen tree originating in the Middle East that give pods similar to broad beans which become brown at maturity. Carob powder is made from the dried fruit that is used in cooking. This powder has a chocolate-type taste and contains sugar. It has the advantage of not containing caffeine. Carob powder is widely used for cakes, sweets and drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.10 Tamarind")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The Tamarind fruit is the pod of the tamarind tree. It contains seeds and a pulp that is bitter but becomes sweeter as the fruit matures. This pulp is used to make sauces and chutney and is an ingredient in many Indian and Thai dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.11 Mesquite Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The velvet mesquite tree gives yellow pods that contain beans. These pods and beans were part of the staple diet  for American Indians for many centuries. Today the pods are ground to produce mesquite flour, which has a much healthier value and is used to prepare, breads, desserts and cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-134",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-07.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("All spices")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("B.5.1.2.12 Fenugreek")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Fenugreek is a green plant that gives perfumed grains. It is cultivated in India as a vegetable giving grains that when crushed gives a particular odour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fenugreek is also used as a medicinal plant. The grains can be sprouted and used in salad or to cook.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.2.13 Liquorice")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Liquorice is a leguminous plant that produces roots that contain a powerful odour. The liquorice extract is obtained by soaking the chopped roots in alcohol for a few weeks followed by filtering. The extract is used for making sweets, cakes and drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.14 Rooibos")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Rooibos is a shrub that grows in the Cape of South Africa and its dried leaves are used to make a tea that has the advantage of not containing caffeine. Very popular today.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.15 False Acacia")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The flower of false acacias is used to make beignets all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.3.2.16 Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The mimosa flowers are used to make beignets, while individual flower balls are crystallised to decorate cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.3 Use of Leguminous Derived Products")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There exist many leguminous plant-derived products. The following text gives a brief description of their uses. There are few houses or flats around the world where there is not a bottle and or pot of a product containing soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.1 Leguminous Flours and Flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Many of the leguminous grain or pods are used as flours or flakes:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Green or yellow pea flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Soybean flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lentil flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lupin flour or flakes")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Carob powder or flour")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Mesquite ground or flour")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.2 Soy Milk")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer207"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-08.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer208"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soybeans")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a milk substitute made from dried soya beans, ground with water. It has been known from the Han dynasty 200 BC-50 AD. It can be used as a substitute for cow’s milk and is very important in Asia. Soy milk can be used alone as the replacement for dairy milk or to make other hot drinks or in cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.3 Soy Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy generally is made by emulsifying soy milk with an oil and often sugar or syrup and flour or thickener. It can be used alone or in cooking like dairy cream.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.4 Soy Yoghurt")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy yoghurt is made by fermenting soy milk in a similar way to dairy yoghurt using the same type of starter; in fact, you can make soy yoghurt by using a pot of dairy yoghurt as a starter, as in the case of dairy yoghurt. The small amount of dairy contents disappear quickly.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer209"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-09.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer210"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soybean paste")])])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.5 Fermented Soybean Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a fermentation of ground soybeans in brine to give a salty paste. It is widely used in Asiatic cooking. Its origin is in about the 1300s in China. Each country or each area has their own particular method of making bean paste.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-135",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-10.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.6 Tofu")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tofu is a form of curdled soy milk that has a soft cheese-like texture and is used after treatment to dry or to season to give a diversity of different products.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.7 Soy Sauce")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer212"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer213"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Soy sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soy sauce is made by fermentation of ground soybeans in a brine solution. It probably originated in China between 900 and 1100 AD. It is very widely used in Asia and today all over the world. It is available in many forms: light, heavy and thick or with other tastes such as oyster or mushrooms when the fermentation is carried out.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.8 Miso")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Miso originated in Japan and is a fermentation of soybean mixed with double the quantity of either rice or barley. Its colour ranges from milky coffee to chocolate. It is widely used in Asian cookery.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.9 Soybean Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soybean oil is extracted from the soybeans. This is done by crushing the beans and adjusting the humidity, followed by pressing and then removing the oil with hexane. The result is a liquid that is distilled and refined to give the pure oil. Soybean oil is one of the most used oils in cooking. It can be converted into a margarine-type cooking medium. It can also be used as biodiesel and for many industrial applications.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.10 Soybean Meal")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Soybean meal is the residue after oil extraction and is a very rich food for animals. It is heated and treated to remove any inhibitors that could interfere with protein digestion.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.11 Adzuki Bean Sweet Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This is a sweet, jam-like paste made from adzuki beans and is widely used in Asia to make bread and cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.12 Cellophane Noodles")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer214"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer215"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cellophane noodles")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Cellophane or glass noodles are starch noodles. In China, they can be made from mung beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.13 Guar Gum")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Guar gum is extracted from the guar or cluster bean by grinding and washing with water. The gum itself after refining is a half-white, free-flowing powder and is used widely in the food industry as a thickener and in many industrial applications.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.14 Carob Chips/Powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Carob chips and powder are made by roasting the carob and pulp and then grinding into chips or powder. Carob has the appearance of chocolate and is used as a substitute; however, the carob does not contain chocolate but another chocolate-like flavour and a sugar substitute, and is used to make types of sweets and biscuits. The carob has the advantage of not containing caffeine and is widely used in the alimentary industry as an additive.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.15 Mesquite Powder")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Mesquite powder exists all over Central and Southern America and the Southern parts of the USA. The powder resembles the carob powder but comes from different parts. The taste and use are different. The powder can be used as a sweetener. In other areas, it is used in tortillas.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.16 Tamarind Paste")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer216"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer217"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tamarind")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Tamarind paste is made from the pulp of the unripe tamarind pod and is generally sold in the form of cakes. It is used in cooking and in the preparation of chutneys and sauces, particularly in Worcester sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.3.17 Kudzu Beans (Japonese Arrowroot)")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The kudzu bean has a very large root that contains a lot of starch. The root is dried and ground to give a powder called Japanese arrowroot that is used to replace cornflour to thicken sauces and dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.4 Sprouting Grains of Leguminous Plants")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.4.1 Generalities")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer218"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-14.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-2"
  }, [_c('div', {
    staticClass: "Caption-R",
    attrs: {
      "id": "_idContainer219"
    }
  }, [_c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Korea’s Three Kingdoms (Goguryeo, Baekje and Silla)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space ParaOverride-14"
  }, [_vm._v("Sprouted grains of lots of different plants have become very popular worldwide. Many grains can be sprouted and are available in many shops an. At since the time of the Three Kingdoms, 57 BC to 668 AD, Korea was much bigger and included part of Manchuria, parts of the People’s Republic of China and of the Russian Federation. This period was very rich in the development of agriculture, culinary art and artisanal activities, particularly in jewellery.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Bean sprouts have been used in East Asia for centuries and are generally made from green mung beans, the larger yellow soybeans or soybeans.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Many plants can be germinated for consumpion, including cereals, crucifers, carrots and leguminous plants. The action of germination has a number of advantages: it makes the bean more nutritious, by increasing proteins, vitamins; it makes the bean easier to cook; and gives a different taste. For instance, wheat grains do not contain vitamin C but the sprouted wheat grain does.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous plants have a very important place in the sprouted grains. The following leguminous plants can be sprouted: peas, chickpeas, mung, soy, adzuki and kidney beans, lentils and fenugreek, as well as two forage plants, clover and alfalfa.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-136",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-15.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-137",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tSprouting mung beans\tSprouted soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Sprouted vegetable grains can be eaten raw, in a salad, stir-fried or in a dish. Today they are available everywhere and even tinned in lots of stores.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.4.2 Method of Sprouting Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The principle of sprouting is to soak the grains for a certain length of time, followed by keeping the grains warm and allowing germination to continue. This takes about two to seven days, in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Special equipment exists for sprouting but it can be done simply with ordinary kitchen equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following description is for soybeans and is representative of the process, but for smaller or larger grains the times will vary.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following is a detailed description of the sprouting process:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Before starting, the grains should be stored for 24 hours in the refrigerator. This is to stimulate sprouting.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The grains should be sorted to eliminate any debris or damaged grains and then washed again carefully in clean water. Wash the grains to eliminate any residues.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("Place the grain in a bowl, cover with cold water and soak for the indicated time on the packet. Should this be for more than 12 hours, the grains should be washed after 10 hours.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The next stages are carried out in a germination container as shown in the following photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-138",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-17.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Germination container")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Numbered-list-spaice",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("The rinsed beans are placed in a layer on the wet paper towel. The germinator is covered with a black cloth and a towel. Then you leave it for 24 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("In the next stage, the germinator is opened and the beans are washed and returned to the clean pot and covered with the cloth and left to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The next day the operation is repeated and continued for six days. This will depend on the type of seeds you use.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The sprouted beans are washed, and the sprouts removed carefully and sorted.")]), _vm._v(" "), _c('li', {
    staticClass: "Numbered-list"
  }, [_vm._v("The sprouts are ready for use and can be stored for up to four days in the refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-139",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-18.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Picture showing how beans are grown in soil")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.5 New Nutritional Values, Diet and Health")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.1\tNutritional Values")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables and derivatives of plants and trees have been consumed and used both for human and animal food from the earliest times, peas, broad beans, chickpeas and lentils were available over most of the world except The Americas. In Europe, beans came after the discovery of The Americas. Today, the leguminous vegetables are one of the principal foods used worldwide. They are particularly interesting as a source of vegetable proteins and thus interesting for vegans and vegetarian people. In some countries like India where the population is largely vegetarian, leguminous vegetables with rice, millet or wheat are the principal food.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Leguminous plants are rich in protein, vitamins and minerals and are gluten-free. The following tables give the nutritional value of:")]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.1.5. Table 4: Leguminous vegetables")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table027"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("14.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("5.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("79.8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dry Green Peas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("60.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("25.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Mangetout")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.7")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("73.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Chickpeas")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("61.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("19.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Green Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("90.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Dry Beans")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("63.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("21.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lentils")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("63.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("24.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("32.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Lupins")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("43.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("32.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Peanuts")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("49.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("26.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.15. Table 5: The nutritional value of soybean-derived products")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table028"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Oil")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("100.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Meal")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("40.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("46.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Milk")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("89.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Tofu")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.8")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("85.3")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Soy Sauce")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.9")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("8.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("86.9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Map-heading",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("5.1.5. Table 6: The nutritional value of common foods")]), _vm._v(" "), _c('table', {
    staticClass: "Basic-Table _idGenTablePara-1",
    attrs: {
      "id": "table029"
    }
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Carbs")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Protein")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Water")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table",
    attrs: {
      "colspan": "5"
    }
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("Weight in grams per 100g of product")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Dairy Milk")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("88.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("White Rice")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("80.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("7.4")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Wheat")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("71.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.5")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("12.6")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Maize")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("18.7")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("1.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("3.2")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("77.8")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Millett")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("72.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("4.3")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("11.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("13.7")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Potatoes")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("17.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.1")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("2.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("80.9")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Beef")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("16.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("26.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("37.0")])])]), _vm._v(" "), _c('tr', {
    staticClass: "Basic-Table"
  }, [_c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table-L"
  }, [_vm._v("Chicken")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("0.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("6.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("25.0")])]), _vm._v(" "), _c('td', {
    staticClass: "Basic-Table"
  }, [_c('p', {
    staticClass: "Text-table"
  }, [_vm._v("69.0")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Please note that these figures are indicative and if required for any serious work should be confirmed, as the real value can vary widely depending on the variety, the type of soil, the geographic location and the climate.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.2 Toxicity")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Most raw beans are toxic as they contain bitter molecules. These molecules are alkaloids, which are thermolabile so can be destroyed by heating. Dry or soaked beans need to be cooked in boiling water for at least 10 minutes. There have been accidents in which people have died after eating falafel made with beans that have not been sufficiently cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Raw lupins cannot be eaten uncooked and require soaking for a long time; they then need to be cooked to remove the bitter taste. Today sweet lupins are available but still require cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.3 Gluten")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables and derivatives are interesting for people with gluten problems since they contain no gluten. Derived leguminous products can be used in the place of gluten-containing foods. Some examples given in our book include: ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Bullet-list-first"
  }, [_vm._v("Green pea flour for making pasta")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea flour with maize for making polenta")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Lupin flour and flakes can be used for making bread cake")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Chickpea fries or socca")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Soy milk")]), _vm._v(" "), _c('li', {
    staticClass: "Bullet-list"
  }, [_vm._v("Tofu.")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.4 Dietary Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Leguminous vegetables are free from gluten but they have a fairly low carbohydrate content and are useful for low-carb foods.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas have been used for centuries around the Mediterranean to prepare street food and substantial meal bases. The often part-cooked chickpeas or dry beans are mixed with oil and water to make the famous falafel. In the more western parts, chickpea flour is mixed with water and used to make la farinata in Italy, which moved around the Genovese sailors to become socca in France and North Africa. In the south of France and particularly in Marseille, there is a street food called panisse. The chickpea flour is cooked in salted water, then poured into a mould, then left to cool. Once cold, it can be removed from the mould, then cut into chip shapes, and fried and sold like chips. It has a good taste and fewer carbs than French fries.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.5 Dairy Milk Intolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("People who are intolerant to dairy milk can use soy milk for drinking or for making bread, cakes and desserts. Today soy milk is available everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.6 Chocolate Intolerance")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("This intolerance can be solved by using carob powder or carob flour. In case of lactose sensitivity, a milk chocolate substitute can be made using soy milk and carob.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.7 Allergy")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Peanuts are well known to be allergic to certain people. Lupin is also known to be allergic. These two products have derived products that should be avoided by allergy sufferers.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("5.1.5.8 Animal Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The use of leguminous products and derived products is very important. The production of soy oil leaves a very rich residue that has changed cattle feeding worldwide. Leguminous grains like chickpeas, lentils and lupin now take a large part of the protein source in dog and cat food.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-2"
  }, [_vm._v("5.1.6 Evolution of the Use of Leguminous Grains and Gluten-Free Food")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("1. Human Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the past 10-20 years, the use of leguminous plants in Europe and America has changed, partly because of the increased intolerance to gluten and the increase of vegetarian or vegan ways of eating. Generally, most people have a more sedentary way of living, which means we burn fewer calories, bringing about an overweight population. This is a big problem all over the world. Generally, the use of vegetable protein and a reduction of carbohydrates can be helped by eating leguminous products that are free of gluten, are rich in vegetable protein and have a lower carbohydrate content than cereals or potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In India, for centuries, leguminous plants are one of the staple parts of food because most Indians are vegetarian and their basic food is rice and leguminous foods, which gives a very well-balanced diet.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("What we have seen is a replacement of cereals by leguminous products in our traditional foods. This means the replacement of cereals in pasta, breads and cakes. This is not totally new; for example, chickpea flour has been used for a very long time to make poppadums, a type of non-leavened bread. In Italy, chickpea flour was used to make socca, panisse and pudding and these foods spread all over the Mediterranean and even to South America.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will review very briefly the general position today:")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Galette and Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("These products can be made easily with the most leguminous flours.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Fresh Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Most leguminous flours can be used alone or combined with wheat bread flour. The method is more or less the same as with flour and eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Dried Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("The leguminous flours can be used alone or cut with durum wheat flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-140",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-19.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idGenObjectAttribute-141",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption-2-col",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("\tFresh green pea pasta\tCoral lentils penne")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-4"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("Breads and Bread Dough")])]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-5"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("Unleavened Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Unleavened bread can be made with a lot of leguminous flours. Typically in India, unleavened bread is made from chickpeas, lentils or other leguminous flours. This can be also mixed with wheat flour or other flours. So, there is a choice of gluten-free or low gluten.")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-5"
  }, [_vm._v("Leavened Bread")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("In the case of leavened bread, the case is a little more difficult, as if the bread needs to be leavened by yeast it will need gluten to rise, so in general yeast-leavened breads are low gluten made with a mixture of wheat or other gluten-containing flour and a leguminous flour or cooked seed. In general, for leavening and physical consistency it is important to keep to a little more than 50% cereal flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The other alternative is to use baking power to raise the dough and, in this case, it is possible to have only leguminous flour or products and obtain a gluten-free bread or dough.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In the majority of cases, it is difficult to obtain a good consistency, but this can be corrected by using products like cassava or arrowroot.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-142",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-21.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lupin cake")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_c('span', {
    staticClass: "bold _idGenCharOverride-1"
  }, [_vm._v("2. Animal Food")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-143",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-22.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Typical soy meal for cattle")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The leguminous forage plants, lucerne, vetch and clover, have been used for thousands of years to feed livestock; however, they are out of context here. Soy meal derived from the production of soy oil is very rich and has taken a very large place in dairy and beef production. The leguminous grains, chickpea, beans, lentils and lupin have taken an important place in dog and cat food.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-144",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-5-23.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Cat or dog food")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer369"
    }
  }, [_c('p', {
    staticClass: "Chapter-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v("Chapter 6\tIndex for Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v("6.1 Soup and Consommé Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v("6.1.1 Pea and Mangetout Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v("6.1.1.1 Green Pea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-145",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the shallot and leek finely and fry in butter in a large saucepan until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper, add the peas and the chopped mint. Keep some of the mint back to sprinkle on the soup before serving. Cover with the stock, bring to a boil and simmer slowly until the peas are soft. Cook for about 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow to cool and pass through the blender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Reheat and check the seasoning before serving. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("6.1.1.2 Green Pea and Shrimp Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-146",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Masala without chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l  Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Dried shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried shrimps for about 20 minutes and then boil for 10 minutes and drain. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the shallots and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, heat olive oil on medium heat and add shallots and garlic. Cook chopped shallots until soft. Add the white wine.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the wine has evaporated, add the chicken stock. Bring to a boil, then add peas and masala. Simmer for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the peas to cool and then pass in the blender to obtain the required consistency. Return to the saucepan, heat and add the shrimps before serving. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v("6.1.1.3 Split Pea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Split peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pork shanks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onion and carrots, chop the onions and dice the carrots. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas and water in a heavy saucepan, bring to the boil and cook for 2 minutes. Remove from the heat, cover and leave for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the two pork shanks, chopped onion, garlic, ground pepper and vegetable stock to cover, then simmer for 11/2 hours, or until the peas are tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the pork bones and allow to cool. Trim off the fat and discard. Remove the meat and cut into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return meat to the pan with the diced carrot. Check seasoning and simmer for ½ hour or until the carrots are tender. Sprinkle with parsley and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v("6.1.1.4 Mangetout Soup with Garlic Bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("650 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Small turnips")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Handful mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Slices of wholemeal bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the ends and string from the mangetout, cut the onion, cut the turnip into small pieces, chop the mint leaves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the vegetable stock into a large saucepan, add mangetout, onion, turnip and mint. Bring to the boil and simmer for 15-20 minutes until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cool and adjust the seasoning, pass through the blender to obtain a smooth texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the garlic, toast the bread and when cold rub both sides with garlic and cut into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the soup sprinkled with garlic bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.1.1.5 "), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v("Pease Pudding")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer232"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-003.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an interesting dish that comes from very early times. It was very popular in medieval times and comes from the earliest human civilizations of hunter-gatherers. It is made from marrowfat peas that are green or yellow peas that have been allowed to mature and dry on the plant and then harvested. Once harvested, they can be used directly or be milled or rolled to give split peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pease pudding is the subject of a nursery rhyme:")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pease porridge hot, pease porridge cold,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Pease porridge in the pot, nine days old;")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Some like it hot, some like it cold,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-no-space"
  }, [_vm._v("Some like it in the pot, nine days old.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(Songwriter(s) Unknown.)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v("Making Pease Pudding")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish can be made with either green or yellow split peas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Split peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the peas for 8-12 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash the peas, cover with water and cook for a least 1 hour or until the peas are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the peas and place in a bowl. Add a bit of water, mint, parsley, marjoram, half of the butter and the other ingredients and blend to obtain a smooth paste. To control the consistency, add more butter or water to obtain the consistency desired.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with boiled meat and bread. When used on its own, it can be served with a dollop of fresh cream. Season to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v("6.1.2 Broad Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v("6.1.2.1 Broad Bean Soup with Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-147",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-004.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Lamb stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop spring onions and garlic. In a saucepan add olive oil and heat. When hot, add onions and garlic. When they start to soften, add the cumin powder, lamb stock and broad beans. Cook for about 10 minutes. Check to see if the broad beans are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with harissa and lemon quarters as an accompaniment.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2."), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v("2 Dry Broad Beans with Lamb Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Lean lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight, drain and place the beans in a saucepan cover with water, add salt and peppers, 1 tbsp olive oil, bay leaves and simmer until the skins can be removed. Drain and remove the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. Slice lambs into strips. Heat a saucepan, adding olive oil, and fry the onions and garlic until they start to soften. Then add lambs, paprika and herbes de Provence. Seal the lamb then add the beans, then add enough stock to cover the lamb and broad beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for a further 10 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v("6.1.2.3 Cream of Broad Bean Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 kg Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Smoked ham")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer234"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-005.jpg"
    }
  })])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the broad beans from their shells and the light green skin.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil in a heavy saucepan, and cook the onions without colouring them. Once soft, add the beans and the herbes de Provence. Cook for 1 minute and add the stock. Cook for about 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the smoked ham into small squares and roast in a dry pan until coloured. Dry on absorbent paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the liquid and sieve. Reheat and serve in bowls sprinkled with the smoked ham. Season to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v("6.1.2.4 Broad Bean and Potato Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Shelled Broad beans. (If using old broad beans remove the outer skin.)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer235"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-006.jpg"
    }
  })])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanch the beans in boiling salted water for 3 minutes and cool in cold water. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut potatoes into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork into thin strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a saucepan, add onions and simmer. When soft, add garlic and pork and cook for 2 minutes. Add beans, herbes de Provence and sumac. Heat and turn for 2 minutes, add stock, potatoes and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the salt and add if necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls and sprinkle with coriander and paprika.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _vm._v("6.1.2.5 Broad Bean and Courgette Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer236"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-007.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium courgettes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 Single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions, cut courgettes into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat oil in a saucepan, cook the onions. When they start to soften, add courgettes, herbes de Provence and coriander powder. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the broad beans, cover with the stock. Cook until soft then add the cream, keeping a little back. Salt and pepper to taste. Cook for a few more minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast the bread then cut into little squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls pour and little of the cream in each bowl. Sprinkle the squares of toast over the top. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2.6"), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v(" Broad Beans with Red Peppers and Rice Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Clean and de-seed peppers then cut into strips. Peel the garlic. Pre-heat oven 180°C. Roast red peppers in the oven for about 20 minutes, until a bit crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan add water, 3 times the volume of rice, add salt. Bring to the boil then add the rice and paprika. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the shelled broad beans and roasted peppers to the rice. If necessary, add a bit more water. Cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast the bread. When toasted, rub with garlic, then cut into four.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with garlic toast.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.2.7 Cream of Broad"), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _vm._v(" Bean Pod Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-148",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-008.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an interesting recipe as it shows the use of broad bean pods that generally go into the bin or compost.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("20 Broad bean pods (very young pods)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Small new potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6-8 Mint leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the pods, remove the string and cut into small pieces. Peel and crush the garlic. Place the broad bean pods in a saucepan covered with water. Add garlic and olive oil. Bring to the boil and simmer for about 5 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Scrub the potatoes and cut them into small pieces. Put the potatoes in a saucepan cover with water, add mint. Cook for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the potatoes. Make sure you keep back some of the liquid. Then mix the potatoes and beans together. Season to taste, serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v("6.1.2.8 Syrian Foul Soup with Dried Fava Beans (Broad Beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Small bunch of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Pita breads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak dried broad beans overnight. Then drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Cut the tomato into cubes, chop parsley.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan. When hot, add the onions and garlic. When the onions are soft, add the tomatoes and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans in a heavy pan and cover with the vegetable stock.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add garlic, ginger, cumin, salt and pepper and bring to a boil. Then add the onions and tomato mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("With a potato masher, partly break the beans and cook over medium heat for 10 minutes. Then add the lemon juice. Serve hot with Pita bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: Today this soup is often made with other beans as the preparation of the dried broad beans is long, but worthwhile. Typically, the soup can be made with a mixture of canned broad beans and kidney beans. It should be noted that dried broad beans are very popular all over the Middle East and particularly in Egypt where they are used to make hummus and falafel, in place of chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-149",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-009.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v("6.1.3 Chickpea Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _vm._v("6.1.3.1 North African Chickpea Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large ripe tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sticks celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Flatbreads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic. Cut the celery and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a saucepan. Cook the onion, garlic and celery until the onions are soft. Add the chopped tomatoes, herbes de Provence, cumin and harissa. Add half the stock and cook for about 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper to adjust the seasoning. Add the rest of the stock and the chickpeas. Cook for another 10 minutes. Serve hot, with a sliver of lemon juice and with Arab-type flatbread. Sprinkle with coriander.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Harissa is a spicy paste made from red pimento mixed with cumin and coriander. It comes from North Africa and is very popular for couscous and other dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Arab flatbread is a yeast-based bread paste with olive oil and a mixture of flour and fine couscous. After raising it is rolled onto a cake type rounds about 1 cm thick and cooked in an iron pan.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-150",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-010.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Flatbread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _vm._v("6.1.3.2 Chickpea Soap Served with Spare Ribs")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This cheap and easy soup is very popular in Southern Italy where it is generally prepared with the local black chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Lean spare ribs, separated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Tomato Confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 kg Pre-cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Hot red pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Basil leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the carrots into chunks, then cut the celery into chunks.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a large saucepan and heat. When it’s ready, add the spare ribs. Cook on both sides until well brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the chicken stock, carrots and celery. Bring to a boil and simmer for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove scum and surface fat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the drained chickpeas, the sliced pimento and the basil. Continue cooking for 30-40 minutes. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and pepper and serve with olive oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v("6.1.3.3 Chickpea and Onion Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("An easy soup ideal for quick lunch on a winter sports holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Precooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Masala with pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Dried breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the onions into thin slices, peel garlic and crush. In a saucepan add oil and heat. Cook until the onions are soft then add the crushed garlic, herbes de Provence, Masala and tomato paste. Add the white wine, stir and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add salt and pepper to the washed and drained chickpea, cover with water and bring to the boil. Check the seasoning and pour into soup bowls. Cover with breadcrumbs and grated cheese, then put under the grill for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with a squeeze of lemon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v("6.1.3.4 Mexican Chickpea Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer240"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-011.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is an amusing dish with the fried egg put into the soup at the last minute.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the chickpeas in cold water for 24 hours, drain and rinse well. Cook them in water until soft, for about 1 hour. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions and garlic, then chop them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 2 tbsp of oil in a saucepan. When hot, add the chopped onion, garlic and mint. Cook until the onion is soft, put through the blender with 250 ml stock, and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cooked chickpeas through the blender with 300 ml of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the two mixtures into a pan, add salt and pepper to taste. Add the rest of the stock and mix together for about 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fry the eggs in the remaining oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To serve, pour the soup into the bowls and slide a fried egg into each bowl. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _vm._v("6.1.3.5 Chickpea Soup for Good Thursday")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In several Catholic countries, it is the tradition to ‘eat lean’ on the eve of and on Good Friday. Generally, meat is replaced by chickpeas. This soup is very popular all over Italy and in Corsica.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of toast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak chickpeas overnight. Drain the chickpeas, rubbing the chickpeas between your fingers to remove as much of the skin as you can. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the chickpeas in boiling salted water, adding garlic, oil, coriander and herbes de Provence. Cook for 20-25 minutes. Season to taste with salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with toast. (It used to be served with stale bread.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("6.1.4 Fresh Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Fresh bean soups can be made with young green, yellow or black beans or with mature but not dried beans like fresh flageolet beans or coco beans. In the case of young beans, they can be served just boiled, in which case, as for green peas, they should be boiled at a  minimum to conserve consistency, taste and vitamins. On the other hand, mature beans, whet fresh or dried, often contain toxic constituents which are thermolabile and can be destroyed by cooking; for this reason, mature beans should be cooked for a minimum of 10 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v("6.1.4.1 Green Beans Fresh Dill Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Large Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Chopped fresh dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Skimmed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large white onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Sour cream or yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-151",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-012.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the string and ends from the beans and cut them into 2 cm lengths, peel the potatoes and cut into cubes, peel the onions and garlic then chop.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the potatoes with water and boil until they are soft. Remove half and mash with a fork and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed pan, heat the oil and cook sliced onions and crushed garlic until they start to soften. Cook for a further 4-5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add onions, garlic and beans to the potatoes. Salt and cook until the beans start to soften (about 10 minutes), reduce the heat add the milk and the mashed potatoes with the chopped dill. Check seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in hot bowls with ½ tbsp of sour cream or yoghurt on top of the soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _vm._v("6.1.4.2 Fresh Shelled Beans Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Shelled fresh coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Stick of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions, carrot and garlic. Slice the onions, crush the garlic and dice the carrots. Chop the celery into slices. Slice finely the salted pork belly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed saucepan and heat the oil. Fry the chopped onions and pork until soft. Add chopped garlic and diced carrot. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbes de Provence, ground cumin, coco beans and the celery. Simmer slowly until the beans are cooked; the time will depend on the freshness of the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the seasoning and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _vm._v("6.1.4.3 Fresh Flageolet Bean Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer242"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-013.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh flageolet beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Celery branch")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Fresh single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g slices of salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Grated hard cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel onions, potatoes. Slice the onions and cut the potatoes into cubes. Chop the celery and leek finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a heavy pan, heat the oil. When it’s hot, add the onions and leek. Cook for 5 minutes. Then add the beans, potatoes, celery and stock. Cook slowly for 1 hour. Check seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pork belly in a dry pan until well browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the soup, add the cooked pork. Cook for another 5 minutes, then add the cream. Serve hot and sprinkle with the grated cheese.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _vm._v("6.1.4.4 Pesto Soup with Pesto Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-152",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-014.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a late-summer autumn soup that originated in Genoa and was carried from over to the Mediterranean by Genoese sailors and traders. Since that time, the recipes have evolved; at the present time, the pesto in Genoa, Nice or Marseilles are much the same, but each is different, so today there is no real pesto soup. We will give a typical recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients (for 8 people) for the soup:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Lean salted lard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh white coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Fresh red coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2  Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium courgettes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Leeks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5-2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for the pesto sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("Large bunch of basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the lard into thin strips about 2 cm long.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and dice the onions, potatoes and carrots. Cut the onions, potatoes and carrots into squares. Clean courgettes and leeks and then slice them. Shell the white and red coco beans. Cut fresh beans into about 2 cm slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put all the prepared ingredients into a heavy saucepan cover with water. Add salt and pepper and bring to the boil and cook for 30 minutes. Check the cooking: if sufficient, set aside; if not, cook a little more")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the pesto sauce, coarsely chop the basil with the stalks left on. Peel the garlic. Place the chopped basil, garlic, pine nuts and pepper and salt into a blender. Blend and gradually add the olive oil to obtain a nice texture. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the soup in bowls and put a spoon of the pesto sauce on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _vm._v("6.1.5 Dry Bean Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _vm._v("6.1.5.1 White Bean and Red Pepper Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer244"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-015.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dried white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the bean for 24 hours in cold water. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions, clean de-seed peppers and cut into small squares. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the oil into a heavy strong pan. When hot, add the onions and cook until soft. Add the peppers and cook while stirring for 5 minutes. Add the chicken stock, drained beans, bay leaf, herbes de Provence and spices. Bring to the boil and cook for about 40 minutes. Check cooking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If the beans are cooked, remove bay, add garlic and paprika. Check seasoning and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.2 Black"), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _vm._v(" Beans and Mushroom Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Boletus")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Clean and de-seed red pepper and slice into small sticks. Cut the mushrooms into slices. Wash the spinach, drain and cut finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, add olive oil. Cook the onions and garlic until they start to soften, then add the red peppers, herbes de Provence and cook for a further 2 minutes. Then add the sliced mushrooms. When they are cooked, add black beans and spinach. Cover with the stock. Bring to the boil. Cook for a further 15 minutes. Make sure the black beans are warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.3 Cream"), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _vm._v(" of White Bean and Boletus Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer245"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-016.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Boletus mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Double cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mace powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions. Clean boletus and cut them into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the white beans in a saucepan, add salted water. Bring to a boil and simmer for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat olive oil and cook the onions. When they start to soften, add the boletus and mace powder. Cook until the mushrooms are nice and brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the white beans and return them to the saucepan, then add the cooked onions and mushroom. Cover with the vegetable stock. Season to taste cook for a further 4 minutes. Add the cream then just heat through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls sprinkled with the chopped parsley and grated Pecorino. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _vm._v("6.1.5.4 Mexican Chilli Bean Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-153",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("70 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bell pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned kidney bean")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion and garlic. Clean and slice the bell pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the olive oil. When it’s hot, add the onion, garlic and bell pepper. Cook until the onions are soft. Add the flour slowly, stirring all the time, till you get a smooth paste, then add the chilli powder and water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the kidney beans and wash well. Then add this to the saucepan and cover with water. Season to taste and cook for 20 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.5.5. Japane"), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _vm._v("se Napa Cabbage and Tofu Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-154",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-018.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the soup")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cooked chicken")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cellophane noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Small Napa cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the broth")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Fish stock, made with dashi powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 ml Mirin (favoured sake)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Sake")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chopped coriander and spring onions for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Press and drain tofu cut into cubes. Chop spring onions and slice Napa cabbage into thick slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the broth, combine all the ingredients in a large pan and bring to the boil. Simmer for 5 minutes, add the cellophane noodles sliced and Napa cabbage, then simmer for 5 minutes and then add cubed chicken pieces and cook for a further 2 minutes. Make sure it’s cooked through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tofu and spring onions in the bottom of the soup bowls and cover with the broth. Serve warm. Sprinkle with coriander and spring onions.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _vm._v("6.1.5.6 Bok Choy and Shrimp Soy Milk Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-149",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-019.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Bok choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Dried shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak shrimps in warm water for at least ½ hour. Then drain the shrimps. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut onions and garlic. Wash the Bok choy and cut roughly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat of the butter. Cook the onions and garlic until they start to soften. Then add the shrimps and Bok choy. Fry for another 3 minutes, then set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, melt the rest of the butter, gradually adding the flour. Make sure it does not go lumpy. Then add the chicken stock slowly and add soy milk, coriander powder, masala and fish sauce. Bring to the boil and simmer for 3 minutes, Season to taste with pepper (normally you should not need salt, as the fish sauce is very salty).")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the sauce the onions, garlic, shrimps and Bok choy. Cook for a further 2 minutes. Serve hot in bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _vm._v("6.1.6 Lentil Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-155",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-020.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _vm._v("6.1.6.1 Red Lentil Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer250"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-021.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onions and carrots.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions in 1 tbsp butter. When cooked, add carrots, coral lentils, salt, pepper and stock, then cook for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the cooking: if tender, pass through the blender and return to the pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the bread into squares and fry in the rest of the butter.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the egg yolks in the milk in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the seasoning of the lentils, bring to a boil, add the eggs yolk mixture, stirring all the time, and serve sprinkled with herbes de Provence and toast. Serve immediately.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.1.6.2 Lentil C"), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v("oconut Milk and Lemongrass Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Tinned coconut milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Lemongrass springs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 mm Piece of ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Jasmine rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Kaffir leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the coral lentils, and drain peel and chop the onion. Cut the lime in half. Squeeze the first half with the rest cut into thin slices. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, add the vegetable stock, then the coral, lentils and onions. Bring to the boil and simmer for about 15-20 minutes. Check the lentils are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel garlic, lemongrass and ginger, slicing them into thin strips. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("While the lentils are cooking, cook the rice in boiling salted water for about 11 minutes. Drain and set aside, keeping it warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the lentils, the coconut milk, lemongrass, garlic, ginger, kaffir leaves, lime juice and sugar. Mix well and cook for a further 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In six bowls, place a good spoon of the rice. Then pour the lentil soup over. Garnish with the sliced lime and coriander. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-156",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-022.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Lemongrass")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _vm._v("6.1.6.3 Egyptian Red "), _c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Lentil Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin grains")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 g Red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Yoghurt and Lemon for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel onions, carrots and garlic. Crush the garlic. Slice onions, carrots and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the butter in a large saucepan and heat. When hot, add onion, carrots and garlic. Cook until soft (about 5 minutes), add cumin grains and coriander powder and cook for 3 minutes. Add tomatoes and cook until soft (about 2 minutes), add lentils and cook until soft, about 10 - 15 minutes. This does depend on the lentils. Season with salt.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in bowls with yoghurt and lemon. Sprinkle with the chilli powder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _vm._v("6.1.6.4. Lentils and Swiss Chard Soup")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer252"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-023.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Swiss chard leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Concentrated tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and check the lentils. Peel the onion, garlic and potatoes, cut the onion into fine slices, crush the garlic. Cut the potatoes into squares. Cut the chard leaves into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the water into a saucepan. Add the lentils and cook until they soften, then add the chard leaves and simmer for 15 minutes. In another saucepan, cook the potatoes in boiling salted water, for about 15 minutes. Drain the potatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook onion, garlic, concentrated tomato and coriander and when cooked add this to the lentils, then add the potatoes. Add lemon juice and cook for another 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _vm._v("6.1.7 Lupin Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _vm._v("6.1.7.1 Sweet Lupin Pumpkin and Sweet Potato Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Sweet lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 kg Pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("650 g Medium sweet potato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("350 g Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Medium curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 cl Cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Grated cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-157",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-024.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions, sweet potatoes, potatoes and pumpkin. Chop them all into small pieces. Roll the vegetables in 2 tbsp of olive oil and place on a baking tray. Roast for about 40 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the rest of the olive oil; when it’s hot, cook the sweet lupin flakes, stirring constantly to get a nice grilled look. Take them out of the saucepan and set them aside. Keep some cooked flakes back for decorating the soup.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the chicken stock, the roasted vegetables, curry powder and lupin flakes. Season to taste. With a blender, blend the mixture to get a smooth paste. Cook for a further 3 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the soup into the bowls. Drizzle the cream over the soup pour a bit of cream into each bowl. Sprinkle the grated cheese over the cream and sprinkle the grilled flakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _vm._v("6.1.8 Peanut Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _vm._v("6.1.8.1 Equatorial Peanut Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-102",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-025.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Freshly roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Large potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Beef or chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("135 ml Fresh single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped chives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and potatoes. In boiling salted water, cook the potatoes for about 15 minutes. Drain and set them aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half the butter and cook the onions until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the onion and butter in the blender with the peanuts, potatoes and a little of the stock. Blend into a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste into a saucepan with the rest of the stock. Stir and simmer covered for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the cream, season with salt and pepper and heat until hot. Sprinkle with chives and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _vm._v("6.1.8.2 Ghanaian Peanut Butter Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Ripe large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Creamy peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Red chilli paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop finely the onions, garlic and shallots. Wash and slice the mushrooms.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanche the tomatoes in boiling water, then drain. When cold, remove the skins, chop the tomatoes and blend to a paste with the tinned tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork into small squares. Mix with garlic, shallots and onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil in a frying pan. When hot, add the pork and garlic, shallots and onion. Cook for about 10 minutes. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 11/2 l of boiling water in a bowl. With a wooden spoon, carefully add the creamy peanut butter to give a creamy paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the creamy paste meat, tomatoes, red chilli powder and mushrooms. Place this in a saucepan and bring to a boil, then simmer for 20 minutes and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This soup is generally served with feta, or a cassava flour dumpling.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _vm._v("6.1.8.3 West African Peanut Soup")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-158",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-026.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Leaves of Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tin of tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Crushed peanut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the stems from the collard greens, discard the stems, cut the leaves into 3 cm squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add 400 ml of stock, onions, garlic and salt. Simmer for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tomato purée, peanut butter, and chilli powder into a blender. Blend until smooth. Add this to the rest of the stock.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Then add the collard greens and simmer for 15 minutes. Serve in bowls with the crushed peanuts sprinkled on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.8.4 Indian P"), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _vm._v("eanut Chaat")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer256"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-027.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Raw peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 cm Cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ginger, chopped finely")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/8 tsp Red chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Mango chutney")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts in a pan with 500 ml water and salt. Cook on medium heat for about 25 minutes until the peanuts are cooked. Drain the peanuts and allow them to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix all the ingredients except, tomatoes, cucumber and lemon juice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut tomatoes into four and de-seed. Cut the cucumber in thin slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix together tomatoes, cucumber and lemon juice, then add peanuts and toss with the sauce.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _vm._v("6.1.10 Tamarind Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _vm._v("6.1.10.1 Fish Soup with Tamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-159",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-028.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("800 g Pollock fillets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Small potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place the tamarind paste in a cup and cover with warm water. Cover and set aside. This should be done at least an hour before you start cooking, if possible.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel potatoes, onion and garlic, chop onion and garlic. Cut potatoes into rounds. Cut the Pollock fillets into bite-sized pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, heat the olive oil and fry the onions and garlic until they start to soften.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add potatoes and water. Drain the tamarind; only use the water the tamarind was soaked in. Bring to the boil and cook for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pollock fillet pieces and cook for a further 8 minutes until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste with salt and pepper. Add sugar. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _vm._v("6.1.12 Fenugreek Soups")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.1.12.1 Pumpkin Sou"), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v("p with Fenugreek and Alfalfa Sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Medium Pumpkin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp. Fenugreek seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("650 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Handfuls of alfalfa sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the onions into thin slices. Peel the pumpkin and cut into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil into a pan and heat then cook the onions until softened. Add pumpkin, fenugreek seeds, salt and pepper and cook until the pumpkin is soft. Mix to the consistency required and add the alfalfa sprouts. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-160",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-029.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_vm._v("6.2 Salads, Starters"), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _vm._v(", Snacks, Breads and Sauces Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _vm._v("6.2.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _vm._v("6.2.1.1 Green Pea Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Grated horseradish")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Paprika, salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanche the peas in boiling slightly salted water for 2 minutes. Pour into cold water and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the peas and place in a salad bowl. Add the mayonnaise, Dijon mustard, horseradish and season with salt and pepper. Sprinkle with paprika and refrigerate before serving. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _vm._v("6.2.1.2 Mangetout Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-161",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-030.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Vinaigrette")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove ends and string from the mangetout. If very young, use as they are. If slightly hard, blanch for 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the mangetout, add vinaigrette, mix and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _vm._v("6.2.1.3 Green Pea and Bacon Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer260"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-031.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people;")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Young fresh peas or frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Slices of lean bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Vinaigrette")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("For the frozen peas, put them into cold water and allow them to thaw. Put the defrosted peas in a saucepan and cook in boiling salted water for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fry the slices of bacon in the oil until slightly crisp. Allow them to cool. Slice the bacon finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the onion very finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas into a salad bowl, add the bacon, onions and vinaigrette, then stir well. Check the seasoning. Be careful, as the bacon is salty.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _vm._v("6.2.1.4 Green Peas and Vegetable Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 tbsp Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the potatoes and carrots, then cook for 15 minutes in salted water: they need to be just cooked – not too soft. Drain and allow cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the potatoes and carrots into small cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the parsley and mix with mayonnaise.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all the vegetables to the mayonnaise and mix. Adjust seasoning to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _vm._v("6.2.1.5 Mangetout, Beetroot and Orange Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Cooked beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Orange")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends and remove the strings from the mangetout. Cook lightly in salted water for about 5 minutes: they should stay crispy. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the beetroot and cut into small strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and slice into fine slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a sauce with salt, pepper, lemon juice and olive oil. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the orange, separate the segments and remove the skin. Mix all the ingredients together. Serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _vm._v("6.2.1.6 Erbswurst German Green Pea Flour and Sausage Meat")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-162",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-032.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Erbswurst")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a survival food developed in Germany during the French-Prussian war. The German army requested Heinrich Gruenberger to find a replacement for the pea and pork soup generally served to troops as this was messy and difficult to keep. Gruenberger came up with Erbswurst, which is a saucisson made from dried pea flour and meat. This product was adopted by the Prussian army with a lot of success. The product was later developed and sold by Knorr, a German food and drink company. It is still very popular with hikers, climbers and sailors as survival food, and is also used by householders as a snack or as a quick base to make soup or a dish. Erbswurst is easy to make at home and can be conserved for a long time in the fridge. This is a typical recipe:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("350 g Fresh pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Pork fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Pea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("18 g Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 g Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 g Ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 g Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Wax paper tubes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Slice pork belly and pork fat into 5 mm cubes. Cook slowly in a frying pan until just golden brown. Set aside. Cut onions very finely and fry in fat slowly until slightly browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pork and onions together. Cook this for about 15 minutes; it must be well cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the pea flour with the other ingredients, stirring continuously, till you obtain a stiff paste. Keep warm to avoid setting.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a wide-mouthed sausage funnel and fill the casing with the paste, using a wooden dowel to push the paste into the casing and to remove all air. Once filled, tie with string and allow to set. The casing can be artificial sausage or waxed paper tubes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can then be kept in the fridge and used either cut into slices and served with a salad or vegetables. But it is mainly used in soups again cut into slices and put into the soup.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _vm._v("6.2.1.7 Fresh Pasta with Green Pea Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer262"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-033.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Green pea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Extra flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl lightly beat the eggs. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the green pea flour and salt in a salad bowl and mix together. Gradually add the oil. Make a well in the middle of the flour and pour in the eggs. Stir gradually so that it does not go lumpy, making sure the pasta has a firm consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the work surface and knead the pasta to obtain an elastic ball. This must be well kneaded, or else you will have problems when you put it through the pasta machine. Then wrap it in cling film, place it in the fridge and leave it overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Work the pasta by hand, or by machine if you have one, to produce tagliatelle. Keep it covered to keep the moisture, as it tends to dry out quickly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pasta for about 2 minutes in salted boiling water and serve with your choice of sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _vm._v("6.2.1.8 Arancini: Rice Balls Stuffed with Bolognese and Green Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("An Italian street food popular in Sicily and southern Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-163",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Desktop\\Nouveau dossier\\PIC_0344.JPG",
      "src": "image/Stribling-6-034.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for the Bolognese")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Minced beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Thick slice of Bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/3 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Red wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Tomato coulis")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for the rice")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Arborio rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pinch of saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Spanish paella spice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("25 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Ingredients for coating")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Beaten egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Dried breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the Bolognese")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion and garlic. Cut the bacon into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy pan and cook the bacon until brown. Add onions and cook for 5 minutes, then add garlic. Cook until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add minced meat and cook until browned. Add spices and herbs, salt and pepper, plus the red wine, and cook until the wine has evaporated. Add the tomato coulis and cook very slowly for about 1 hour until you have a thick sauce. Check from time to time to see if it needs any more water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peas and cook for a few minutes until the peas are cooked. Set aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the rice")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Use a rice cooker, add twice the volume of water to the arborio rice, with a pinch of salt, the saffron and Spanish paella spices. Cook and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the rice is cool, add egg yolk and grated Parmesan and mix together well, getting a nice pasta texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cold, place in a bowl. Cover with cling film and place in refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("To finish")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("With the cold rice pasta, roll into balls. Place the ball into your hand and make holes in the middle. Fill each hole with Bolognese sauce and cover with more rice paste and form into a ball. Set the balls aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat up a deep fat fryer. Place the beaten egg in a bowl and the breadcrumbs on a plate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dip the balls first into the beaten egg and then in the breadcrumbs to coat. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When all the balls are covered, cook them in very hot oil until golden brown. Remove and put onto absorbent paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot with the rest of the Bolognese sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _vm._v("6.2.1.9 Grass Peas and Tomatoes on Drum Bread Toast")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish comes from the poorer areas of central and southern Italy and was the staple food for many.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Dried grass peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Small dried tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Slices of durum wheat flour bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Parsley and mint")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the grass peas and soak overnight. Drain and rinse well, then cook in slightly salted water for 2 hours. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the dried tomatoes. Peel and chop the garlic. Chop up the parsley and mint.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil then fry the dried tomatoes, chilli powder and garlic until soft. Add drained peas, half the chopped parsley and mint and a little hot water to obtain a thickish consistency, like pasta. Cook on low heat so that it does not stick.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Toast four slices of the durum flour bread. Spread the grass pea pasta onto the toast and serve warm. Sprinkle with the rest of the chopped parsley and mint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _vm._v("6.2.1.10 Green Pea and Chickpea Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("125 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C. Line a square baking tin with greaseproof paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together the chickpea flour, paprika, cumin seeds and half the salt. Then gradually add a little of the water to obtain a nice paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the peas in boiling salted water for about 5 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the rest of the water in a saucepan, then heat it. When it reaches boiling point, gradually add the chickpea flour mixture, whisking all the time to avoid it going lumpy and gradually getting a nice pourable paste. Add the cooked peas. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into the baking tin. Make sure you spread it evenly. Cook for about 15 minutes. When it’s cold, cut into 3-cm squares. Serve warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("You can also prepare this in advance and keep the squares in the fridge. To use, heat olive oil in a frying pan. When hot, fry on both sides till brown. Serve warm or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _vm._v("6.2.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _vm._v("6.2.2.1 Young Broad Beans and Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe must only be used with very young and immature broad beans, which in general means from your own garden, or from a very good greengrocer. In this case, the beans should be served along with a little salt and olive oil.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _vm._v("6.2.2.2 Broad Bean Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-164",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-035.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Small tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Juice of lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the tomatoes in half. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl mix together olive oil, sumac, crushed garlic and lemon juice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a salad bowl add the shelled broad beans tomatoes and sauce. Mix together well and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _vm._v("6.2.2.3 Broad Bean Dip")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer265"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-036.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 1 bowl:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dry broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried broad beans overnight. Wash and drain them well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onion and garlic; do not cut.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the broad beans in a saucepan, then cover with water and bring to a boil. Cook until soft, but not too soft. Drain leave to cool. When cool, remove the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a food processor, place broad beans and all the other ingredients. Then blend to make a sauce. Check seasoning, adding salt and pepper to taste.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _vm._v("6.2.2.4 Grilled Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of one lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat the grill. Coat the non-shelled beans with a small quantity of olive oil, then place them on a grilling rack. When the grill is hot, place the broad beans underneath.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Turn them now and then until blackened all over. Remove from the grill and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the shell before they get a too cold. Season with olive oil, lemon juice, salt and pepper, and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _vm._v("6.2.2.5 Fried Dried Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer266"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-037.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A popular Mediterranean aperitif snack, particularly in Portugal.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for one bowl:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dried broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Vegetable oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans for 2 days. Rinse with fresh water each day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash the beans, put them into 4 litres of slightly salted water and cook for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and allow the beans to cool. Remove the outer skins and separate the two halves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dry the beans. Heat the oil: when hot, fry the beans until browned. Put onto absorbent paper to remove oil. Season with salt and pepper and serve. Note the fried beans can be stored in jars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _vm._v("6.2.2.6 Stir-Fried Fresh Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled fresh broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Hot Sichuan pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Rice wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp White wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Red bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the beans in boiling salted water for 4 minutes. When you drain the broad beans, keep a cup of the water the broad were cooked in for later use. Let the broad beans cool, then remove the outer skin of the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat olive oil in the wok, add broad beans and toss for 1 minute. Add all the ingredients, except sesame seeds, and continue tossing for 2 minutes. Add 2 tbsp cooking water and continue tossing 2 minutes over high heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Just before serving, sprinkle with sesame seeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _vm._v("6.2.3 Chickpea")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-165",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-038.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Chickpeas have been a street or finger food for eternity. Known in Greece and Rome, they have always been used as a snack. Some 2000 years ago, in Genoa, it was found that the chickpea flour mixed with water and cooked generally by frying gave a delicious dish. This was the origin of fried chickpea paste. This came in many different forms, which were transported all around the Mediterranean and even to South America by the Genoese sailors and traders. We will see the modern plants derived from these old ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _vm._v("6.2.3.1 Socca, Farinata, Chickpea Pancake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer268"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-039.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("(La Farinata in Italy, Socca in Southern France)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("900 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, add the chickpea flour. Gradually add the water to get a nice smooth paste and set aside and cover. Leave for 24 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oven to 220°C. Pour olive oil into a flat paella-type oven dish and heat. When hot, add the flour mixture and cook for 30 minutes. At the end, move to a heated grill to brown the top of the dish. Serve hot with ground pepper and Genoese pesto. See recipe below.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _vm._v("6.2.3.2 Genoese Pesto Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic, crush pine nuts and chop basil. Place these ingredients into a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the olive oil, mixing into a smooth paste, then add the grated Parmesan and Pecorino cheese. Make sure it’s all mixed together well. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Refrigerate before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be served with pasta, or on toast – I like it served with jacket potatoes!")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _vm._v("6.2.3.3 Chickpea Fries (Panisse)")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer269"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-040.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is typical street food on the Mediterranean coast from Genoa to Marseilles.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pinch of Sriracha or paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the garlic. Put the water into a large saucepan, add garlic and bring to a boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the heat. Add the chickpea flour gradually, stirring all the time. Once the flour is well mixed, add a pinch of sriracha then return the saucepan to the heat and continue cooking for 10-15 minutes until the pasta has thickened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the pasta into a mould and allow it to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the moulded Panisse into suitable forms and fry in olive oil until browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In Marseilles, the Panisse is normally sold in the form of chips in the street but can be cut into other forms for use as a side dish, as seen below")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _vm._v("6.2.3.4 Chickpeas Polenta Fries")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a variation of the Panisse, popular in Liguria in Italy. It is a mixture of chickpea and polenta. It has a different taste and is more consistent in texture.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people (Measures are given by volume for ease):")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 vol Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 vol Polenta, small-grained")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("7 vol water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put water in a saucepan. Add salt and stir in the chickpea flour. Once incorporated into the liquid, bring to the boil whilst stirring. Continue stirring for 3 minutes and then add polenta. Keep stirring for another 3 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the paste onto a greaseproof paper, cover with a second sheet of paper, roll to the desired thickness and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once cool, the pasta can be cut into desired shapes and fried in olive oil. This is cooked in the same way as the chickpea fries.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _vm._v("6.2.3.5 Chickpea and Chestnut Crackers")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for a dish:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Chestnut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/ 2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl mix together the chickpea flour, chestnut flour, Herbes de Provence, masala and salt.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a well in the middle of the bowl. Gradually add the olive oil, then water, arriving at a nice dough-like texture that can be rolled out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan: do not add oil. When it starts to smoke, add the sesame seeds, tossing all the time. This will be very quick. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste on greaseproof paper and cover with a second sheet of paper. Roll out the paste to the thinness you want. Remove the top paper, sprinkle with sesame and replace the paper to make the sesame seeds penetrate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer paper to an oven plate. Cut the paste into, say, 4 cm cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook in the oven for about 15 minutes. The real time will depend on the oven; you must watch when cooking it for the first time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _vm._v("6.2.3.6 Bread Rolls with Chickpea Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 12 rolls:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250"), _c('span'), _vm._v("g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("159 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pots of yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tsp Backing powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Whey or water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat the oven to 250°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix the chickpea flour, wheat flour, salt and baking powder together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the yoghurt with the vinegar and add to the mixture. Add the water, mixing progressively to obtain a paste that is supple but does not stick. Knead until homogeneous.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste onto greaseproof paper. Roll into a cylinder and divide it into 12 pieces. Roll each piece into a ball.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the greaseproof paper on a baking plate. Slightly flatten each roll, cut across with a sharp knife and loosen the top. Put it into the oven and cook for about 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note, these rolls can be made gluten-free by replacing the wheat flour with rice flour or chestnut flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _vm._v("6.2.3.7 Fresh Pasta with Chickpea Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer270"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-041.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Lightly beat the eggs together, one at a time.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the flour and salt in a salad bowl and mix together. Gradually add the oil. Make a well in the middle of the flour, pour in the eggs and mix together to make a homogeneous paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the work surface and knead the paste to obtain an elastic ball. Wrap in cling film and keep in the fridge for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Work the paste by hand, or by machine if you have one, to produce tagliatelle. Keep covered, so that it does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pasta for about 2 minutes in salted water and serve with your choice of sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _vm._v("6.2.3.8 Chickpea Crackers")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Poppy seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chickpea flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-166",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-042.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the chickpea flour, salt, herbs, and spice in a salad bowl. Keep the sesame and poppy seeds for later.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add olive oil and incorporate. Add the water to obtain a paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the paste on a lightly floured work surface and knead. Add flour if the paste is too sticky. Once the paste is homogeneous and supple, roll progressively. Sprinkle the flour to keep the paste from sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the required thickness is ready, roll between sheets of greaseproof paper. Remove the upper sheet and dampen with water very lightly with a brush. Sprinkle with half the sesame and poppy seeds. Cover roll to insert the grain. Return and repeat on the other side.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the upper sheet and cut into desired shapes. Put the paper onto a baking plate and cook for 15 minutes. Allow it to cool in the oven with the door open.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _vm._v("6.2.3.9 Hummus (Chickpea Dip)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-167",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-043.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Hummus is a chickpea dip. It was once used all over the Middle East, but today all over the world. In Egypt, it is made from boiled dried broad beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Tahini")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A mixture of olive and sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few sprigs of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas. Peel and crush the garlic. Keep a few chickpeas back for decoration.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the chickpeas, garlic, lemon juice and tahini in a blender. Turn slightly and progressively add the olive and sesame oil to obtain a very thick paste. Place in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Decorate with the springs of coriander and whole chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with Arab bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _vm._v("6.2.4 Fresh Bean Salads and Starters")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("All types of fresh beans are of different shapes and sizes. Some young beans can be eaten raw; as they get older, they have to be cooked. In the case of certain beans like coco beans these would have to be cooked first for at least 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _vm._v("6.2.4.1 Fresh Slender Green Beans and Basil Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer273"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-044.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends of the green beans and remove the string. If necessary, cook the beans in slightly salted water until softened but still crunchy. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel red onions and garlic. Crush the garlic, slice the onions very finely. Chop the basil. Place the green beans and sliced onions in a salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a vinaigrette sauce with garlic, salt and pepper with the wine vinegar and olive oil. Add the basil, mix well, then pour it over the beans and onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave this for about 10 minutes. This help to take the fire out of the onion, but if you like the strong onion flavour, don’t leave for 10 minutes. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _vm._v("6.2.4.2 Fresh Yellow Bean, Red Peppers and Anchovy Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Fresh yellow beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Red pepper confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Desalted anchovies")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few leaves of basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the ends off and check beans. Cook in salted water for 2-3 minutes, drain, cool in cold water and dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and crush garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the beans are cold, place the cold beans and add the peppers and anchovies. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the vinaigrette sauce with olive oil, vinegar garlic, Dijon mustard, salt and pepper, mix together well, then add the basil. Pour this over the beans.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _vm._v("6.2.4.3 Flat Green Bean and Feta Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer274"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-045.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Flat green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Feta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Sweet onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take off the ends of the beans and remove the string, if necessary, cut into 2 cm lengths and cook in salted water for about 3-4 minutes, drain then rinse in cold water and dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the feta into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the sauce with mustard, sesame oil and balsamic vinegar. Season.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans and onion into the salad bowl, add the vinaigrette and mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the feta and incorporate, taking care not to break the cheese. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _vm._v("6.2.4.4 Salad of Fresh Cranberry Beans, Cockles and Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh cranberry beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Cockles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Celery stick")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sherry vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("A few green salad leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the cranberry beans in a large pan with half the herbes de Provence. Cover with water and cook for 20-35 minutes. Drain and leave to cool. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the cockles and scrape the mussels. Discard any cockles or mussels that are broken. Put them into a large saucepan with the wine and the other half of the herbes de Provence, cover, and heat rapidly to open, shaking the pan often. Drain the shellfish, keeping 100 ml of the juice back. Discard any cockles or mussels if they have not opened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the tomatoes, celery into small cubes. Chop the dill. Put into a salad bowl with the drained beans, the olive oil, the lemon juice from the shellfish and the sherry vinegar. Mix and season with salt and pepper. Add the shellfish. Turn and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _vm._v("6.2.4.5 Green Bean and Bacon Bundles")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-168",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-046.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Slices of thick-cut bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat the oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash trim and check the green beans, season with salt and pepper. Peel the garlic and slice thinly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make 10 bundles of the beans, then wrap the bacon slices around the green beans. If need be, use a toothpick to hold them together. Grease a non-stick oven plate with olive oil. Place the bundles on the non-stick plate with the joint down to avoid opening.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a small saucepan, add the butter, heat, then add the sugar and garlic. When hot, brush the mixture over the bundles.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the bundles with aluminium foil and cook for 35 minutes. Remove the foil and cook for a further 15 minutes. This can be served hot or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _vm._v("6.2.4.6 Edamame Soybean Aperitif")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The edamame bean belongs to the soy genus and was known in Japan as long ago as the AD 600s. It resembles a broad bean but is a soybean type. It is popular in Japan as an aperitif dish in a similar way to the yellow lupins in Spain and Portugal,")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("To prepare, blanch beans in salted boiling water and then drain. Make a mixture of salt and sugar. Toss the beans in the salt and sugar. Heat a hot plate or a frying pan. Cook the beans. When the plate is very hot – just for a few minutes – serve.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _vm._v("6.2.5 Dry Bean Salads")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Most dry beans are interesting for making salads. However, virtually all dry beans contain toxic alkaloids. These molecules are thermolabile and are destroyed by cooking. It is therefore important that dry beans be soaked and cooked before using. It is also possible to make salads with bean sprouts from most beans. Germination of beans sprouts is dangerous as the germination takes place in the ideal conditions for microbial development. Therefore, unless one has some serious experience, it is better to buy the beans sprouts from an authorised dealer.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _vm._v("6.2.5.1 White Bean and Green Pepper Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Green peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Hard-boiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight in water. Drain and rinse well. Then cook in lightly salted water for about 2 hours until soft. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. Clean and de-seed peppers and cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make a vinaigrette with salt, pepper, garlic, vinegar, olive oil and Dijon mustard. Peel and chop the eggs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans, onion and peppers into a salad bowl. Add vinaigrette and mix. Place the chopped eggs on top and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _vm._v("6.2.5.2 Black Bean and Sweet Corn Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-169",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-047.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Ripe avocado")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few springs of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("For the dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Juice of a lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Open and drain the black beans and sweet corn. Rinse very well. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Clean and de-seed red pepper and cut into long strips. Wash the tomato and cut into quarters. Slice the spring onions finely. Cut the avocado into two, then twist it: this makes it easier to remove the stone. Peel the avocado and slice. Chop the coriander roughly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place all the ingredients into a salad bowl, mix together well, making sure you do not break the avocado slices up.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_c('span', {
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Peel and crush the garlic. In a small bowl, add all the ingredients for the salad dressing and mix together well. Then pour over the salad and serve.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _vm._v("6.2.5.3 Red Bean, Rice and Shrimp Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Basmati rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Skinned shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wasabi")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, add water and salt. Bring to the boil and add the basmati rice. Cook for 9 minutes, stirring now and again. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the sauce with the sesame and olive oil, rice vinegar, soy sauce and wasabi, seasoning with salt and pepper if necessary. Put the sauce in a salad bowl")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add beans, rice and shrimps to the sauce and mix.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _vm._v("6.2.5.4 Sushi with Mung Bean Sprouts Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-168",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-048.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Packet sushi sheets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece pickled daikon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Mung bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("51 tbsp Nuoc mam")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wasabi paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the rice in the rice cooker with a pinch of salt, or in boiling salted water for 10 -15 minutes, till cooked. Drain. Then place in a bowl and add the rice vinegar and sugar. This will help the rice to stick together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanch the spinach in boiling salted water until it’s soft, then drain. Make sure it’s well-drained. Then cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To make the omelette: in a bowl, beat the eggs, adding a little water and salt. In a frying pan add the sunflower oil. When it’s very hot, add the egg mixture. Cook until golden. Place on a plate and let it cool down. When the omelette is cold, cut it into 1-cm strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the cucumber and daikon into strips about 5-mm square, the same length as the seaweed sheets.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the mug bean sprouts and bring to a boil in salted water. Turn off the heat and leave for 2 minutes. Drain and press to remove water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prepare the sushi as instructed on the packet with a layer of rice covered with a small layer of bean sprouts, a strip of omelette, a strip of cucumber and a strip of daikon. Seal with water and place the joint on the bottom of the dish.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the sushi into 5 cm lengths. Then place in bowls the soy sauce, nuoc mam and wasabi. Sometimes I serve it with lettuce leaves. Any rice left over, serve in a bowl.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _vm._v("6.2.5.5 Korean Style Mung Bean Sprouts Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer278"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-049.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("350 g Fresh mung bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of spring onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel garlic and clean spring onions. Chop them both finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Rinse the mung bean sprouts in water, drain, and put in the water with the salt. Bring to a boil and cook for 2 minutes. Drain and rinse under cold water. Dry them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mung bean sprouts into a bowl. Add onion, garlic soy sauce and sesame oil. Mix together well. Check seasoning and add salt if necessary. Serve cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _vm._v("6.2.5.6 Salad of Coco Beans with Cockles and Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-170",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-050.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh white coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Mussels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Cockles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bouquets garni")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Branch of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lime")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few leaves of green salad to decorate")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the white coco beans in a saucepan with one bouquet garni and cover with water. Bring to a boil and simmer for 30-35 minutes, until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the cockles and scrape the mussels. Put the cockles and mussels in a cooking pot with the white wine and the other bouquet garni. Cover with a lid. It will not need a lot of cooking, about 5 - 7 minutes. Just check to see if they are open. Heat the pot on the stove to open the cockles and mussels, shaking the pot during the cooling. Drain the mussels and cockles, keeping 100 ml of the juice. Remove the shells.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash the tomatoes and dry them, cutting them into small pieces. Peel and chop the garlic and shallots. Cut dill finely. Put all into a salad bowl with the shellfish with the drained beans. Add lime juice, olive oil and vinegar, dill, salt and pepper, and mix all.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the shellfish and the cooking juice. Mix and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _vm._v("6.2.5.7 Peppers Stuffed with Black Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer280"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-051.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("8 Peppers (mixed colours)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cayenne")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the chicken into squares. Peel and chop finely onions and garlic. Drain the black beans and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the top of the peppers, then clean out the insides, removing all seeds and fibres. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan, heat olive oil. Fry onions and garlic until they are soft, then add chicken pieces. Cook until the chicken is golden. Then add herbs and spice and glaze with the white wine. Then mix this with the cooked rice and black beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stuff the peppers with this mixture. Then place the stuffed peppers on a baking tray. Add a little water. Cover with foil and cook for 20 minutes. Take off the foil and cook for a further 20 minutes. Check with a knife that the peppers are cooked. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _vm._v("6.2.5.8 Tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-171",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-052.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients to make one block of tofu:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 l Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Magnesium chloride")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large saucepan, bring the soy milk to boil, then allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dissolve the magnesium chloride in a little water then gradually add this to the cooled soy milk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The curds will start to appear. Allow to stand for 30 minutes. Line a square baking tin with sides with cheesecloth, making sure that the cheesecloth is big enough to cover the whole baking tray. Then pour the mixture through a colander into the lined baking tray. Then cover the top with the cheesecloth. Place some weight on top of the cheesecloth. Then allow to stand for about 30 minutes in a cool place.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove the tofu block from the cheesecloth. It is now ready for use. You can cut cubes or slices as you wish to use. You can keep the rest in the fridge ready for use another time. It must be kept in water.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _vm._v("6.2.5.9 Grilled Tofu and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer282"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-053.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Block of tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Baby tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Hot black fermented paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onion in round rings. Slice the 1 tomato into slices. Leave the 3 baby tomatoes whole.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Choose a block of tofu that is nice and firm. Cut onto slices of 4 mm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take an iron griddle and put it on the heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Coat the grill with a little oil and start by grilling the tomatoes and onions. When they start to get soft, add the slices of tofu and grill on both sides. Make sure the tofu slices are nice and crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a small pan, add a little water and the hot black fermented paste. Serve with the hot black fermented paste mixture and heavy soy sauce in small bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _vm._v("6.2.5.10 Soy Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-172",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-054.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Making soy sauce is a very long and smelly process. But the results are wonderful. You can buy the fermenting agent Koji on the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1.200 g Soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.200 Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Koji starter (quantity to use is marked on the packet)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3.8 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("850 g Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("a) Making the soy sauce base")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pod the soybeans, then rinse them in cold water, discarding any that are old.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the soybeans in a larger pot. Cover and soak overnight. Drain and replace with clean water and drain again.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place soybeans in a large saucepan covered with freshwater. Cook for 4-5 hours on low heat. You can test to see when they are cooked: you should be able to mash the soybeans with your fingers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the soybeans and mash them into a smooth consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the wheat flour gradually to the soybeans. This should finish up like a dough mixture. Knead the mixture just like you would for bread.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make sure the mixture is not too hot. This is when you need to add the Koji starter mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer the mixture to a tray 8 mm deep. Spread the mixture out in the tray. Use your fingers to make furrows, just like when you put seeds into a tray to germinate. But do not cover it over.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the mixture to rest for 2 days in a warm humid place. The bacteria will start to develop. You will start to see this: it looks a sort of green colour. After two days, we now start the fermenting brine mixture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("b) Fermenting and pasteurising the sauce")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("As this is a very long process, you have to choose a place where you can place the Koji (this is the name given to the mixture). As this ferments, it really smells.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Dissolve the salt into 3.8 litres of water. Mix this well till all the salt has dissolved. This is the brine mixture. Mix the koji and brine together to create moromi (this means fermentation mash). The koji mix will not separate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Now place the mixture into a large earthenware jar that has a good lid. This jar needs to hold about 7.6 l of liquid, which leaves you room to stir it.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the brine over the top of the mixture. You will need a long spoon for this. Stir the mixture well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Keep the moromi in a warm place and stir daily for a week. Make sure that the temperature is stable and the lid is on tightly. This will really smell – it’s normal!")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir the moromi once a week for the next 6-12 months. The longer you leave it the stronger it will be. This is where it really starts to ferment.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the fermentation has finished, strain the mixture through a cheesecloth, making sure that you get every last drop of the liquid. It’s the liquid that you will use for the next stage. Discard the moromi mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the liquid into a saucepan ready to pasteurize the soy sauce. Heat the soy sauce over medium heat. Use a thermometer to ensure that the soy sauce stays at the same temperature of 90°C for 20 minutes but must not boil. When this is finished, transfer the soy sauce into heat-proof pots. Test with a sugar thermometer to monitor the temperature.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Now that the soy sauce is pasteurized, you can store it in a pot or several pots and store it in the fridge. This is now ready to try. It can be stored for up to three years.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: It’s long and smelly but the end result is worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _vm._v("6.2.5.11 Coco Beans with Cod Paste (Brandade De Morue)")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-173",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-055.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Brandade de morue (cod paste) is a French dish from the town of Nîmes in Southern France. It is made from morue (dried salted cod) that has been soaked in water to remove the salt and is then mixed with milk and olive oil to make a paste. It is very popular in the South of France as an aperitif or with starters. The tradition of using dried salted cod in the Mediterranean areas goes back to the fishing fleet of Northern Europe bringing their catches to the Mediterranean ports to exchange the cod for salt, olive oil, wine and other products such as fruits. It’s very similar to the bitter Seville oranges that found their way to Dundee and produced the famous Dundee marmalade.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the cod paste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: for 6 people")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Dried salted cod")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Warm milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Glass of cold milk")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried salted cod in cold water for 48 hours, changing the water 4 times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the fish and put in a saucepan with water. Heat and just before boiling, add a glass of cold milk. Remove from the heat and allow to stand for 10 minutes. The cod should not boil. Drain and remove all bones while still warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prepare equal volumes of warm milk and olive oil. Break the fish with your fingers into a heavy-bottomed pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the pan on low heat and with a strong wooden spoon start to turn the fish add little by little small equal quantities of milk and oil, stirring continuously, continue till you have a stiff paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The fish paste can be stored in the refrigerator, for up to 4 days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the dish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cod paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Grated dry goat’s cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the beans in the vegetable stock until soft. Allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans and cod paste in an oven-proof dish and mix together. Cover the mixture with grated goat’s cheese and cook until well browned. Cook for about 30 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Note: If coco beans are not available you can use other sorts of beans. Goat’s cheese is mentioned, as this is the local cheese of the Nîmes area, but other fresh cheeses can be used.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("If you have made more cod paste than necessary, no problem: it can be used on toast.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _vm._v("6.2.6 Lentil Salads")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _vm._v("6.2.6.1 Puy Lentil Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer285"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-056.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried green Puy lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece of ginger, 2 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the lentils. Cook for 20-25 minutes in three times their volume of non-salted water. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the red onions cut into half and slice finely. Skin the ginger and grate.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing by mixing the Dijon mustard, ginger and spices with the cider vinegar and add the olive oil. Check the seasoning with the salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lentils in a salad bowl, add red onion and mix together, then add the dressing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _vm._v("6.2.6.2 Coral Lentils and Pepper Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-174",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-057.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Coral lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Yellow pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Light Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Nuoc mam")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the coral lentils. Soak in cold water for 30 minutes then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lentils into twice the volume of non-salted water and cook for 20-30 minutes until tender. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onions and slice. Clean and de-seed the peppers and cut into small strips. Peel the carrot and cut into small squares. Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing with the garlic, light soy sauce, olive and sesame oils and Nuoc mam, incorporating the chopped coriander")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a salad bowl, mix the lentils with the red onions and peppers, then add the dressing. Mix together well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _vm._v("6.2.6.3 Beluga Lentil Basil Salad Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-175",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-058.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Beluga lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Celeriac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pesto sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sweet paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions, garlic and celeriac. Chop one onion and garlic finely. Grate the celeriac in a machine. Slice the remaining 2 onions. Clean and de-seed the red peppers, then cut into strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check the beluga lentils under the running water. Drain, cover with cold water, then drain again. In a saucepan, cover the beluga lentils with twice their volume of water. Add a little salt and the herbes de Provence, one onion and garlic. Put on the heat and bring to a boil. Reduce the heat and simmer for about 25 minutes until the beluga lentils are cooked. Drain and reserve.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the lentils have cooled down, put them into a salad bowl. Add the 2 onions, celeriac and red peppers mixed together, then add the pesto sauce and remix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve in flat bowls and cover the salad with slices of tomato sprinkled with paprika powder.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _vm._v("6.2.6.4 Sprouted Lentil Salad")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("You can buy sprouted lentils, or you can grow them yourselves. If you want to grow them yourself, please see our section on how this can be done. You can buy the sprouting seeds through the internet or in delicatessen shops.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Sprouted lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Wholegrain mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice onion. Clean and de-seed the peppers then slice. Peel and chop finely the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the sprouts in a salad bowl and mix with onions and peppers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the dressing with the wholegrain mustard, garlic, vinegar and olive oil. Season with salt and pepper and add to the salad bowl. Stir and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _vm._v("6.2.6.5 Roast Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried Puy lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala with Pimento")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the lentils, put into a saucepan and cover by 2 cm with cold water. Bring to a boil, reduce heat and simmer for 18-20 minutes until cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return the lentils to the pan. Add other ingredients and mix together well. Pour the mixture onto greaseproof paper in a baking pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the lentils in the oven for 15 minutes. Remove and stir. Return to the oven and cook for a further 15 minutes. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _vm._v("6.2.6.6 Sprouted Green Lentil Burger")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("650 g Fresh sprouted green lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tomato sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chopped garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Sage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ghee or olive oil for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place all the ingredients together in a blender to produce a slightly stiff paste, keeping the ghee for frying.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the paste into balls, then flatten to give a rather thin burger. Or you can make small balls.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the burger in a hot pan with ghee or oil until browned on both sides.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _vm._v("6.2.7 Lupin Salads and Starters")]), _vm._v(" "), _c('p', {
    staticClass: "Subhead-3"
  }, [_vm._v("Traditional Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The origins of lupins are in the Mediterranean area and Latin America. Lupin beans have been eaten for thousands of years. The lupin bean as such has a bitter taste due to the presence of certain alkaloids some of which are toxic and must be removed before eating. Lupin beans can be used after preparation as an aperitif or as a dish in the same way as chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("There are many ways of sweetening lupins, and in each area where families have their own method, we will give a typical method.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _vm._v("6.2.7.1 Sweetening of Traditional Lupins")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer288"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-059.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the lupin beans and soak in cold water for 24 hours")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Rinse beans and put into fresh cold water. Bring to a boil and simmer for about one hour till cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let the beans cool. Once cold, drain, rinse and put into a pot of cold water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Soak for 3-4 days, changing the water twice every day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check to make sure that the bitterness has disappeared. If not, continue.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store the beans in the refrigerator in either a solution of brine or in brine and vinegar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The beans must be soaked in water to eliminate salt before use.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _vm._v("6.2.7.2 Lupin Beans as Aperitif")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is the common way of eating lupin beans. Once desalted, they are served as such and are eaten after removing the skin. They can also be used once skinned as a salad ingredient.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Desalted lupin  beans can be used to make houmous or falafel in the place of cooked chickpeas.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("At the present time, food manufactures are selling pasta based on lupins.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _vm._v("6.2.7.3 Lupin Houmous")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Lupin Flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Lebanese bread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the lupin flakes in a saucepan. Cover with water, then boil in salted water for about 4 minutes and drain well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic. Chop the coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the lupin flakes are cold, put them into a blender with the salt, nutmeg and lemon juice. While blending, gradually add a little bit of olive oil. Continue mixing, adding the olive oil until you have the desired consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mixture into a bowl, decorate with coriander and drizzle with the sesame oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve at room temperature, slice the Lebanese bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _vm._v("6.2.7.4 Low Carb Pancake with Lupin and Plain Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a neutral pancake that can be used in sweet or savoury dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 pancakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Sweet lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Cornflour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix together sweet lupin flour, plain flour, cornflour, salt and sugar. Heat the milk up, just to take the chill off: do not boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the warm milk to the pancake mixture, whisking to obtain a lightish cream texture without lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, beat the 2 eggs together, then gradually add this to the pancake mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the mixture to stand for about six hours. It can be made the night before.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Before you cook the pancakes, pre-heat your oven on medium heat, so that when the pancakes are cooked you can keep them warm while you cook the others.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check the pancake mixture is not too thick. If this is the case, add a little bit more milk. Heat a pan with a small quantity of butter and when hot add a ladle of the pancake mixture and cook until browned. Turn and do the other side. (After cooking each pancake, I wipe the pan and start again.)")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("These pancakes can be used for either sweet or savoury dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _vm._v("6.2.7.5 Low Carb Pizza with Sweet Lupin Flour")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer289"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-060.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for two pizzas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("1. For the Pizza Dough")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Dry yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Flour for kneading and rolling")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("2. For the Pizza")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Tomato confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Skinned red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 Anchovy fillets")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Black olives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Hard cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Few leaves of marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the dough")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take a large salad bowl. Add a little flour, dry yeast and sugar. Mix together, then add a little warm water to make a dough. Cover with a cloth and place in a warm place for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The yeast should now have activated. So, we can add salt, olive oil gradually, then we gradually add the plain and lupin flours. Mix this well together: you need to obtain a sticky dough. If it’s too dry, add a bit of warm water. Re-cover with the cloth and place in a warm place for another hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Knead well together on a floured board. This can be made the day before.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the pizza")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take half the dough, make a ball and flatten it. Put the dough on a board with a little flour and roll to a diameter of about 25 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover a greaseproof baking tray with greaseproof paper. Place the dough onto this.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mash the tomatoes and red peppers to make a paste. Grate the cheese and set it aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Brush the dough with olive oil. Cover with the paste, add anchovies, sprinkle with the grated cheese, add olives and decorate with the marjoram. Season to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pizza in the oven for about 10-15 minutes. Check to see if it’s a nice bronze colour. Serve with a salad.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _vm._v("6.2.8 Peanut Salads and Aperitifs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _vm._v("6.2.8.1 Roasted Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Shelled or unshelled raw peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat over 160°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If using unshelled peanuts, take the shells off. Place the shelled peanuts in a bowl, then roll them through your fingers, getting as much skin off as you can. Sprinkle with salt and rub them together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the raw peanuts on a shallow oven tray, only a single layer.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for about 15-20 minutes. Remove from the oven just before the end of the time, as the peanuts will continue to cook while cooling.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe can also be used with sugar, sugar and salt, spices or soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _vm._v("6.2.8.2 Peanut Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-176",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-061.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts into a food processor and blend for 3-5 minutes, the peanut will pass from crumbly to wet crumbly to a paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add honey and salt to taste and remix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pack in jars and keep in the refrigerator.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _vm._v("6.2.8.3 Sugar-Coated Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 ml Coconut milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("70 g Rice flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Fresh shelled peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable oil. (This is for deep frying.)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix together the sugar, coconut milk, salt, sesame seeds, rice flour and peanuts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the vegetable oil until hot but not smoking. Cook the peanuts in batches, putting them carefully into the hot oil until they are browned and crunchy. Dry them on absorbent paper. It tastes very nice!")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _vm._v("6.2.8.4 Potato and Beetroot Salad with Peanut Sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Cooked potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Cooked beetroot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Crunchy peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Balsamic vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the red onion and cut into slices. Peel the garlic and chop finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the potatoes and beetroot into small squares and put them in a salad bowl. Then add the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut butter, olive oil and sesame oils, garlic, balsamic vinegar into a food processor and run to obtain a paste. Add salt and pepper to taste, then mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the sauce to the salad bowl and toss before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _vm._v("6.2.8.5 Indian Peanut Chaat Salad")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer291"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-062.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("3 cups Peanuts with shells")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Chaat Masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Red chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Roasted cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium tomato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Green chillies")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Fresh coriander leaves chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the peanuts into a large saucepan, add the sea salt and turmeric powder and cover with water. Bring to a boil, then simmer for about 3 hours. Drain. Let it cool, then shell the peanuts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanuts in a bowl. Add salt, chaat masala, red chilli powder, roasted cumin seeds, onion, tomato, green chillies, coriander leaves and lemon juice and mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot or cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _vm._v("6.2.16 Mimosa Aperitifs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _vm._v("6.2.16.1 Mimosa Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Eggs cooked like this have been served for thousands of years, even in Roman times. But the name was given to this recipe when Captain Cook brought the Mimosa trees to Europe. The mimosa flowers looked so much like the eggs they served that they named them mimosa eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 Mimosa Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Hardboiled eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chopped Parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salad leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, boil then eggs till they are hard-boiled. Shell the eggs and cut into two. Remove the yolks and put them in a salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the egg yolks, the mayonnaise, white vinegar, salt and sugar. Mix them together well. Then mash the mixture together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Fill the white of the eggs with the egg yolk mixture. On a serving plate, cover this with salad leaves then place the mimosa eggs on the plate. Sprinkle this with chopped parsley and paprika.")])]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-177",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-063.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _vm._v("6.3 Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _vm._v("6.3.1 Peas/Mangetout Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _vm._v("6.3.1.1 Rice with Green Peas and Broad Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer293"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-065.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people. The ingredients are indicated by volume: interesting in certain cases. In this case the volume equals 250 ml.")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 vol Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 vol Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 vol Broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 vol Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Packet Spanish spigol")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Pinch Saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the stock into a saucepan. Add Spanish spigol and salt. Bring to a boil. When boiling, add the green peas and broad beans and cook for 2 minutes. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a flat pan, add the oil and when hot fry the rice until white.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the stock with vegetables and spigol to the flat pan with the rice in. Stir and cook until most of the liquid has disappeared: this should take about 20 minutes. Check the rice to see if it’s cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and pepper to taste. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("N.B. Spigol is a Spanish mixture for paella and can be found in most deli stores.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _vm._v("6.3.1.2 Gratin of Peas and Spinach with Brandade")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The Brandade, a French speciality from Nîmes, is a paste made from salted cod. The salted cod is soaked for 48 hours to eliminate the salt and is then mixed with olive oil to make a paste. This dates from the time when Northern European fishermen caught cod in the Northern Atlantic, dried and salted the cod on board, and brought to the Mediterranean ports to trade and exchange salted cod for wine, olive oil and oranges.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Green peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spinach leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Brandade de morue")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the potatoes and cut into cubes. Wash the spinach. If you are using fresh green peas, pod them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the potatoes into a saucepan, cover with water and bring to a boil. When they are cooked, drain and mash them. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the stock and salt, bring to a boil. Add peas and spinach leaves and cook for 2 minutes. Drain and allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the Brandade with the vegetables and put them in an oven-proof dish. Cover with a layer of mashed potatoes, powder with grated Parmesan cheese and put in the oven for about 25 minutes until well browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _vm._v("6.3.1.3 Mangetout with Rice and Shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Long Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Dried Shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Strands of saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the dried shrimps in hot for about 45 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the stock into a saucepan. Add mangetout, shrimps, masala and saffron. Bring to a boil, season and reserve.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put olive and sesame oils into a flat pan and heat. When hot, add the rice cook until the rice whitens. Once the rice has whitened, add the contents of the saucepan and cook slowly until almost dry. Check that the rice is cooked. Season and serve. Goes well with a dal.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _vm._v("6.3.1.4 Lamb Stew with Green Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer294"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-066.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Thick slices of neck of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium potato")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Courgette")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Frozen peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Mild paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Peel and cut potatoes into cubes. Peel carrot and clean courgette and slice into discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy stew pan, heat the oil and brown the sliced neck of lamb. Once brown, set aside in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the pan, add onion and garlic and allow to soften. Return the lamb with the spices and herbes de Provence. Add the wine and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add carrot and stock, season with salt and pepper and simmer slowly for one hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add potatoes and courgettes and continue cooking. Just before the potatoes are cooked, add the peas and cook for about 5 minutes. Check seasoning and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _vm._v("6.3.1.5 Greek-Style Peas and Potatoes with Chicory")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer295"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-067.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 kg Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Large chicory roots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Large potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of one lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Shell peas, peel and chop onions and garlic, peel potatoes and dice them, slice chicory and cut in 1.5 cm cubes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan with boiling water, blanch the tomatoes. Drain. When cold, peel the skin off. Cut the tomatoes into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the onion and garlic in a heavy pan with the olive oil and cook slowly for about 10 minutes until soft, but do not brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chopped tomatoes and marjoram and cook for 10 minutes. Add water, salt and pepper. Add the diced potatoes and chicory. Cook for 15 minutes on average heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add peas and chopped dill and cook until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lemon juice, stir and cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with pasta and feta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("If you can’t find chicory, you can use salsify.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _vm._v("6.3.1.6 Goat’s Meat Stew with Peas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-178",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-068.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical Greek country dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Goat’s meat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 kg Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Origami")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the tomatoes into four, peel and dice carrots. Peel onions and garlic and slice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the meat into bite-sized pieces and coat with flour, salt and pepper. Place in a stew pot with the olive oil and cook on all sides until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chopped onions and garlic and continue to cook until the onions are softened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add sliced tomatoes, diced carrots and herbs. Add a little stock to cover and continue cooking slowly until the meat softens. Add stock or water to keep covered. Cook for 60 to 75 minutes or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the meat has softened, add peas and cook for a further 5 minutes, or until cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice or pasta.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _vm._v("6.3.1.7 Chickpeas and Chorizo")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer297"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-069.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Dry chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chorizo")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak chickpeas overnight. Drain chickpeas and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and crush the garlic. Put the chickpeas in a saucepan and cover with water. Add garlic, bay leaves and salt. Bring to a boil and simmer for 30 minutes. Check to see if the chickpeas are soft, then drain. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the chorizo into slices. In a frying pan, add oil and heat. When hot, add the chorizo slices, fry until they are slightly brown, then add the chickpeas mixture. Cook for a further 3 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _vm._v("6.3.1.8 Pork Fillet with Coco Beans and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fillet of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slice the pork fillet into slices. Peel and chop 1 onion and garlic. Put 1 tbsp of olive oil in a pan and heat. Add the onions and garlic to the pan and cook until soft. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the coco beans with salted water and simmer for 10 minutes. Cook until soft. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel one onion and cut into six. Peel carrot and cut into rounds, cut the pepper into 3 cm squares and trim the mangetout and cut them in half.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put all the vegetables except the mangetout into a salad bowl. Add salt and pepper, herbes de Provence and 1 tbsp of oil and mix together. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put meat and onions in an oven-proof dish cover with the vegetables except the mangetout. Add a little of the meat water during the cooking to make sure that the dish does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cooked, add mangetout and coco beans, stirring them together. Return to the oven for a further 5 minutes and serve. The mangetout should remain crunchy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _vm._v("6.3.2 Broad Beans Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _vm._v("6.3.2.1 Broad Bean Risotto")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer298"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-070.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Arborio rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Powdered cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Mascarpone")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook the broad beans on salted boiling water for about 10 minutes. Drain, keeping the water they were cooked in. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions and cook them in the olive oil. Once soft, add the rice and allow to whiten.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbs and cumin and salt and pepper. Add the white wine and cook for 3 minutes. Add the stock, mascarpone and beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Continue to cook, stirring and making sure it does not dry out; add water if necessary. Cook this for about 15-20 until the rice is cooked. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _vm._v("6.3.2.2 Gratin of Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Squash")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Strong honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Glass of white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blanch the beans in salted boiling water for about 3 minutes, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the squash and cut into small pieces, then cook in salted water for 10 minutes. Then drain and make into a purée with a masher.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onion, heat the olive oil, then add the chopped onions. Cook until soft. Add cumin, paprika, garam masala, white wine and honey. Season to taste with pepper and salt. Stir and bring to a boil and add the mashed squash.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the beans into a greased oven-proof dish and cover with the squash. Sprinkle with the Parmesan and Pecorino, then cook in the oven for 20 minutes, until golden-brown on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _vm._v("6.3.2.3 Whole Broad Beans with Pork")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Young whole broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shoulder of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Fresh bunch of coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Pork stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the whole broad beans, remove the ends and cut into 5-cm pieces. Peel and crush the garlic, cut the tomatoes into 6 pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork into 3-cm cubes. In a pan add the duck fat. When it’s hot, add the pork pieces. Fry until nice and golden-brown.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the garlic and tomatoes and cook for 2 minutes. Add salt and pepper. Add the stock, cover and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning, then add the beans and cook until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice sprinkled with coriander.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _vm._v("6.3.2.4 Stir-Fried Broad Beans and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer299"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-071.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Shelled broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Bok Choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Young carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Dill")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Roasted sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Boil the beans in salted water until tender. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the Bok choy, celery and carrots into 3 cm lengths and then into thin sticks.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add olive oil to a wok on medium heat, add vegetables and stir, keeping the vegetables moving for about 5 minutes. Then add all the other ingredients and continue cooking until the vegetables are cooked but still crunchy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _vm._v("6.3.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _vm._v("6.3.3.1 Lamb with Chickpeas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer300"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-072.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Shanks of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Neck of lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Couscous")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece fresh ginger, about 5 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Boil some water in a saucepan. When it’s boiling, add the tomatoes and bring to a boil. Boil till the skins start to come away. Drain and set aside to cool. When the tomatoes are cold, take the skin off and cut into four.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onions, garlic and ginger. Put the olive oil in a heavy pan and heat. Cook the onions until soft, add Herbes de Provence, garlic and ginger. Heat for another minute while stirring.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the shanks of lamb, neck of lamb in the pan and brown all over.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peeled chopped tomatoes and spices with a part of the stock. Simmer slowly covered for about 35 minutes, or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook couscous as instructed on the packet.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season the couscous with salt and pepper, then add the washed and drained chickpeas and serve hot.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the lamb and couscous and harissa.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _vm._v("6.3.3.2 Andalusian Chickpeas with Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Spinach, washed and cleaned")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbs de Province")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Powdered paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sliced stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Take a saucepan. Add a very small amount of water, put it on the heat and add the spinach and butter. Cover for 1 or 2 minutes until the spinach has wilted. Remove from the heat and allow to cool. Once cold enough, squeeze the spinach to remove water and chop, not too finely. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the stale bread into very small cubes. Chop the garlic and shallot very finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil into a heavy pan and heat. As soon as it is hot, add the garlic and shallot. Cook until they start to brown. Add the bread, stirring. Add the herbes de Provence and spices. Have a glass of water handy in case it sticks and stir well so that it is all mixed together, then add the spinach. Continue stirring and add the chickpeas. Add the vinegar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When well mixed and hot, serve with a drizzle of olive oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish is a main dish in a Spanish tapas bar.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor187"
    }
  }), _vm._v("6.3.3.3 La Cocido Spanish Chickpea Stew")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer301"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-073.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Originally this dish was brought to Spain by the Arabs and was traditionally served without pork. However, at the time of the Inquisition, Queen Catarina ‘The Catholique’ decided that this national and widely eaten dish should be served with pork to detect the false Muslim and Jewish converts to Catholicism. Since that time, the dish is always served with pork.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dried chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chicken")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Sliced stewing steak")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g White cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the chickpeas overnight. Drain and rinse well, then cook them in salted water, until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add water, then cook the pork belly for 10 minutes. Drain. When cool, slice. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onions, garlic, carrots and potatoes. Slice the onion and garlic. Cut the carrots and potatoes in two. Slice the cabbage.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork and stewing steak into 6 pieces. Cut the chicken into 6 pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large casserole, add the lean pork, pork belly, stewing steak and chicken, herbes de Provence, spices and bay leaves. Then cover with water. Bring to the boil. When boiling, reduce heat and simmer for half an hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the onions, garlic, carrots, potatoes and cabbage. Simmer for a further 20 minutes. Add chickpea, making sure there is enough liquid. If it’s too dry, add some water. Season with salt and pepper to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the vegetables on a large plate, then place the meat on the top of the vegetables.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Traditionally this dish is served in the following way: the juice is served as soup to start with, then the rest is served as a main dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor188"
    }
  }), _vm._v("6.3.3.4 White Shark with Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-179",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-074.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 White shark steaks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Pimento powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 dose Saffron")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic. De-seed the red pepper and cut into strips")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a flat pan, add the olive oil and heat. Add the sliced red pepper until slightly browned. Add garlic and onion chopped finely, spices and herbes de Provence, stirring. Add stock and cook for 1 minute.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the washed and drained chickpeas, saffron, salt and pepper and the rest of the stock. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the coriander and the shark and cook for 5 to 10 minutes. Turn the shark steaks. Slice the lemon confit.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove shark and set aside, keeping it warm. Cook the sauce and chickpeas about 10 minutes. Check seasoning, add the shark and sliced lemon and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor189"
    }
  }), _vm._v("6.3.3.5 Chickpeas with Beef")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Beef spare ribs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Calf’s feet")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions, garlic and tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put spare ribs and calf’s feet in a saucepan. Add garlic, onions, tomatoes, oil and herbs. Cover with stock. Bring to a boil and simmer for 4 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chickpeas, paprika, coriander and check seasoning. Cook for a further 5 minutes. Serve hot. This can be served with either rice or potatoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor190"
    }
  }), _vm._v("6.3.4 Fresh Bean Main Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-180",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-075.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor191"
    }
  }), _vm._v("6.3.4.1 Coco Beans and Black Cabbage")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer304"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-076.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Shelled coco beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Black Florentine cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Slice the cabbage, then steam in salted water for 5 to 10 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the stock into a saucepan, then put the coco beans into the stock. Cook for about 15 minutes until soft. Set the saucepan aside. Do not drain: the rest of the ingredients will go into this later.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Chop the salted pork into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions and pork in the olive oil until they start softening. Add herbes de Provence, spices, garlic and wine and cook for 4 minutes. Then add this to the saucepan with the coco beans in. Add the chopped cabbage to this also.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning, heat and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor192"
    }
  }), _vm._v("6.3.4.2 Fresh Green Bean Gratin")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Cheddar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Grated Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Trim the beans and cut into 4 cm lengths. Grate the Cheddar cheese. Peel and crush the garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set the oven to 200°C. Put the fresh beans in an oven-proof dish. Season with salt, pepper and crushed garlic, mixing well together. Put a knob of butter on the beans, cover with foil, and roast for about 15 minutes, then stir well. Then cook covered with the foil for another 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take off the foil, sprinkle the grated Cheddar and Parmesan. Cook for another 15 minutes until brown. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor193"
    }
  }), _vm._v("6.3.4.3 Indian Cluster Beans and Potato Curry")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer305"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-077.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Fresh cluster beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g New potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("25 cm Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of Asafoetida")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Curry leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Coriander powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Top and tail the cluster beans and remove side threads if necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash potatoes and cut into cubes. Cut the tomatoes into cubes: do not peel.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion, ginger and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan and add cardamom, cumin and asafoetida.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When grains splatter, add curry leaves and the chopped onion, garlic, ginger, turmeric and salt, then cook until well browned")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the rest of the spices and tomatoes, stir and fry until oil separates.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add tomatoes and cluster beans and stir-fry for a further few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add a bit more water and bring to a boil. Turn heat down and add the potatoes. Cover and cook until potatoes are cooked. Stir occasionally to avoid sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Sprinkle with garam masala and serve hot. You can serve this with either dal and chapatti or rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor194"
    }
  }), _vm._v("6.3.5 Dried Bean")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor195"
    }
  }), _vm._v("6.3.5.1 Brazilian Feijoada")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer306"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-079.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Feijoada is a traditional Portuguese dish made with brown beans and meat. Feijoada is very popular all over Brazil and when you walk into a restaurant there is most often a big ceramic pot of bubbling brown beans. Recently there has been a fashion for eating the traditional food of slaves, and Feijoada with black beans is the typical case. In fact, the black beans are the most expensive as they cannot be picked by machine.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2"), _c('span'), _vm._v("kg Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pig’s feet")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Pig’s ears")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("800 g Pieces of smoked pork shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Big smoked sausage, cut into chunks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Sultana’s")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 kg Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.5 kg Portuguese cabbage, shredded")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Oil or fat, for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the smoked shoulder of pork overnight. Drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Soak the black beans in water for 24 hours. Drain and rinse a couple of times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the pig’s feet and ears for one and a half hours. Drain and discard water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onions and garlic and put into a heavy saucepan with oil or fat. Cook until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all meats, stock, spices, herbs and sultanas and cook for 1 hour. Add the drained black beans and cook until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add water and bring to a boil. When boiling, add the rice. The cooking time will depend on what type of rice you choose: check on the packet.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the Portuguese cabbage for 5-8 minutes in salted water and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the three dishes in separate bowls. This looks very appetising.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor196"
    }
  }), _vm._v("6.3.5.2 Cassoulet")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-181",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-080.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish from the South-west of France. It is made with local beans and is traditionally cooked in an earthenware dish with a special shape. The name Cassoulet comes from this earthenware pot.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry white beans (usually Tarbes beans)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Shoulder of pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Lamb")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Confit of Duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Pig skin rind")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Toulouse sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bouquet garni")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Goose or duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Dry breadcrumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight in cold water. Drain and rinse a few times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 150°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop 2 of the onions and garlic. Peel and chop carrot. Slice tomatoes and leave a moment to drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the onions in the fat and when soft add the garlic, tomatoes and white wine. Cook for 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the pork and lamb into 3 cm cubes and half the pig skin into slices, about 3 x 2 cm. Peel the last onion and stick this with the cloves.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a large saucepan. Add the meat, white beans, carrot, onion with cloves and bouquet garni. Cover with water, check seasoning with salt and pepper and simmer slowly for 2 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Prick the sausages and cook in fat for a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the beans to cool. Remove the carrot, the onion with cloves, and the bouquet garni.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the Cassoulet. Rub the inside of the earthenware pot with duck fat, cover the bottom part with the pig skin (skin inside). Fill the tin with alternate layers of meat and beans. Finish with the confit and the sausage. Make sure that there is enough liquid and sprinkle with breadcrumbs. Place the dish in the oven and cook for 2 hours. During the second hour remove the dish to break the crust and check the liquid level. At the end of the time, switch to grill to brown the surface.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The Cassoulet should be served hot with a full-bodied red wine from the South-west of France.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor197"
    }
  }), _vm._v("6.3.5.3 Garbure")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is another typical dish from the French South-West, but in this case the Atlantic side of the Pyrenees. This was a typical peasant food for many years and is basically a stew with whatever is available, but there are certain elements that are always present: potatoes, cabbage, beans and some sort of dried, salted or conserved meat. What we are giving below is not a real recipe but an indication of what can be used, and what perhaps was reserved for Gala days.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 People:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Leeks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Medium carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Medium potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium turnip")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Sprigs of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Legs of confit of duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Wings of duck confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Slice of Bayonne ham")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Slice of stale bread")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 tbsp Grated cheese (preferably dry sheep’s cheese)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("The day before, soak the white beans in a large quantity of cold water. Drain, rinse and renew a couple of times. Afterwards, drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and cut the potatoes, carrots, and turnip into small cubes. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Clean and cut the leeks and celery into fine slices. Slice the cabbage not too thinly and blanch in boiling water for about 5 minutes. Drain and set aside")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large pot, cook the leeks, onion and half of the garlic in the duck fat. Simmer slowly for 10 minutes. Stir regularly to avoid sticking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover with water. Once boiling, add the vegetables except the potatoes and cabbage, and add the ham. Salt slightly as the ham is probably very salted. Cover and simmer slowly until the vegetables are soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the beans are cooked, add the potatoes and the cabbage.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("At this stage, transfer the Garbure, the duck confit, duck wings. Cover this with all the cooked vegetables. Make sure there is enough water. Cover with the stale bread, push down and sprinkle with the remaining garlic and the grated cheese. Put in the oven and cook until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor198"
    }
  }), _vm._v("6.3.5.4 Chilli Con Carne")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer308"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-081.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is found as a daily dish worldwide. Its origin is widely disputed between Mexico and the southern states of the USA. However, most people seem to agree that Texas was probably the origin.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Chunks of beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("400 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 Large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 Red chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Garam masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Peel and chop tomatoes. De-seed and clean red peppers and cut into small strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the meat into small cubes. Cut the red chilli into two and remove the seeds, then cut into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the olive oil in a heavy saucepan and fry the onion for 5 minutes. Add meat and brown. Add garlic, peppers and tomatoes and cook for a further 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add herbes de Provence, spices and red chilli. Stir for a couple of minutes, add part of the stock, check seasoning, cover and simmer for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the red beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check that the meat is cooked, add the red beans, cook for a further 10 minutes to warm the sausages and red beans. Check that the rice is cooked. Season to taste. Serve while hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor199"
    }
  }), _vm._v("Cooking in Louisiana")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The following two recipes illustrate the Cajun cooking of beans in Louisiana. The first, with beans and maize, shows the influence of Pre-Columbian cooking culture; the second is more recent and represents the New Orleans cooking of beans and rice, which inspired a jazz man like Louis Armstrong to finish his letters with ‘Red beans and Ricely’. Beans are indigenous to the southern States of the USA, and African rice came to the area with the slave trade, as the slaves knew how to grow it.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor200"
    }
  }), _vm._v("6.3.5.5 Dry White Beans and Sweet Corn")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Chicken thighs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Shallot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pork dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans and sweet corn. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop garlic and onions. Cut the tomatoes into 4. De-seed and cut the red pepper into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large saucepan, heat the pork dripping on medium heat. Seal the chicken thighs. Once browned, remove from the saucepan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same saucepan, add the onions and garlic and cook until the onions are soft. Then add the red peppers and cook for 5 minutes. Then add the herbes de Provence, tomatoes, spices and stock. Bring to a boil and simmer for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the beans and sweet corn. Add salt and pepper to taste. Cook for 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor201"
    }
  }), _vm._v("6.3.5.6 Creole Beans and Rice with Sausages")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer309"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-082.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400"), _c('span'), _vm._v("g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Long grain rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Large pork sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Pork dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Turmeric Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Cayenne Powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a frying pan, add 25 g of pork dripping. When it’s very hot, add the sausages. Cook well. When they are cooked, place on a plate and cut into pieces. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onions and garlic. De-seed and clean green pepper and cut into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy-bottomed pan and heat. Add the rest of the dripping and melt. Add onions and cook until slightly transparent. Add green pepper and garlic with the rice. Stir until the rice whitens, then add spices and bay leaves. Stir, then add water progressively until the rice is cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the rice is cooked, add parsley and sausages, drain the beans and rise them, then add them to the rice. Cook, making sure that the beans and sausages are well cooked. Check seasoning and serve in soup bowls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor202"
    }
  }), _vm._v("6.3.5.7 Oven Dish with Borlotti Beans and Chorizo")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer310"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-083.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 ml Tomato, lightly puréed")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Salted lean pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Chorizo, mild")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned borlotti beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Oregano")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and slice the onion, peel and chop garlic. Clean and de-seed the red pepper and cut into small squares. Peel the potatoes and cut into slices. Drain and rinse the borlotti beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the lean pork into small pieces and slice the chorizo. Then pour the oil into a pan and fry the salted pork and chorizo. Remove the meat and dry on absorbent paper. Remove most of the fat, leaving about 2 tsp.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Replace the pan on the heat. When hot, add onion, garlic and red pepper and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add oregano, potatoes, borlotti beans, tomato purée, stock, wine and the cooked pork and chorizo. Check the seasoning.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for a further 10 minutes, sprinkle with parsley and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor203"
    }
  }), _vm._v("6.3.5.8 Savoy Beans with Diots")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-182",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-084.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish from the French Alps and is made with diots, which are cabbage sausages. These sausages are made from pig’s head, pig’s neck and some lean pork, mixed with 50% cabbage. These sausages are made in the autumn when the pig is slaughtered, and after being made they are air-dried and then smoked. They can be kept all winter.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("750 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Salted lean pork belly, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Diots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the pork for 6 hours. Then drain set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the white beans in unsalted water for 21/2 hours. After 1 hour, add the soaked pork.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Towards the end of the cooking time for the white beans, cook the diots in a frying pan.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("At the end of the cooking time, check that the beans are tender. Season with salt and pepper, and serve on hot plates with a slice of pork and the diots.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor204"
    }
  }), _vm._v("6.3.5.9 Baked Beans On Toast")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer312"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-085.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a dish that is very popular all over the Anglo-Saxon world. It is a main course, a snack or a standby. Generally, it is made with a can of beans, which most people have in their cupboards. The principle is to have a slice or two of English bread, thickly cut and toasted. All the main canned food producers do them. Heat the beans, season and serve on toast.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Should you wish to make your own, here is the recipe for Baked Beans.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the bean overnight in cold water, drain and rinse. Peel the onions and slice.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a heavy pot with a well-fitting lid. Put in the oil and fry the onion until soft but not browned. Add all the ingredients except salt and pepper. Make sure that the beans are covered with stock and cook slowly for about 1 hour. Ensure all along that the beans are covered; if not, add stock or water. The sauce has to have a thickish consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the beans are cooked, season with salt and pepper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve on toasted bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor205"
    }
  }), _vm._v("6.3.5.10 Loubia White Beans with Beef and Calf’s Feet")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A typical North Africa food popular all over North Africa. Sometimes a variation is made with vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 Calf’s feet, cleaned of skin and cut into pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Beef neck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Dry white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch flat parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Beef stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-183",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-086.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the white beans overnight. Drain and rinse a few times. Peel and chop tomatoes, onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the calf’s feet and lamb neck in a heavy pan. Cover with stock and cook for 45 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add spices, herbs, onion, garlic and tomatoes. Cook slowly for 25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lemon juice and white beans. Cook until the beans are cooked, for about 15 minutes. Check water: if need b,e add a bit more as the cooking proceeds. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor206"
    }
  }), _vm._v("6.3.5.11 Stir-Fried Tofu and Vegetables")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer314"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-087.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Firm tofu")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Fresh green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Roasted sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Light soya")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Heavy soya")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("To prepare the tofu: set the oven to 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove tofu from its packaging and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wrap the tofu in a cloth and place between two wooden flat plates. If the cloth gets wet quickly, change the cloth once or twice until there is no further liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the tofu is no longer losing water, remove from the cloth and place on a sheet of greaseproof paper. Put into the oven for about 30 minutes, turning now and then. Remove from the oven and cut into rectangular blocks of about 1 x 2 cm and allow to continue to dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To prepare the sauce: mix all the ingredients in a bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and de-seed the green pepper and slice. Cut the green beans into 5 mm slices, about 2 cm long.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the wok on the heat, add the sesame oil and when hot, add the onions, green peppers and green beans. Stir regularly until soft, about 7-8 minutes. Add the sauce until it starts to thicken. Keep stirring and add the tofu. Stir slowly until cooked, then serve sprinkled with roasted sesame.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor207"
    }
  }), _vm._v("6.3.5.12 Stir-Fried Chicken with Cellophane Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Cellophane noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Yellow pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 cm Fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Light soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Heavy soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the chicken into thin slices of 9 cm long. Set aside. Clean and de-seed the peppers and cut onions and peppers into thin slices. Chop the garlic and ginger finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the sauce, place all the ingredients in a bowl together and mix well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the chicken in flour to coat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the wok on medium heat, add 2 tbsp oil and when hot, stir-fry the chicken until brown. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the noodles for 1 to 2 minutes in boiling salted water, or as indicated on the packet. Drain and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the remaining oil in the wok and cook all the other ingredients until softened but not overcooked. Add sauce and cook until it starts to thicken. Add chicken to heat. Add the cellophane noodles. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor208"
    }
  }), _vm._v("6.3.5.13 Stir-Fried Shrimps and Bean Sprouts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer315"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-088.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 persons:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("a. For the stir-fry")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("300 g Fresh shrimps")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 cm Fresh ginger root")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Fresh bean sprouts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Roasted sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Mixed olive and sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("b. For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Light soy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Thick soy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour or arrowroot")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Shell the shrimp. Clean onion, garlic, and ginger. De-seed pepper. Cut the onion and pepper into thin strips of about 2 cm, chop garlic and ginger finely, wash and drain sprouts.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put 1 tbsp of oil in a wok and heat on medium heat. When hot, cook the shrimps. When cooked, set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the sauce, put all the ingredients into a bowl and mix together well. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the remaining oil to the wok and when hot, add onion, pepper, ginger, garlic and sesame. When the vegetables start to soften, add the sauce and continue stirring. When the sauce starts to thicken, add shrimps and bean sprouts and stir until the bean sprouts are warm but not cooked: the bean sprouts should be crunchy. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor209"
    }
  }), _vm._v("6.3.5.14 Akra with Dry Black-eyed Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-184",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-089.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Black-eyed beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Onion (onions cut into large pieces - keep the skin)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("235 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Chilli sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the black-eyed beans in water for 2 hours until they are soft. Drain and rinse a few times.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the black-eyed beans in water and soak for 2 minutes. Drain after a few minutes, wash the black-eyed beans and drain. With your hands, rub the beans together so that the skins come away. Take away the skins.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Repeat the above three or four times. The idea is that when you have finished, you have no skins left.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a mixer, add black-eyed beans, onions and water. Mix until you have a purée consistency. Salt to taste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the purée well to get some air into the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a deep fat fryer. When the oil is hot, add the onion skins. Then add the purée with a spoon, to form balls. Cook until golden. Place on absorbent towelling to get rid of any oil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve warm with a chilli sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor210"
    }
  }), _vm._v("6.3.5.15 Akra with Black-eyed Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer317"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-090.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the dough")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Black-eyed bean flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ Salted water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 pkt Bread yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic (Crushed)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("A few springs of parsley to decorate")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the black-eyed bean flour, water and yeast together. Peel and chop finely the onions then add to the flour mixture. Cover the bowl with a cloth and set aside for 1 hour. It will double its size.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("De-seed chilli and cut finely. In a saucepan, add oil and heat. Add tomato purée, salt pepper and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let this cook slowly. When it’s cooked, add white vinegar and chopped, de-seeded chilli. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a frying pan. When it’s warm, make small balls with the flour mixture using a spoon.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook till they are golden brown, then serve with the sauce. Sprinkle with parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor211"
    }
  }), _vm._v("6.3.5.16 Cornbread and Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer318"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-091.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a very popular dish from the southern states of the United States. Cornbread is made from maize, but maize is called ‘corn’ in America so we have kept the name cornbread. The history of cornbread goes back a long way, to the time that the Maya and Aztec were making maize tortillas. North of the Rio Grande (the present-day Mexican frontier), the American indigenous people like Cherokees and others were cultivating beans and maize and making an early form of cornbread which was served with beans. The dried maize was stone-ground and mixed with water into a thick pourable paste that was cooked on hot stones and cinders on the campfire. This fairly hard disc was eaten with beans and with what was available: meat, fish or animal fats. It was nourishing and was the staple food of these tribes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("With the arrival of immigrants and slaves, both adopted cornbread as a basic food and many attempts to improve it were made by adding wheat flour, butter, buttermilk and eggs. However, the cornbread was always heavy. At this time, the cornbread was called hoe bread as it was cooked in the blade of a gardener’s hoe, in the same way as you would use a saucepan on an open fire. The big change came in 1840 with the discovery of baking powder by the American Alfred Bird, because it could be used to raise gluten-free products like cornbread. The product was commercialized in 1850.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We will give a recipe of the cornbread and beans that is representative of traditional Southern cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the cornbread")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100"), _c('span'), _vm._v("g Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Polenta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("45 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg, slightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together corn flour, polenta, salt, bicarbonate of soda and baking powder. Mix well. Gradually add the beaten egg and milk, making sure you obtain a pourable paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a cast iron skillet, then add the peanut oil when very hot. Pour the paste into the skillet and cook in the oven for 20-25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the cornbread is cooked, serve it with the pinto beans mixture shown below. Serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the pinto bean’s mixture")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Pinto beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2  Rashers of bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the beans and soak overnight. Drain and rinse well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the onion and garlic. Chop the onion and crush the garlic. Cut the bacon into squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a heavy-bottomed saucepan, fry the bacon until crispy. Add onion, garlic and bay leaves. Add a little water and cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the beans, add to the saucepan and cover with water. Cook slowly for about 1 hour. Add salt and pepper. Check cooking and if ready, set aside and keep warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor212"
    }
  }), _vm._v("6.3.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor213"
    }
  }), _vm._v("6.3.6.1 Lentils with Herb Sausages")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer319"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-092.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Herb sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Spring of thyme")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chicken stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Knob of butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper grains")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onion. Peel the carrot and cut into discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the butter in a saucepan. When hot, cook the onions and carrot for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lentils, chicken, stock cube, salt and pepper grains. Cover with two volumes of water and cook for 35 minutes")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pierce the sausages, add them to the pan and cook further 25 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Five minutes before the end of the cooking, adjust the seasoning.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor214"
    }
  }), _vm._v("6.3.6.2 Beef Sausages with Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer320"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-093.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("450 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Branches of celery")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sausages")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Minced meat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 ml Red wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Paprika powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("1 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Sheets of cotton, 20 cm x 20 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic. Peel and skin tomatoes then cut into small pieces. Chop the celery into small pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat olive oil in a saucepan. Add garlic, tomatoes, paprika and celery. Fry until the juice starts to reduce. Add the lentils and a little of the stock. Bring to a boil and simmer. To avoid the lentils breaking up, add water as necessary. Cook for about 15-20 minutes. Check seasoning. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together all the ingredients for the sausages. Roll into 4 cylindrical forms. Place each sausage shape onto the cloth, then roll the cloth and tie with string, making sure they are well sealed.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, put the sausages in, then add water to cover. Bring to a boil and simmer for 20 minutes. Take the sausages out from the water with a ladle. Let them cool down, then unwrap them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a frying pan add oil and heat. When hot, cook the sausages, making sure they are nice and brown on all sides and cooked through.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve the sausages with the lentils.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor215"
    }
  }), _vm._v("6.3.6.3 Wild Duck with Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 Wild duck")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Small white cabbage")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Juniper berries")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the onions and garlic. Cut the cabbage into 4, then into slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cabbage into a saucepan, cover with water and add half the garlic, salt and pepper. Cook for 10 minutes. Drain the cabbage, keeping the liquid back. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the cabbage with a little salt and the juniper berries. Clean the duck, then stuff with the cabbage mixture. Close the duck using cocktail sticks to keep it together. Rub the duck with olive oil, herbes de Provence and paprika. Place the duck in a casserole dish add a bit of water. Cook for 30-40 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large pan, heat the oil. When hot, add the rest of the garlic and onions. Fry them till they start to soften and turn a bit brown. Then add the lentils and reserved liquid from the cabbage. Simmer for 20 minutes, making sure it does not dry out.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the duck is cooked, cut it in half and serve with the lentils.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor216"
    }
  }), _vm._v("6.3.6.4 Lentils with Fresh Pasta")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-185",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Documents\\Peas & Beans Book 30.7.18\\Recipe photos  13.7.2018 us\\PIC_0331.JPG",
      "src": "image/Stribling-6-094.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical Southern German dish, originally for poor people: lentils and flour are cheap and easy to conserve. It is also very nutritious, with a high protein content. Today the dish is popular worldwide.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8",
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_c('span', {
    staticClass: "CharOverride-15",
    attrs: {
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("For the lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Slices thick cut bacon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large yellow onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Carrot")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Leek")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 l Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method for the lentils:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut bacon into slices and peel and dice finely the onion. Finely slice the carrot and leek.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half the olive oil in a saucepan. When hot, add the sliced bacon. When the bacon is well-cooked, take it out of the saucepan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same saucepan, add the rest of the olive oil. Cook the onions until transparent, about 5-7 minutes, then add butter, carrot and leek. Cook for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add lentils, stock, bay leaf, salt, pepper, sugar, vinegar and parsley. Cook for 10-15 minutes; add extra stock if too thick. Check to see if the lentils are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with fresh pasta (see below).")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the fresh pasta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5-6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix all the ingredients in a bowl to obtain a firm paste. If the paste is too hard, add another egg.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the paste to a thickness of about 5 mm. Cut into 5 mm-wide strips and thin lengths of about 2 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the pieces in boiling salted water. When they rise to the surface, they should be removed, cooled under cold water and allowed to dry.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the butter in a frying pan. When it’s hot, add the fresh pasta and fry until golden-brown.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor217"
    }
  }), _vm._v("6.3.6.5 Rice with Lentils ‘Mujadara’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical dish with lentil from the Middle East. It is eaten in most countries and is a dish with lentils and rice and generally some type of meat.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Round rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Yoghurt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the lentils. Crush the peppercorns and cardamom pods in a mortar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the lentils in three times their volume of water with a little salt until they start to soften. Check cooking time on the packet, as this varies depending on the lentils. When cooked, drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and slice onion, chop the garlic finely. Put half the oil in a heavy pan and cook the onion until browned. Add garlic and all the spices cooked further minute and set half aside on absorbent paper. Pour the rest of oil and onion into the pan with the lentils.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the rice with about twice its volume of water. Bring to a boil and simmer for 5 minutes, then add the lentils and pine nuts. Continue cooking until the rice is cooked; add water if necessary. When the rice is cooked, the water should all have disappeared.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow the dish to stand some minutes before serving. Serve in bowl, adding the warmed onion and a large spoonful of yoghurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This recipe is inspired by a meal prepared in the desert by Yemeni friends. Of course, in the desert there are no onions or yoghurt, but it was good served with grilled lamb.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor218"
    }
  }), _vm._v("6.3.6.6 Confit of Duck with Lentils")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer322"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-095.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Legs of duck confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Duck fat")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("16 Small potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("8 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven 180°C. Peel and chop the onions and garlic, peel the potatoes and shallots.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the duck fat into a saucepan and heat, add the duck legs until browned and set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat half of the olive oil in a saucepan. Then add the chopped onion and garlic to the pan with the cumin, salt and pepper, cook until the onion softens, add lentils and cover with stock, stir and cook slowly adding stock as the water is absorbed until the lentils are cooked. Keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the potatoes and shallots in a roasting tin. Add the rest of the olive oil, salt and pepper and the herbs. Place the leg of duck confit on top. Place in the oven and cook for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve as shown in the photograph.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor219"
    }
  }), _vm._v("6.3.8 Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor220"
    }
  }), _vm._v("6.3.8.1 Beef with Peanuts and Noodles")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("700 g Fillet steak")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Transparent noodle")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Grated lime peel")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic. Slice beef steak into thin strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, cook the noodles in salted boiling water for 1 minute. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a bowl, mix together the sauce with soy sauce, fish sauce, lime juice and corn flour. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a wok, heat both olive and sesame oil. When very hot, add the beef strips. When they are sealed, take them out of the pan and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In the same wok, cook the onions and garlic until they start to soften and turn brown, then add the beef strips and the sauce. Cook for a further 2 minutes, making sure the sauce does not stick. Then add the noodles, stirring well. Just cook till the noodles have reheated. To serve, sprinkle with the peanuts.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor221"
    }
  }), _vm._v("6.3.8.2 West African Pork with Beans in Peanut Sauce")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer323"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-096.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tinned red beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tinned sweet corn")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Chorizo")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("70 g Tin tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Chilli powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the pork into cubes and chorizo into slices. Cut the collard greens into 2.5 cm strips. Peel and chop onion and garlic. Peel potatoes and cut in half. Drain and rinse red beans and sweet corn.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut oil into a saucepan and heat. Cook the onions and garlic. When they start to soften, add pork pieces and cumin. Cook for 10 minutes. Add the chorizo and cook for a further 3 minutes. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the potatoes in salted water, boil for 10 minutes then add the red beans and sweet corn and cook for a further 10 minutes. Then drain the potatoes and beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a wok, add tomato purée, peanut butter and chilli powder, then mix well. Heat, stirring to get a smooth paste, then add potatoes, beans and collard greens. Adjust the seasoning and cook for 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor222"
    }
  }), _vm._v("6.3.8.3 Fish with Dried Peppers Sichuan Pepper and Peanuts")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer324"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-097.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the marinade and fish:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g White fish")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Egg white, slightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chinese chilli bean sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp White rice vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("C. For the stir-fry:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("400"), _c('span'), _vm._v("ml Peanut or vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Spring onions cut in 2.5"), _c('span'), _vm._v("cm lengths")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("19-15 Dried chilli peppers, cut in half and de-seeded")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("4 Cloves of garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("2 tsp Sichuan pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 g Roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("A. For the marinade and fish")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the fish in a large bowl. Add all the other ingredients and mix together with your hands until all the fish is covered. Allow to stand 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("B. For the sauce")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix all the ingredients together and set aside.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("C. For the stir-fry")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Divide the fish into three. Put half the oil in the wok and heat. Add one portion of fish and stir carefully until browned on both sides, then place on absorbent paper. Do the same with the other portions. Keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To prepare the wok for stir-fry, discard oil, add water and bring to a boil, scrape with a spatula and empty. Dry the surface with an absorbent paper towel.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the rest of the oil in the wok, heat until smoking. Add spring onions, dried chilli, garlic and Sichuan peppers until the garlic is golden: about 30 seconds. Add sauce and cook until sauce thickens, then add fish and toss lightly. Transfer fish to a plate, sprinkle with the roasted peanuts and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor223"
    }
  }), _vm._v("6.3.8.4 Spicy Lamb and Peanut Sauté")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-186",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-098.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a typical West African dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 g Lamb shoulder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 ml Beef stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Chunky peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Jalapeño peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Cooked rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the lamb into 2.5 cm cubes. Peel the onion and chop coarsely, dice the carrots and remove the seeds from the jalapeño peppers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat peanut oil in a heavy-bottomed pan, over medium heat. Add lamb and onions and cook until the lamb is browned. Stir occasionally and cook for 6 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season, then add tomatoes, stock and water and simmer until the lamb is tender: about 1 hour and 20 minutes. In a steamer, place the rice to re-heat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir in the peanut butter. Add carrots, jalapeño peppers and cayenne pepper and cook until carrots are tender. Add peas and cook until they are cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove jalapeño peppers, as they are very hot. Serve on hot rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor224"
    }
  }), _vm._v("6.3.8.5 Chard, Sweet Potato and Peanut Stew")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Sweet potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Crushed chilli flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("140 g Salted roasted peanuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Chard leaves")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion. Peel and cut sweet potatoes into large chunks. Wash the chard leaves and cut into two.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the vegetable oil in a pan with lid and heat on medium heat. Add onion and cook until browned. Stir in cumin seeds until fragrant: about 1 minute, Add sweet potatoes, chilli flakes, tomato and 750 ml water. Bring to a boil and simmer for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Blend the peanuts in a processor to obtain a lumpy peanut butter. Add to the stew and stir. Check seasoning, then simmer for 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add chard leaves. Stir and simmer for 10 minutes, until the chard is cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season to taste and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor225"
    }
  }), _vm._v("6.3.8.6 West African Chicken Peanut Stew")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-187",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-099.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tbsp Peanut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Chicken drumsticks")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped ginger")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.2 L Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Small sweet potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Collard greens")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onion, garlic and ginger. Peel and cut sweet potatoes. Roughly chop the collard greens.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peanut oil into pan on medium heat. Add onion, garlic and ginger. Stir until soft, then add chicken drumsticks and stir until browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Season with salt and peppers and cayenne. Add the stock, bring to a boil and simmer for 5 minutes. Add tomatoes, collard greens and peanut butter. Partly cover and simmer for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot with rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor226"
    }
  }), _vm._v("6.3.8.7 Mafe Senegalai with Two Meats")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 persons:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1.2 kg Stewing beef")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("600 g Lean pork")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Beef stock cube")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Peanut paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Dijon Mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onion. Cut the pork and beef into 3 cm cubes. Cut the tomatoes into 4.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook onion and meats in the oil until they are browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add tomatoes, beef cubes and Dijon mustard and cover with water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Simmer 3 hours on low heat; the meat should be tender. Make sure it does not dry out. If necessary, add some water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the peanut paste and cook a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Check seasoning and serve on plain rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor227"
    }
  }), _vm._v("6.4 Side Dishes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor228"
    }
  }), _vm._v("6.4.1 Peas and Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Peas and mangetout are often served just boiled or steamed. The important thing is not to overcook in order to have a crunchy and tasty dish, which will also avoid destroying the vitamins and other nutrients. The peas should be boiled the minimum time, and the cooking can be stopped by rinsing the peas in cold water. The exact cooking time is difficult to fix as it will depend on the variety and age of the peas. The best thing to do is to watch and check the cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor229"
    }
  }), _vm._v("6.4.1.1 Fresh Peas with Lean Gammon")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Thick lean slices of gammon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Fresh peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ l Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cut the gammon into 5 cm slices. Peel and slice the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put ½ the amount of butter in a frying pan. Cook the onions and gammon until they are brown: about 20 minutes. Set aside and keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, melt the butter, gradually adding the flour, then add the stock a little at a time, making a smooth sauce.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the peas to the sauce. Season to taste. Cook for about 10 minutes. Serve the pea sauce on top of the onions and gammon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mushy peas ")]), _vm._v("are very similar to "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Pease pudding")]), _vm._v(" (see "), _c('a', {
    attrs: {
      "href": "#/STRIBLINGLadyBeanPrelimsall_in_one_without_Hlinks_#_idTextAnchor055"
    }
  }, [_vm._v("page 135")]), _vm._v("), but the taste is very different.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor230"
    }
  }), _vm._v("6.4.1.2 Mushy Peas")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer327"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-100.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a traditional British dish generally served with fish and chips.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Marrow fat peas, dried peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 ml Full cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the peas in water for up to 12 hours, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the peas in salted boiling water until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the peas, butter and cream into a blender and process, leaving small pieces of peas. Season and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today, mushy peas are often made with fresh or frozen peas. However, the taste is not the same.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor231"
    }
  }), _vm._v("6.4.1.3 Pea Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-188",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/shutterstock_407630140.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 fritters:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 ml Pease pudding mixture (see recipe, "), _c('a', {
    attrs: {
      "href": "#/STRIBLINGLadyBeanPrelimsall_in_one_without_Hlinks_#_idTextAnchor055"
    }
  }, [_vm._v("page 135")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Bread crumbs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix onions, herbs salt and pepper with the pease pudding mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the breadcrumbs bit by bit; while mixing to obtain a stiff dough, the consistency will vary depending of the quantities of crumbs you use.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once that the consistency is correct, form into 4 cakes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the cakes and fry in a pan until well browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor232"
    }
  }), _vm._v("6.4.1.4 Green Peas with Capers and Braised Chicory")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer329"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-103.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Chicory")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Shelled peas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Capers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Clean the chicory and cook in boiling water for 8 minutes, then drain. Cut the chicory into two and put into a heavy pan with 1 tbsp oil. Cook slowly until browned, then keep warm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Boil the peas for about 5 minutes in lightly salted water, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the onion and garlic and cook in a pan with the remaining oil until softened.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the herbs, capers, peas and season to taste. Stir for 2 minutes and then mix well. Pour the sauce over the chicory before serving. Note that this side dish goes well with roast meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor233"
    }
  }), _vm._v("6.4.1.5 Mangetout with Sesame")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-189",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-104.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Blanch the mangetout in lightly salted water for 3 minutes and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel onion and garlic, de-seed pepper, chop onions and garlic and cut pepper into strips. Cook with oil in a heavy pan. Once the vegetables start to soften, add pepper to pan. Cook for 5 minutes and add the peas and sesame seeds. Stir for a further 2 minutes. Check seasoning and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor234"
    }
  }), _vm._v("6.4.1.6 Mangetout Sautéd with Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Fresh mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Big shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the shallots. Trim the mangetout and cut into 2 cm lengths.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a pan with the oil. Add shallots and cook over a moderate heat for about 30 minutes, until the shallots are browned.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the cut mangetout and coriander. Season and cook while stirring 5 minutes. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor235"
    }
  }), _vm._v("6.4.1.7 Mangetout with Carrots")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer331"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-105.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Mangetout")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the stem and string from the mangetout and cut into 3. Clean the carrots and cut into 1/2 cm discs.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the carrots in boiling salted water for about 5 minutes until they start getting tender. Add the mangetout and cook a minute more, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the chopped onion and garlic in a pan with the olive oil until soft. Season, then add the mangetout and carrots, stirring. Add the basil, stir for 1 minute and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor236"
    }
  }), _vm._v("6.4.2 Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor237"
    }
  }), _vm._v("6.4.2.1 Plain Boiled Fresh Broad Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Broad beans are often served simply boiled. The only problem is the skin. If young, the skin can be left on; however, if they are not young or fresh the skin must be removed as it is hard and does not taste good. Beans should not be overcooked and can be improved with a little butter or olive oil. They can also be mixed with chopped garlic, onion, parsley, coriander or mint to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor238"
    }
  }), _vm._v("6.4.2 Broad Beans and Tomatoes")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer332"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-106.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Pre-cooked broad beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("4 Tomatoes type Roma")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop garlic and onions and skin the tomatoes. Slice the tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in the pan and soften the onions. Add garlic, tomatoes, herbs and cumin. Simmer until they get a little dry. Add white wine and simmer for 5 minutes. Add the broad beans and season with salt and pepper. Cook to warm the beans. Add a little water if too dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor239"
    }
  }), _vm._v("6.4.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Over the last fifty years chickpeas have become popular in many parts of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The chickpea is a very versatile food and can be used in so many ways. Typically, a can of chickpeas, simply opened, drained and served with lemon juice and olive oils is a very acceptable snack. If using dried chickpeas, these would have to be soaked for 24 hours, then drained and cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor240"
    }
  }), _vm._v("6.4.3.1 Chickpeas with Tomato and Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-190",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-107.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a popular dish from North Africa and is often served with couscous or tagine dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people: ")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tomato confit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Harissa")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion and garlic. Chop the tomatoes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in the pan and heat. Add onions and garlic and cook until the onions are soft. Add tomatoes, harissa and the stock. Heat for a few minutes and add the chickpeas. Check the seasoning to taste and serve warm.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor241"
    }
  }), _vm._v("6.4.3.2 Chickpeas with Peppers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer334"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-108.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500"), _c('span'), _vm._v("g cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red Pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Piece Ginger, about 2 cm")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Walnut wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop onion. De-seed peppers and cut in large portions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel garlic and ginger and finely chop.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a flat pan and heat. Add onions, peppers, garlic and ginger, and cook until the onion is soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add herbs and spices. Stir and deglaze with the walnut wine. Simmer for a few minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the stock and chickpeas. Stir and check seasoning before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor242"
    }
  }), _vm._v("6.4.3.3 Chickpeas and Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Cooked chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spinach")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sumac")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Lemon for garnish")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the chickpeas.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and chop spinach, then put it in a saucepan. Add a bit of water, salt and butter. Cook for 1 minute and drain. Retain the liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add and cook the sliced onion and when soft add spices, salt and pepper. Add the chickpeas and spinach and the spinach water you retained. Cook for a further 2 minutes, stirring. Serve hot with wedges of lemon.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor243"
    }
  }), _vm._v("6.4.3.4 Galettes of Lentils and Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-191",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-109.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Orange lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Onions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Tin (420 g) chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Fresh ginger, grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Chopped parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Chopped coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 g Breadcrumb flour")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Cook lentils in a large casserole in salted boiling water, just till they are tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a frying pan. Cook the onions until they are golden, and then add the curry powder. Cook for a further minute.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the chickpeas. Mix chickpeas, half the lentils, ginger, egg and the onions together. Put in a blender and mix for about 20 seconds. Put the blended mixture into a large salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the blender mixture the rest of the lentils, plus the parsley and coriander. This gives the galettes a bit of texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Divide the mixture into 10 portions, and then make them into round flattened balls. Put in the fridge for about 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Using the breadcrumb flour, flour the galettes before cooking.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat some oil in a frying pan. When the oil is hot, cook the galettes for a few minutes on each side till they are golden. You can also cook these galettes on the barbecue or under a grill.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor244"
    }
  }), _vm._v("6.4.4 Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-192",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-110.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor245"
    }
  }), _vm._v("6.4.4.1 Boiled Fresh Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("One of the lost popular ways of serving fresh beans is boiled or steamed. The important thing is to boil them slightly in salted water and to be careful not to overcook them, so that the beans keep some texture, are still crunchy and keep most of the nutrient value.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _vm._v("6.4.4.2 Boiled Beans with Onions and Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned red kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Packet of fresh parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop the onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash, dry and chop the parsley finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add the onion and cook for 5 minutes. Add garlic and parsley, stirring. Add red kidney beans and serve as soon as it’s hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _vm._v("6.4.4.3 Beans and Beans")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer337"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-111.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This dish is a mixture of fresh beans and cooked dry beans and is always a great success. In fact, with the diversity of colours of both types of beans, it is always good to look at.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh flat green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned red kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 Shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Dry Sherry")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and prepare the green beans and cut into a suitable form.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the shallots and chop into large slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and drain the red beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the green beans in slightly salted boiling water until tender but crunchy, then drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil into a flat pan and heat. Cook the shallots until soft, then add garlic, herb and spices, stirring. Add the sherry and cook for 2 minutes. Add the beans and kidney beans. Cook for a further few minutes, making sure that the beans are hot. Serve as soon as it’s hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _vm._v("6.4.4.4 Green Beans with Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Fresh beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Tomato purée")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Parsley")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain beans and cut into 5 cm lengths.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the tomato purée into a pan. Add olive oil and crushed garlic, then season and bring to a boil. Add beans. Lower heat and simmer slowly for 20 minutes or until tender.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve with parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _vm._v("6.4.4.5 Green Bean Relish")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer338"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-112.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 3 average pots:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 kg Dwarf beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Large onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("750 ml Wine vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp French seeded mustard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Turmeric powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Masala, with or without chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("120 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the onions and cut into fine slices. Clean and de-seed peppers and cut into thin strips and then into 2 cm lengths. Top and tail the beans and cut into 3 cm lengths. Peel the garlic and chop finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the beans in salted water for about 3 minutes: they should remain crunchy. Drain, cool in cold water and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put half the vinegar in a saucepan with the onions and garlic. Bring to a boil and simmer for 5 minutes. Add the red peppers and simmer for another 10 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("While cooking the onions, make a sauce in a bowl with the French seeded mustard, turmeric, corn flour, masala and a small amount of vinegar, being careful to avoid lumps. Add the sauce to the saucepan and mix together well. Add sugar, salt and most of the vinegar. Allow to cook for about 2 minutes, then add the beans and cook a few minutes longer. The paste should be consistent; if too dry, add a little more vinegar. Allow to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the relish into glass pots and store in the fridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This relish goes well with smoked salmon and cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _vm._v("6.4.5 Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _vm._v("6.4.5.1 White Lima Beans Sauté with Coriander")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer339"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-113.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 3 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned white lima Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Bunch of fresh coriander")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the shallots and cut into rings, peel and chop garlic, chop coriander.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan and cook shallots until soft. Add salt, pepper, cumin and white wine. Cook for a few minutes to reduce wine and add beans with the coriander. Stir, then serve when hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _vm._v("6.4.5.2 Kidney Beans with Peppers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer340"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-114.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Red peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Green pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Chicken stock")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash and drain the beans. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("De-seed and clean the peppers and cut into fine strips.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. When hot, add onions and garlic. Cook until transparent, then add spices, chicken stock, salt and pepper. Bring to a boil and add the peppers. When the peppers have softened, add the beans. Check seasoning, add stock if necessary, and stir. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _vm._v("6.4.5.3 Beans and Sauerkraut")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer341"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-115.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Pre-cooked sauerkraut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Tinned white beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Salted pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large red onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Garam masala with chilli")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and cut the onions into half moon slices. Peel and chop the garlic. Slice the pork belly.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil in a pan. Add onion and cook until the onions start to soften. Add garlic, herbs and garam masala and stir. Add white wine and pork belly and cook until the wine has partly evaporated.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add beans and sauerkraut. Cook for a further 2 minutes, stirring. Add water if dry. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Transfer to an oven dish and cook for 20 minutes in an oven at 180°C or until slightly browned.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _vm._v("6.4.5.4 Dry Black Beans with Potatoes and Bok Choy")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 2 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Cooked sauerkraut")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Bok choy")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Ghee")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Paprika, mild")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the beans and soak overnight. Drain and rinse. Cook the beans very slowly in salted water for 30-40 minutes. Keep an eye on the cooking as it will depend on variety and age of the beans. The beans should be cooked but still keep their form.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel the potatoes. Cut Bok choy in 1 cm slices. Peel and chop the onions.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the potatoes in salted water. When they are cooked, remove, then lightly cook the Bok choy for 1 minute. Remove and drain, keeping the stock. Cut the potatoes into small squares.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the ghee in the oil. When hot, add the onions, cook until softening add white wine, herbs and spices. Cook for a further minute. Add beans, potatoes and Bok choy, plus a little of the retained stock to keep the dish fairly wet. Cook a minute while stirring. Transfer to an oven-proof dish and cook in an oven at 180°C for 20 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("NOTE: This dish can be made with other crucifers such as mustard, cabbage and Brussels sprouts.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _vm._v("6.4.5.5 Refried Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-193",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-116.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a classical Mexican dish which is popular in the southern states of the U.S. and to a lesser extent all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Dry black beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Lard/dripping")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Smoked paprika")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel and chop onions and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check beans. Put them in a large saucepan with the herbs, salt and pepper and onions and garlic and cover with about 5 cm water. Bring to a boil and cook covered for 80 minutes or until soft.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and keep the cooking liquid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Return the beans to the saucepan and mash the beans with a potatoes masher to obtain a smooth but slightly lumpy paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the lard/dripping in a heavy-bottomed pan and when hot add the bean paste and smoked paprika. Keep stirring until the paste is thick and hot. Add the liquid in small quantities if necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _vm._v("6.4.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-194",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-117.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _vm._v("6.4.6.1 French Lentils with Pork Belly")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("400 g Dry lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Pork belly")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Large onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Oregano")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the lentils and check that there are no stones. Cut the pork belly into small squares and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a pan and heat add pork and onions and cook until the onion is soft, and the pork a little bit crispy.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add garlic, salt and pepper, oregano and the white wine once boiling add the lentils and cover with water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Reduce the heat and simmer slowly, the lentils must be cooked very slowly in a minimum of water, so it is necessary to add water in order to avoid the lentil breaking up.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("The cooking time will vary on the lentils keep checking them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _vm._v("6.4.6.2 Black Beluga Lentils with Rice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Long grain white rice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Beluga lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large shallots")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Cumin powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, add water and salt and bring to a boil. Add the rice and cook for 9 minutes. Drain and set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Peel and chop the shallots. Clean the red pepper and cut into small slices.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the oil in a heavy pan and heat. Once hot, add shallots and pepper and fry until the shallots soften. Add herbs and cumin. Stir, then add the white wine. Once hot, add lentils, cover with water and reduce the heat to a low simmer.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Stir carefully and add water as necessary; the cooking time will be about 10-15 minutes. Follow closely, adding water as necessary. Just before the end, add the rice. Check seasoning with salt and pepper and allow the last water to be absorbed. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _vm._v("6.4.6.3 Brown Lentils with Swiss Chard and Za’atar (Spices)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Fresh Swiss chard")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Medium onions")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Clove of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Za’atar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Za’atar is a mixture of marjoram, sumac and sesame seeds. It is very popular in the Middle East and North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Wash the Swiss chard and remove the green leaves. Cut the white pieces of Swiss chard into large pieces and cook in salted water until very slightly cooked and still firm. Drain and set aside. Keep the water, then use this to cook the leaves. Cook for 5 minutes. Drain and add to the white chard pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wash and check the lentils. Peel and chop onion and garlic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the oil and cook the onions until soft. Add the garlic and za’atar with a little water and bring to a boil. Add the lentils and cover with water. Return to the boil, then reduce the heat and simmer for 10-15 minutes until cooked, adding water as necessary.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the lentils are cooked, add the white pieces and leaves of chard and season with salt and pepper. Reheat before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _vm._v("6.4.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("The name sweet lupin is given to different varieties from the normal European lupin that is bitter and requires long preparation. The sweet lupin defines the newer varieties of lupin that have been developed and produce a lupin that is not bitter. The use of lupins, beans, flakes or flour is very interesting for vegetarian, low carb and gluten-free cooking, as the lupin has a very high protein and very low carbohydrate content. Lupin flour can be used in part for a lot of pasta dishes except for fresh pasta of the tagliatelle or spaghetti type, the reason being the lack of texture of the lupin flour when cooked. For this reason, it can only be used at 10-15% in thin pasta and therefore does not represent a significant reduction in carbs.")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-195",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-118.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _vm._v("6.4.7.1 Low Carb Spätzle")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/ 2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("14 cl Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the flours and salt together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Beat the eggs and gradually add to the flours to give a smooth paste. Then gradually add the water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put a large saucepan of salted boiling water. When the water boils, add the paste slowly with a spätzle press to the boiling water. When the spätzle rise to the surface, allow them to cook for about 3 minutes, then remove with a perforated spoon and allow to drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the spätzle are cold, they can be fried in the sunflower oil until browned and served. If not used immediately they should be refrigerated.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("You can replace the wheat flour with chickpea flour. It also gives a nice taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.4.7.2 Low Carb Gnocchi with Herbs")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-196",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-119.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("600 g Floury potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Extra flour for working")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped fresh tarragon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Chopped chives")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Juice of 2 lemons")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Parmesan")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Peel the potatoes and cook until soft in boiling salted water. Drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mash the potatoes with a potato masher. Mix with salt, butter and the beaten egg, and allow to cool. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the lupin and wheat flour together to make a pasta. Add the mashed potatoes and mix them well together. Put the paste on a wooden work surface and knead to produce homogeneous dough.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Flour the board and roll the dough into a sausage of about 2 cm large.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the sheets on a gnocchi board, if you have one; otherwise, form each piece of gnocchi with the back of a fork into ball shapes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the gnocchi in salted boiling water for 4 minutes and drain.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the gnocchi are cold, heat the butter in a pan and fry the gnocchi until browned. Add garlic, pine nuts and herbs and cook on a lower heat for 2 minutes. Add the lemon juice and serve with a sprinkle of Parmesan.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.4.7.3 Gluten-Free Gnocchi with Pesto")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-197",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-120.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This gnocchi recipe is the same at the one above: steps 1 to 5. But we have replaced the wheat flour with chickpea flour.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the sauce:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Medium onion")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Cloves of garlic")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Chopped fresh Basil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Chopped Pine nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Grated Pecorino")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 cl White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt and pepper")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Chop the onions and garlic finely.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the olive oil and add the chopped onion. When the onion is soft and a bit brown, add the cold gnocchi and garlic and cook until the gnocchi are slightly coloured. Add white wine and cook to reduce the wine.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the basil, pine nuts and Pecorino. Check seasoning, adding pepper and salt to taste. Serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-1"
  }, [_vm._v("6.5 Sweets, Desserts and Drinks")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2-first"
  }, [_vm._v("6.5.3 Chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.1 Chickpea and Pistachio Biscuits")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer347"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-121.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pistachio nuts")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix chickpea flour, sugar, butter and cardamom pods together. Allow to stand 3-4 hours in the fridge.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Roll the paste into a thickness of 1 cm and cut to shape.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Decorate with pistachio nuts and cook in the oven at a medium temperature, 140 C° for 7 minutes. Allow to cool in the oven.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.2 Fried Churros")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer348"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-122.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("A type of provincial street food served at fairs.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 g Tinned chickpeas")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("100 ml Orange flower water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("250 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("7"), _c('span'), _vm._v("g Baker’s yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Remove the skin from the chickpeas and mash into a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the yeast with a little warm water and salt. Set aside till it starts to ferment.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Separate the egg yolks. Mix the egg yolks, milk, orange flower water, sugar and yeast mixture together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mount (whisk) the egg whites. I always add a bit of salt this helps the egg to mount. Then gradually add this to the egg yolk mixture. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Let the mixture stand for about 1 hour. The mixture should remain fluid.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a deep fat fryer. I use a cake funnel to make this: it’s the easiest way. When the fat is hot, squeeze the cake funnel into the fat. This might take a few goes in the hot fat. Once well browned, remove from the hot oil, place on absorbent paper, sprinkle with sugar and serve hot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.3 Gluten-Free Canistrelli with Chestnut and Chickpea Flour Buns")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-197",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-123.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: for about 10 pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Chestnut flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("20 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml White wine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C. Mix together the chestnut and chickpea flour, sugar, and bicarbonate of soda.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add the white wine and oil to the mixture, making a dough-like mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the dough is a good texture, make into square shapes and place on a greaseproof baking tray. Let stand for 15 minutes covered.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for 10 minutes. Then turn the oven down to 150°C and cook for a further 10 minutes. Check to see if they are cooked. If not cooked, cook a bit longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.3.4 Canistrelli with Chickpea Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-198",
    attrs: {
      "alt": "C:\\Users\\Mr STRIBLING\\Downloads\\93639129_s.jpg",
      "src": "image/Stribling-6-124.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Canistrelli is a traditional Corsican cake made from flour and with a taste of anise. This variation is interesting as it is low in carb and has no gluten.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for about 25 cakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Chickpea flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ pkt Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 cl Pastis")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 cl Dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix all the dry ingredients together. Add olive oil, white wine and pastis. Knead the dough to obtain a homogeneous paste. Cut up and make about 25 balls, flatten the balls and place on a baking tray.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook the cakes at 180°C for about 20 minutes. Allow to cool before serving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Pastis is a French aperitif with a taste of aniseed.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.5 Dry Beans")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.1 Adzuki Bean Sweets")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer351"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-125.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 500 g of sweets:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Adzuki dry beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/2 tsp Nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt, 1 pinch")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans overnight (8-12 hours) and drain and rinse.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the adzuki beans in a large pan and cover with water. Put on the heat and bring to a boil. Stop the heat and cover. Allow to stand for 5 minutes, then drain. Put the adzuki beans back into the saucepan, cover with water and bring to a boil. Simmer for 1 hour. Make sure it does not dry out, if need be adding a bit more water. The beans should crush easily between the fingers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Once the adzuki beans are cooked, add the sugar, nutmeg and salt, stirring all the time. The paste is cooked when you can see the bottom of the saucepan: a little bit like when you make jam, but producing a thicker paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("On a baking tray, place a sheet of greaseproof paper. Sprinkle this with icing sugar. Then pour the paste onto this. Flatten to the required thickness and cut into squares. Place in the fridge. This can be kept for up to a week.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.2 Korean Sweet Bean Paste Bread")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer352"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-126.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 16 small breads:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("450 g Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("350 g Sweet bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Warm water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 ml Warm milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Instant dried yeast")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("11/2 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Butter for coating")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Black sesame seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the flour, salt, sugar and yeast in a large salad bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add milk and water gradually to the flour mixture. Mix well together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour in the butter and mix. Check that the dough is the correct consistency: not too sticky. Adjust with flour or water. Knead for about 20 minutes until smooth and elastic.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover and set aside in a warm place for 30 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heated oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut the bean paste into 16 pieces and roll each into a ball. Set aside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Uncover the dough and work slightly to remove air. Cut the dough into 16 portions and roll each into a ball.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take the dough balls and flatten them. Place the bean paste ball in the centre, fold the dough around the paste to cover and make a round flattened form. Cut each piece with a sharp knife in part of the upper surface. Do the same for all the others. Coat the bread buns with the rest of the butter and sprinkle with the sesame seeds. Set aside on a baking dish for 20 minutes in a warm place.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook for about 15 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.3 Japanese Red Bean Paste Pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 6 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("4 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("140 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Honey")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vegetable oil for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("400 g Sweet bean paste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix eggs, sugar and honey in a bowl and whisk till you have a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix the flour and baking powder into the batter. When it’s mixed well, place in the fridge for at least 15 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("If the batter seems too thick, add a bit of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a non-stick pan. When it’s very hot, take a small ladle of batter and pour this into the hot oil to make the pancakes. Cook on both sides until lightly golden on both sides. Make two for each person. Spread the sweet bean paste in the middle and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.4 Making Soy Milk")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer353"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-127.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 ml Soybeans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Sugar if necessary")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Soak the beans in a container in of water overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain and wash beans.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove as many of the skins as possible.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add 1 l of water to the beans, put in a food processor and blend until smooth.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Filter the blend through a cheesecloth and squeeze to finish.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cool and refrigerate")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be kept up to 4 days in the fridge. If you require it to be sweet, add sugar to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.5. Chocolate Cake with Soy Milk")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer354"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-128.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 8 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 ml Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("160 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 ml Chocolate powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("65 ml Vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp White vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 ml Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven to 160°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, add flour, sugar, salt, chocolate powder and baking powder. Mix all the ingredients together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, add soy milk, vegetable oil and vanilla extract. Whisk all together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add all the ingredients together and mix with a wooden spoon. Don’t over-mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tin.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bake for 40 minutes. Check to see if it’s cooked by inserting a knife in the middle of the cake: if there is no moisture on the knife, it’s ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Allow to cool and then dust with icing sugar.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.6 Soy Yoghurt")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer355"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-129.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1 l Soy milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Agar-agar powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("125 g Soy yoghurt activator")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat the oven at 43°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the soy milk into a saucepan. Add the agar-agar powder and heat slowly, making sure it does not boil.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a bowl. Let the mixture cool a bit. When it’s nearly cold, add the soy yoghurt activator. Stir well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into small yoghurt-size pots. Turn the oven off, let it cool a bit, then place the pots in the oven without lids on. This can be done in an airing cupboard as well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave in the oven for at least 8 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover the jars and store in the fridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.5.7 Kudzu Japanese Starch Cake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer356"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-130.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Kudzu powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-1-col"
  }, [_vm._v("50 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put all the ingredients into a saucepan and mix.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the saucepan on a medium low heat, stirring constantly to avoid lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the paste turns transparent and starts to come away from the pan, it is ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Wet a square mould, pour in the paste and smooth with a wet spatula. Allow to cool")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cold, de-mould and cut into squares.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("These square cakes are sweet and rather tasteless and are generally served with a sweet sauce such a black sugar syrup alone or mixed with ground roasted soybean or dried fruits.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.6 Lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.6.1 Lentil and Chocolate Brownies")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Makes about 25 Brownies")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Cooked black lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Unsweetened apple sauce")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat over at 180°C")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put into a food processor, lentils, chocolate chips, apple sauce, eggs and vanilla. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add cocoa powder and salt. Blend well. When the texture is correct add the walnuts to the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tray. Cook for about 30-35 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Leave to cool before cutting into squares.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.6.2 Lentil Granola Bars")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer357"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-131.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Tinned red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Oat meal")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Barley flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1/4 tsp Cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Mixed dried fruit")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Sunflower seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Pumpkin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 ml Coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 ml Golden syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large bowl, mix together oats, brown sugar, barley flour, salt and cinnamon. After mix in the dried fruit and seeds.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, whisk together the oil, peanut butter, golden syrup, egg and vanilla extract.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the two sets of ingredients together, then add the red lentils. Place the mix in a greased baking tray.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook in oven at 180°C for about 25-30 minutes, till golden on the outside.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When it’s cooked, let the cake cool, and then cut into bars.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.7 Lupins")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.1 Low Carb Pancake with Lupin and Plain Flour")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This is a neutral pancake that can be used as a sweet or savoury dish.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 5 pancakes:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Sweet lupin flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Corn flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("700 ml Semi creamed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Olive oil for cooking")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix together both flours with sugar and salt. Beat the eggs together then gradually add this to the mixture. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Slowly add the milk while stirring to obtain a homogeneous cream without lumps.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set aside in a cool place for about 10 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat a pan. Add a little oil and when hot, pour one ladle of the pancake mixture. Cook until the pancake starts to colour and turn. Complete the cooking and remove the pancake. Add a little oil and repeat the operation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.2 Lupin Spice Biscuits")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer358"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-132.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("180 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Mixed spices")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("110 g Melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("90 g Malt syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Egg")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the following ingredients in a food mixer: lupin flakes, plain flour, sugar, baking powder and mixed spices. Mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually add to the mixture the butter, the malt syrup and then the egg. Mix until all the ingredients are well mixed together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Knead the mixture. Wrap in a plastic bag and put it into the fridge for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take the dough out of the fridge and roll out on a floured board. Cut into shapes of your choice, then pierce with a folk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the cut-out shapes on a greaseproof baking tray. Bake in the oven for about 4 minutes, then turn the biscuits over, so they cook on both sides. Cook for another 4 minutes. They cook very quickly, so keep an eye on them.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.7.3 Gluten-Free Lupin Pancakes")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-199",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-133.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("50 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Ricotta")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Lemon zest")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 tsp Semi skimmed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Baking powder (gluten-free)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("10 g Butter for frying")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put all the ingredients except the butter into a blender. Blend well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the batter mixture in the fridge and leave overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat oil and butter. When this mixture is warm, cook the pancakes in a non-stick pan. This batter takes longer to cook than normal pancakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.5.7.4 Lupin Carrot Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Lupin flakes")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Almond powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Carrots, peeled and grated")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 ml Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Icing:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Spreadable cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("75 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Vanilla essence")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pre-heat oven at 170°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the lupin flakes, almond powder, bicarbonate of soda and cinnamon into a large bowl.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, put in brown sugar, oil, maple syrup, eggs and vanilla essence. Mix with a whisk till you have a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Mix all the ingredients together, then add the grated carrots, until you get a nice texture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Grease a baking tray. Pour the mixture into the baking tray. Cook for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("To make the icing, put all the ingredients for the icing together in a bowl and mix together well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When the cake is cold, put the icing on top.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.9 Carob")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.9.1 Carob Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("6 Eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("80 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 ml Milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("100 g Coconut sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Carob powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("60 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Pkt Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 180°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, mix together the flour, baking powder, salt and carob powder.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In another bowl, beat the eggs together, then add the coconut sugar. Then gradually add this to the flour mixture to produce a smooth paste.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the butter in a small saucepan. Heat on medium heat just till the butter is all melted. Add this to the mixture, then add the milk.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Grease a square cake tin. Then pour the mixture into this. Bake for 20 minutes. Test with a knife to see if it’s cooked through.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.9.2 Carob Sauce")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer360"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-134.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("2 tsp Carob powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tbsp Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, melt the butter on a very low heat, so that it does not burn.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the rest of the ingredients into the saucepan, stirring gradually to avoiding any lumps. Heat on low heat, stirring all the time till you get a sauce texture.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("This can be used on ice cream or pancakes, or even for savoury dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.10 Tamarind")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.10.1 Tamarind Sweet Balls")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-200",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-135.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200"), _c('span'), _vm._v("g Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1"), _c('span'), _vm._v("kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Mix the tamarind paste with half the sugar into equal shaped balls.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Use the rest of the sugar to roll the balls to coat.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put them in the fridge to cool. Serve cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Tamarind balls can be flavoured to taste using ginger, cinnamon, cardamom or chilli powder, depending on your taste.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head-break"
  }, [_vm._v("6.5.10.2 Tamarind Date Cake")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer362"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-136.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients for 4 people:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("275 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Dates, stoned and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Tamarind paste")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Bicarbonate of soda")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Icing:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("6-8 Ground cardamom pods")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Put the chopped dates and tamarind paste in a pan and cover with water. Bring to a boil. Cook for about 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take off the heat, add the butter. Let the butter melt while the mixture cools.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pre-heat oven at 180°C. Add brown sugar to the mixture. In a bowl, beat the eggs together, then gradually add eggs, flour and bicarbonate of soda to the mixture.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour the mixture into a greaseproof baking tin. Cook for about 60-70 minutes. Test to see if it’s cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Make the icing: mix all the ingredients for the icing together, making a paste. When the cake is cooked, pour the icing over.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.11 Mesquite")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.1 Mesquite Bean Jelly")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer363"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-137.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("7 kg Mesquite beans")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("5 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 Packet of gelatine")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1.75 kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Break the mesquite beans and put in a large pan of water. Soak overnight.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain the beans, then put them in a large pan with fresh water. Cook for 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Drain, saving the juice. Boil 1½ l of the juice in a pan, add the lemon juice and boil for 5 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Continue to boil, slowly adding sugar and then gelatine. Continue to stir. Cook for another 5 minutes. ")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Strain through cheesecloth and pour into sterilised jars and seal. Then turn the jars upside down to cool, just like you do for jam.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.2 Mesquite Syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("500 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("500 g Mesquite pods (washed)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place water and mesquite pods in a large covered pot and cook at a very low heat for 12 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("When cooked, keep the liquid. Then heat the liquid and boil, reducing to a thin, syrupy consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bottle. When cool, you can serve it on pancakes or on toast. You can keep the syrup for a few days.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.11.3 Mesquite Tortillas")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-201",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-138.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("1½ Vol of plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Vol of mesquite flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("3 tbsp Olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ Vol of water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix together both flours and salt with a wooden spoon.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Gradually mix in the olive oil and water to arrive at a dough consistency. Knead for 2 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Divide the mixture into 12 balls, all about the same size. Then flatten them in discs of about 20 cm, or in a tortillas press.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook them on a griddle for about 1 minute on each side, and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.13 Liquorice")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-202",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-140.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.1 Liquorice Root Extract")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer366"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-139.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("200 g Liquorice root")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 bottle of vodka or any strong alcohol of your taste")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Place the liquorice root in a half-full jar.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour over the vodka, leaving a gap at the top of the jar of 5 cm.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store in a dark place. Shake every day.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In 4 weeks’ time, it should be ready.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Serve as a liqueur, or you can use it to marinate meat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.2 Black Liquorice Caramels")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Makes about 60 pieces:")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("250 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tin sweetened condensed milk")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("120 ml Light syrup")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 tsp Liquorice extract")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tsp Black food colouring")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a large heavy saucepan over low to medium heat, melt the butter. Add sweetened condensed milk, sugar, light syrup and salt. Stir continually.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Use a thermometer to cook till the heat reaches about 110°C. At this stage, it should have a chewy texture,")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Remove from the heat. Add liquorice extract and black food colouring. Line a baking tray with greaseproof paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Pour mixture into the baking tray and leave to cool. When it’s cold, place in the fridge for about 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cut into sweet sizes. Wrap in wax paper. It’s very good!")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.13.3 Liquorice Cake")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("We are using coconut sugar in this recipe. Coconut sugar is made in the same way as maple syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("150 g Twisted liquorice pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Butter")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("150 g Single cream")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("300 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("½ tsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("For the topping:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("200 g Cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Grated zest and juice of ½ lemon")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("40 g Icing sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Preheat oven at 200°C.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Chop the liquorice into small pieces. Keep a few back to decorate the cake.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a saucepan, add the butter, cream and liquorice. Heat on medium heat and bring to a boil. Reduce the heat and simmer; you must make sure that it does not stick. When all the liquorice has dissolved, take off the heat and set aside to cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("In a large bowl, beat the eggs and sugar together. Then gradually add the flour and salt, making sure you have a nice smooth mixture. Then add the cooled liquorice mixture, stirring well.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Take a round cake tin and grease. Pour the mixture into this. Place in the oven and cook for 15 minutes. Test this with a knife to see if it’s cooked. When cooked, let the cake cool.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("For the topping: mix the cream cheese lemon juice, zest and icing sugar together in a bowl, until you have a smooth paste. Spread this on the top of the cake and then decorate with the rest of the liquorice.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.14  Rooibos")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.14.1 Rooibos beverage")]), _vm._v(" "), _c('p', {
    staticClass: "Graphic"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-203",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-141.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Rooibos is a bush that grows around the Table Mountain in Cape Town in South Africa and has leaves that turn red at maturity for this reason the red bush carries the Afrikaans name of Rooibos. The bush produces red leaves that are like tea. It is used either dried or fresh for beverages and infused like tea; in fact, it’s sometimes called red tea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("In South Africa, the infusion is made with hot milk in a similar way to the infusion of tea in India, probably due to the early presence of Indian traders all along the east coast of Africa. The infusion of rooibos has some therapeutic actions and has the advantage of not containing stimulants as is the case of coffee and tea.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-main"
  }, [_vm._v("Today rooibos is consumed worldwide and is generally infused in water.")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.15 False Acacia")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.15.1 Acacia Flower Fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients: For 5 fritters")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("5 Stems of Acacia flowers")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("250 g Plain flour")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 g Caster sugar (for sprinkling)")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Cold beer")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("50 ml Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("¼ tsp Baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("1 tbsp Sunflower oil")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a bowl, mix the flour, baking powder and salt together.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add to the flour and salt very slowly to the water, stirring with a whisk to avoid any lumps. When this is smooth, gradually add the beer, stirring all the time till you arrive at a smooth consistency.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Place the batter mixture into the fridge for at least 1 hour.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Heat the sunflower oil in a deep fat fryer. When the oil is hot, dip the flower stems in the batter, one at a time, very carefully so as not to damage the flowers. The stem cooks very quickly. Cook till golden, then remove and place on absorbent paper. Continue until they are all cooked.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Sprinkle with the icing sugar and serve.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-level-2"
  }, [_vm._v("6.5.16 Mimosa")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.16.1 Mimosa and Lemon Jelly")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Mimosa tassels")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 l Water")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 kg Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("30 g Pectin")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Lemons (juice and zest)")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("In a saucepan, boil 2 l of water. When it’s boiled, turn it off. Then steep the mimosa tassels for 20 minutes.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Filter the juice through a cheesecloth, keeping the liquid. Put the liquid back into the saucepan, then add the pectin and sugar, stirring all the time.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Bring to a boil and add the juice of the lemons.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cook, stirring constantly, for about 25 minutes, until it’s thick.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Add the lemon zest. Bottle in sterilized jars. Cool pots upside down.")])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-head"
  }, [_vm._v("6.5.16.2 Crystallised Mimosa Flowers")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Inline-graphic-R",
    attrs: {
      "id": "_idContainer368"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/Stribling-6-142.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-first"
  }, [_vm._v("100 g Mimosa flower heads")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("2 Egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "Ingredients-main"
  }, [_vm._v("Castor sugar as needed")]), _vm._v(" "), _c('p', {
    staticClass: "Recipe-subhead"
  }, [_vm._v("Method:")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "Method-first",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Whisk the egg whites, adding a pinch of salt and slowly adding a few drops of water.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the mixture into a large, shallow bowl. Put the mimosa flowers into the mixture, trying not to break them.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Put the sugar in another bowl, then dip each mimosa head into the sugar. This takes a bit of time: the best way is to use tweezers.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Cover a large plate with greaseproof paper (you might need several plates).")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Set flowers aside to let completely dry: up to 24–36 hours.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store the flowers in layers, separating with grease paper.")]), _vm._v(" "), _c('li', {
    staticClass: "Method"
  }, [_vm._v("Store in an airtight container.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer370"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d73475e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/STRIBLING-Lady-Bean-Prelims-all_in_one_-without_H--links_.vue
// module id = 57
// module chunks = 0